export default [
    {
        "id": "110000",
        "label": "北京市",
        "children": [
            {
                "id": "110100",
                "label": "北京市",
                "children": [
                    {
                        "id": "110101",
                        "label": "东城区"
                    },
                    {
                        "id": "110102",
                        "label": "西城区"
                    },
                    {
                        "id": "110105",
                        "label": "朝阳区"
                    },
                    {
                        "id": "110106",
                        "label": "丰台区"
                    },
                    {
                        "id": "110107",
                        "label": "石景山区"
                    },
                    {
                        "id": "110108",
                        "label": "海淀区"
                    },
                    {
                        "id": "110109",
                        "label": "门头沟区"
                    },
                    {
                        "id": "110111",
                        "label": "房山区"
                    },
                    {
                        "id": "110112",
                        "label": "通州区"
                    },
                    {
                        "id": "110113",
                        "label": "顺义区"
                    },
                    {
                        "id": "110114",
                        "label": "昌平区"
                    },
                    {
                        "id": "110115",
                        "label": "大兴区"
                    },
                    {
                        "id": "110116",
                        "label": "怀柔区"
                    },
                    {
                        "id": "110117",
                        "label": "平谷区"
                    }
                ]
            }
        ]
    },
    {
        "id": "120000",
        "label": "天津市",
        "children": [
            {
                "id": "120100",
                "label": "天津市",
                "children": [
                    {
                        "id": "120101",
                        "label": "和平区"
                    },
                    {
                        "id": "120102",
                        "label": "河东区"
                    },
                    {
                        "id": "120103",
                        "label": "河西区"
                    },
                    {
                        "id": "120104",
                        "label": "南开区"
                    },
                    {
                        "id": "120105",
                        "label": "河北区"
                    },
                    {
                        "id": "120106",
                        "label": "红桥区"
                    },
                    {
                        "id": "120110",
                        "label": "东丽区"
                    },
                    {
                        "id": "120111",
                        "label": "西青区"
                    },
                    {
                        "id": "120112",
                        "label": "津南区"
                    },
                    {
                        "id": "120113",
                        "label": "北辰区"
                    },
                    {
                        "id": "120114",
                        "label": "武清区"
                    },
                    {
                        "id": "120115",
                        "label": "宝坻区"
                    },
                    {
                        "id": "120116",
                        "label": "滨海新区"
                    }
                ]
            }
        ]
    },
    {
        "id": "130000",
        "label": "河北省",
        "children": [
            {
                "id": "130100",
                "label": "石家庄市",
                "children": [
                    {
                        "id": "130102",
                        "label": "长安区"
                    },
                    {
                        "id": "130103",
                        "label": "桥东区"
                    },
                    {
                        "id": "130104",
                        "label": "桥西区"
                    },
                    {
                        "id": "130105",
                        "label": "新华区"
                    },
                    {
                        "id": "130107",
                        "label": "井陉矿区"
                    },
                    {
                        "id": "130108",
                        "label": "裕华区"
                    },
                    {
                        "id": "130121",
                        "label": "井陉县"
                    },
                    {
                        "id": "130123",
                        "label": "正定县"
                    },
                    {
                        "id": "130124",
                        "label": "栾城县"
                    },
                    {
                        "id": "130125",
                        "label": "行唐县"
                    },
                    {
                        "id": "130126",
                        "label": "灵寿县"
                    },
                    {
                        "id": "130127",
                        "label": "高邑县"
                    },
                    {
                        "id": "130128",
                        "label": "深泽县"
                    },
                    {
                        "id": "130129",
                        "label": "赞皇县"
                    },
                    {
                        "id": "130130",
                        "label": "无极县"
                    },
                    {
                        "id": "130131",
                        "label": "平山县"
                    },
                    {
                        "id": "130132",
                        "label": "元氏县"
                    },
                    {
                        "id": "130133",
                        "label": "赵县"
                    },
                    {
                        "id": "130181",
                        "label": "辛集市"
                    },
                    {
                        "id": "130182",
                        "label": "藁城市"
                    },
                    {
                        "id": "130183",
                        "label": "晋州市"
                    },
                    {
                        "id": "130184",
                        "label": "新乐市"
                    },
                    {
                        "id": "130185",
                        "label": "鹿泉市"
                    }
                ]
            },
            {
                "id": "130200",
                "label": "唐山市",
                "children": [
                    {
                        "id": "130202",
                        "label": "路南区"
                    },
                    {
                        "id": "130203",
                        "label": "路北区"
                    },
                    {
                        "id": "130204",
                        "label": "古冶区"
                    },
                    {
                        "id": "130205",
                        "label": "开平区"
                    },
                    {
                        "id": "130207",
                        "label": "丰南区"
                    },
                    {
                        "id": "130208",
                        "label": "丰润区"
                    },
                    {
                        "id": "130209",
                        "label": "曹妃甸区"
                    },
                    {
                        "id": "130223",
                        "label": "滦县"
                    },
                    {
                        "id": "130224",
                        "label": "滦南县"
                    },
                    {
                        "id": "130225",
                        "label": "乐亭县"
                    },
                    {
                        "id": "130227",
                        "label": "迁西县"
                    },
                    {
                        "id": "130229",
                        "label": "玉田县"
                    },
                    {
                        "id": "130281",
                        "label": "遵化市"
                    },
                    {
                        "id": "130283",
                        "label": "迁安市"
                    }
                ]
            },
            {
                "id": "130300",
                "label": "秦皇岛市",
                "children": [
                    {
                        "id": "130302",
                        "label": "海港区"
                    },
                    {
                        "id": "130303",
                        "label": "山海关区"
                    },
                    {
                        "id": "130304",
                        "label": "北戴河区"
                    },
                    {
                        "id": "130321",
                        "label": "青龙满族自治县"
                    },
                    {
                        "id": "130322",
                        "label": "昌黎县"
                    },
                    {
                        "id": "130323",
                        "label": "抚宁县"
                    },
                    {
                        "id": "130324",
                        "label": "卢龙县"
                    }
                ]
            },
            {
                "id": "130400",
                "label": "邯郸市",
                "children": [
                    {
                        "id": "130402",
                        "label": "邯山区"
                    },
                    {
                        "id": "130403",
                        "label": "丛台区"
                    },
                    {
                        "id": "130404",
                        "label": "复兴区"
                    },
                    {
                        "id": "130406",
                        "label": "峰峰矿区"
                    },
                    {
                        "id": "130421",
                        "label": "邯郸县"
                    },
                    {
                        "id": "130423",
                        "label": "临漳县"
                    },
                    {
                        "id": "130424",
                        "label": "成安县"
                    },
                    {
                        "id": "130425",
                        "label": "大名县"
                    },
                    {
                        "id": "130426",
                        "label": "涉县"
                    },
                    {
                        "id": "130427",
                        "label": "磁县"
                    },
                    {
                        "id": "130428",
                        "label": "肥乡县"
                    },
                    {
                        "id": "130429",
                        "label": "永年县"
                    },
                    {
                        "id": "130430",
                        "label": "邱县"
                    },
                    {
                        "id": "130431",
                        "label": "鸡泽县"
                    },
                    {
                        "id": "130432",
                        "label": "广平县"
                    },
                    {
                        "id": "130433",
                        "label": "馆陶县"
                    },
                    {
                        "id": "130434",
                        "label": "魏县"
                    },
                    {
                        "id": "130435",
                        "label": "曲周县"
                    },
                    {
                        "id": "130481",
                        "label": "武安市"
                    }
                ]
            },
            {
                "id": "130500",
                "label": "邢台市",
                "children": [
                    {
                        "id": "130502",
                        "label": "桥东区"
                    },
                    {
                        "id": "130503",
                        "label": "桥西区"
                    },
                    {
                        "id": "130521",
                        "label": "邢台县"
                    },
                    {
                        "id": "130522",
                        "label": "临城县"
                    },
                    {
                        "id": "130523",
                        "label": "内丘县"
                    },
                    {
                        "id": "130524",
                        "label": "柏乡县"
                    },
                    {
                        "id": "130525",
                        "label": "隆尧县"
                    },
                    {
                        "id": "130526",
                        "label": "任县"
                    },
                    {
                        "id": "130527",
                        "label": "南和县"
                    },
                    {
                        "id": "130528",
                        "label": "宁晋县"
                    },
                    {
                        "id": "130529",
                        "label": "巨鹿县"
                    },
                    {
                        "id": "130530",
                        "label": "新河县"
                    },
                    {
                        "id": "130531",
                        "label": "广宗县"
                    },
                    {
                        "id": "130532",
                        "label": "平乡县"
                    },
                    {
                        "id": "130533",
                        "label": "威县"
                    },
                    {
                        "id": "130534",
                        "label": "清河县"
                    },
                    {
                        "id": "130535",
                        "label": "临西县"
                    },
                    {
                        "id": "130581",
                        "label": "南宫市"
                    },
                    {
                        "id": "130582",
                        "label": "沙河市"
                    }
                ]
            },
            {
                "id": "130600",
                "label": "保定市",
                "children": [
                    {
                        "id": "130602",
                        "label": "新市区"
                    },
                    {
                        "id": "130603",
                        "label": "北市区"
                    },
                    {
                        "id": "130604",
                        "label": "南市区"
                    },
                    {
                        "id": "130621",
                        "label": "满城县"
                    },
                    {
                        "id": "130622",
                        "label": "清苑县"
                    },
                    {
                        "id": "130623",
                        "label": "涞水县"
                    },
                    {
                        "id": "130624",
                        "label": "阜平县"
                    },
                    {
                        "id": "130625",
                        "label": "徐水县"
                    },
                    {
                        "id": "130626",
                        "label": "定兴县"
                    },
                    {
                        "id": "130627",
                        "label": "唐县"
                    },
                    {
                        "id": "130628",
                        "label": "高阳县"
                    },
                    {
                        "id": "130629",
                        "label": "容城县"
                    },
                    {
                        "id": "130630",
                        "label": "涞源县"
                    },
                    {
                        "id": "130631",
                        "label": "望都县"
                    },
                    {
                        "id": "130632",
                        "label": "安新县"
                    },
                    {
                        "id": "130633",
                        "label": "易县"
                    },
                    {
                        "id": "130634",
                        "label": "曲阳县"
                    },
                    {
                        "id": "130635",
                        "label": "蠡县"
                    },
                    {
                        "id": "130636",
                        "label": "顺平县"
                    },
                    {
                        "id": "130637",
                        "label": "博野县"
                    },
                    {
                        "id": "130638",
                        "label": "雄县"
                    },
                    {
                        "id": "130681",
                        "label": "涿州市"
                    },
                    {
                        "id": "130682",
                        "label": "定州市"
                    },
                    {
                        "id": "130683",
                        "label": "安国市"
                    },
                    {
                        "id": "130684",
                        "label": "高碑店市"
                    }
                ]
            },
            {
                "id": "130700",
                "label": "张家口市",
                "children": [
                    {
                        "id": "130702",
                        "label": "桥东区"
                    },
                    {
                        "id": "130703",
                        "label": "桥西区"
                    },
                    {
                        "id": "130705",
                        "label": "宣化区"
                    },
                    {
                        "id": "130706",
                        "label": "下花园区"
                    },
                    {
                        "id": "130721",
                        "label": "宣化县"
                    },
                    {
                        "id": "130722",
                        "label": "张北县"
                    },
                    {
                        "id": "130723",
                        "label": "康保县"
                    },
                    {
                        "id": "130724",
                        "label": "沽源县"
                    },
                    {
                        "id": "130725",
                        "label": "尚义县"
                    },
                    {
                        "id": "130726",
                        "label": "蔚县"
                    },
                    {
                        "id": "130727",
                        "label": "阳原县"
                    },
                    {
                        "id": "130728",
                        "label": "怀安县"
                    },
                    {
                        "id": "130729",
                        "label": "万全县"
                    },
                    {
                        "id": "130730",
                        "label": "怀来县"
                    },
                    {
                        "id": "130731",
                        "label": "涿鹿县"
                    },
                    {
                        "id": "130732",
                        "label": "赤城县"
                    },
                    {
                        "id": "130733",
                        "label": "崇礼县"
                    }
                ]
            },
            {
                "id": "130800",
                "label": "承德市",
                "children": [
                    {
                        "id": "130802",
                        "label": "双桥区"
                    },
                    {
                        "id": "130803",
                        "label": "双滦区"
                    },
                    {
                        "id": "130804",
                        "label": "鹰手营子矿区"
                    },
                    {
                        "id": "130821",
                        "label": "承德县"
                    },
                    {
                        "id": "130822",
                        "label": "兴隆县"
                    },
                    {
                        "id": "130823",
                        "label": "平泉县"
                    },
                    {
                        "id": "130824",
                        "label": "滦平县"
                    },
                    {
                        "id": "130825",
                        "label": "隆化县"
                    },
                    {
                        "id": "130826",
                        "label": "丰宁满族自治县"
                    },
                    {
                        "id": "130827",
                        "label": "宽城满族自治县"
                    },
                    {
                        "id": "130828",
                        "label": "围场满族蒙古族自治县"
                    }
                ]
            },
            {
                "id": "130900",
                "label": "沧州市",
                "children": [
                    {
                        "id": "130902",
                        "label": "新华区"
                    },
                    {
                        "id": "130903",
                        "label": "运河区"
                    },
                    {
                        "id": "130921",
                        "label": "沧县"
                    },
                    {
                        "id": "130922",
                        "label": "青县"
                    },
                    {
                        "id": "130923",
                        "label": "东光县"
                    },
                    {
                        "id": "130924",
                        "label": "海兴县"
                    },
                    {
                        "id": "130925",
                        "label": "盐山县"
                    },
                    {
                        "id": "130926",
                        "label": "肃宁县"
                    },
                    {
                        "id": "130927",
                        "label": "南皮县"
                    },
                    {
                        "id": "130928",
                        "label": "吴桥县"
                    },
                    {
                        "id": "130929",
                        "label": "献县"
                    },
                    {
                        "id": "130930",
                        "label": "孟村回族自治县"
                    },
                    {
                        "id": "130981",
                        "label": "泊头市"
                    },
                    {
                        "id": "130982",
                        "label": "任丘市"
                    },
                    {
                        "id": "130983",
                        "label": "黄骅市"
                    },
                    {
                        "id": "130984",
                        "label": "河间市"
                    }
                ]
            },
            {
                "id": "131000",
                "label": "廊坊市",
                "children": [
                    {
                        "id": "131002",
                        "label": "安次区"
                    },
                    {
                        "id": "131003",
                        "label": "广阳区"
                    },
                    {
                        "id": "131022",
                        "label": "固安县"
                    },
                    {
                        "id": "131023",
                        "label": "永清县"
                    },
                    {
                        "id": "131024",
                        "label": "香河县"
                    },
                    {
                        "id": "131025",
                        "label": "大城县"
                    },
                    {
                        "id": "131026",
                        "label": "文安县"
                    },
                    {
                        "id": "131028",
                        "label": "大厂回族自治县"
                    },
                    {
                        "id": "131081",
                        "label": "霸州市"
                    },
                    {
                        "id": "131082",
                        "label": "三河市"
                    }
                ]
            },
            {
                "id": "131100",
                "label": "衡水市",
                "children": [
                    {
                        "id": "131102",
                        "label": "桃城区"
                    },
                    {
                        "id": "131121",
                        "label": "枣强县"
                    },
                    {
                        "id": "131122",
                        "label": "武邑县"
                    },
                    {
                        "id": "131123",
                        "label": "武强县"
                    },
                    {
                        "id": "131124",
                        "label": "饶阳县"
                    },
                    {
                        "id": "131125",
                        "label": "安平县"
                    },
                    {
                        "id": "131126",
                        "label": "故城县"
                    },
                    {
                        "id": "131127",
                        "label": "景县"
                    },
                    {
                        "id": "131128",
                        "label": "阜城县"
                    },
                    {
                        "id": "131181",
                        "label": "冀州市"
                    },
                    {
                        "id": "131182",
                        "label": "深州市"
                    }
                ]
            }
        ]
    },
    {
        "id": "140000",
        "label": "山西省",
        "children": [
            {
                "id": "140100",
                "label": "太原市",
                "children": [
                    {
                        "id": "140105",
                        "label": "小店区"
                    },
                    {
                        "id": "140106",
                        "label": "迎泽区"
                    },
                    {
                        "id": "140107",
                        "label": "杏花岭区"
                    },
                    {
                        "id": "140108",
                        "label": "尖草坪区"
                    },
                    {
                        "id": "140109",
                        "label": "万柏林区"
                    },
                    {
                        "id": "140110",
                        "label": "晋源区"
                    },
                    {
                        "id": "140121",
                        "label": "清徐县"
                    },
                    {
                        "id": "140122",
                        "label": "阳曲县"
                    },
                    {
                        "id": "140123",
                        "label": "娄烦县"
                    },
                    {
                        "id": "140181",
                        "label": "古交市"
                    }
                ]
            },
            {
                "id": "140200",
                "label": "大同市",
                "children": [
                    {
                        "id": "140202",
                        "label": "城区"
                    },
                    {
                        "id": "140203",
                        "label": "矿区"
                    },
                    {
                        "id": "140211",
                        "label": "南郊区"
                    },
                    {
                        "id": "140212",
                        "label": "新荣区"
                    },
                    {
                        "id": "140221",
                        "label": "阳高县"
                    },
                    {
                        "id": "140222",
                        "label": "天镇县"
                    },
                    {
                        "id": "140223",
                        "label": "广灵县"
                    },
                    {
                        "id": "140224",
                        "label": "灵丘县"
                    },
                    {
                        "id": "140225",
                        "label": "浑源县"
                    },
                    {
                        "id": "140226",
                        "label": "左云县"
                    },
                    {
                        "id": "140227",
                        "label": "大同县"
                    }
                ]
            },
            {
                "id": "140300",
                "label": "阳泉市",
                "children": [
                    {
                        "id": "140302",
                        "label": "城区"
                    },
                    {
                        "id": "140303",
                        "label": "矿区"
                    },
                    {
                        "id": "140311",
                        "label": "郊区"
                    },
                    {
                        "id": "140321",
                        "label": "平定县"
                    },
                    {
                        "id": "140322",
                        "label": "盂县"
                    }
                ]
            },
            {
                "id": "140400",
                "label": "长治市",
                "children": [
                    {
                        "id": "140402",
                        "label": "城区"
                    },
                    {
                        "id": "140411",
                        "label": "郊区"
                    },
                    {
                        "id": "140421",
                        "label": "长治县"
                    },
                    {
                        "id": "140423",
                        "label": "襄垣县"
                    },
                    {
                        "id": "140424",
                        "label": "屯留县"
                    },
                    {
                        "id": "140425",
                        "label": "平顺县"
                    },
                    {
                        "id": "140426",
                        "label": "黎城县"
                    },
                    {
                        "id": "140427",
                        "label": "壶关县"
                    },
                    {
                        "id": "140428",
                        "label": "长子县"
                    },
                    {
                        "id": "140429",
                        "label": "武乡县"
                    },
                    {
                        "id": "140430",
                        "label": "沁县"
                    },
                    {
                        "id": "140431",
                        "label": "沁源县"
                    },
                    {
                        "id": "140481",
                        "label": "潞城市"
                    }
                ]
            },
            {
                "id": "140500",
                "label": "晋城市",
                "children": [
                    {
                        "id": "140502",
                        "label": "城区"
                    },
                    {
                        "id": "140521",
                        "label": "沁水县"
                    },
                    {
                        "id": "140522",
                        "label": "阳城县"
                    },
                    {
                        "id": "140524",
                        "label": "陵川县"
                    },
                    {
                        "id": "140525",
                        "label": "泽州县"
                    },
                    {
                        "id": "140581",
                        "label": "高平市"
                    }
                ]
            },
            {
                "id": "140600",
                "label": "朔州市",
                "children": [
                    {
                        "id": "140602",
                        "label": "朔城区"
                    },
                    {
                        "id": "140603",
                        "label": "平鲁区"
                    },
                    {
                        "id": "140621",
                        "label": "山阴县"
                    },
                    {
                        "id": "140622",
                        "label": "应县"
                    },
                    {
                        "id": "140623",
                        "label": "右玉县"
                    },
                    {
                        "id": "140624",
                        "label": "怀仁县"
                    }
                ]
            },
            {
                "id": "140700",
                "label": "晋中市",
                "children": [
                    {
                        "id": "140702",
                        "label": "榆次区"
                    },
                    {
                        "id": "140721",
                        "label": "榆社县"
                    },
                    {
                        "id": "140722",
                        "label": "左权县"
                    },
                    {
                        "id": "140723",
                        "label": "和顺县"
                    },
                    {
                        "id": "140724",
                        "label": "昔阳县"
                    },
                    {
                        "id": "140725",
                        "label": "寿阳县"
                    },
                    {
                        "id": "140726",
                        "label": "太谷县"
                    },
                    {
                        "id": "140727",
                        "label": "祁县"
                    },
                    {
                        "id": "140728",
                        "label": "平遥县"
                    },
                    {
                        "id": "140729",
                        "label": "灵石县"
                    },
                    {
                        "id": "140781",
                        "label": "介休市"
                    }
                ]
            },
            {
                "id": "140800",
                "label": "运城市",
                "children": [
                    {
                        "id": "140802",
                        "label": "盐湖区"
                    },
                    {
                        "id": "140821",
                        "label": "临猗县"
                    },
                    {
                        "id": "140822",
                        "label": "万荣县"
                    },
                    {
                        "id": "140823",
                        "label": "闻喜县"
                    },
                    {
                        "id": "140824",
                        "label": "稷山县"
                    },
                    {
                        "id": "140825",
                        "label": "新绛县"
                    },
                    {
                        "id": "140826",
                        "label": "绛县"
                    },
                    {
                        "id": "140827",
                        "label": "垣曲县"
                    },
                    {
                        "id": "140828",
                        "label": "夏县"
                    },
                    {
                        "id": "140829",
                        "label": "平陆县"
                    },
                    {
                        "id": "140830",
                        "label": "芮城县"
                    },
                    {
                        "id": "140881",
                        "label": "永济市"
                    },
                    {
                        "id": "140882",
                        "label": "河津市"
                    }
                ]
            },
            {
                "id": "140900",
                "label": "忻州市",
                "children": [
                    {
                        "id": "140902",
                        "label": "忻府区"
                    },
                    {
                        "id": "140921",
                        "label": "定襄县"
                    },
                    {
                        "id": "140922",
                        "label": "五台县"
                    },
                    {
                        "id": "140923",
                        "label": "代县"
                    },
                    {
                        "id": "140924",
                        "label": "繁峙县"
                    },
                    {
                        "id": "140925",
                        "label": "宁武县"
                    },
                    {
                        "id": "140926",
                        "label": "静乐县"
                    },
                    {
                        "id": "140927",
                        "label": "神池县"
                    },
                    {
                        "id": "140928",
                        "label": "五寨县"
                    },
                    {
                        "id": "140929",
                        "label": "岢岚县"
                    },
                    {
                        "id": "140930",
                        "label": "河曲县"
                    },
                    {
                        "id": "140931",
                        "label": "保德县"
                    },
                    {
                        "id": "140932",
                        "label": "偏关县"
                    },
                    {
                        "id": "140981",
                        "label": "原平市"
                    }
                ]
            },
            {
                "id": "141000",
                "label": "临汾市",
                "children": [
                    {
                        "id": "141002",
                        "label": "尧都区"
                    },
                    {
                        "id": "141021",
                        "label": "曲沃县"
                    },
                    {
                        "id": "141022",
                        "label": "翼城县"
                    },
                    {
                        "id": "141023",
                        "label": "襄汾县"
                    },
                    {
                        "id": "141024",
                        "label": "洪洞县"
                    },
                    {
                        "id": "141025",
                        "label": "古县"
                    },
                    {
                        "id": "141026",
                        "label": "安泽县"
                    },
                    {
                        "id": "141027",
                        "label": "浮山县"
                    },
                    {
                        "id": "141028",
                        "label": "吉县"
                    },
                    {
                        "id": "141029",
                        "label": "乡宁县"
                    },
                    {
                        "id": "141030",
                        "label": "大宁县"
                    },
                    {
                        "id": "141031",
                        "label": "隰县"
                    },
                    {
                        "id": "141032",
                        "label": "永和县"
                    },
                    {
                        "id": "141033",
                        "label": "蒲县"
                    },
                    {
                        "id": "141034",
                        "label": "汾西县"
                    },
                    {
                        "id": "141081",
                        "label": "侯马市"
                    },
                    {
                        "id": "141082",
                        "label": "霍州市"
                    }
                ]
            },
            {
                "id": "141100",
                "label": "吕梁市",
                "children": [
                    {
                        "id": "141102",
                        "label": "离石区"
                    },
                    {
                        "id": "141121",
                        "label": "文水县"
                    },
                    {
                        "id": "141122",
                        "label": "交城县"
                    },
                    {
                        "id": "141123",
                        "label": "兴县"
                    },
                    {
                        "id": "141124",
                        "label": "临县"
                    },
                    {
                        "id": "141125",
                        "label": "柳林县"
                    },
                    {
                        "id": "141126",
                        "label": "石楼县"
                    },
                    {
                        "id": "141127",
                        "label": "岚县"
                    },
                    {
                        "id": "141128",
                        "label": "方山县"
                    },
                    {
                        "id": "141129",
                        "label": "中阳县"
                    },
                    {
                        "id": "141130",
                        "label": "交口县"
                    },
                    {
                        "id": "141181",
                        "label": "孝义市"
                    },
                    {
                        "id": "141182",
                        "label": "汾阳市"
                    }
                ]
            }
        ]
    },
    {
        "id": "150000",
        "label": "内蒙古自治区",
        "children": [
            {
                "id": "150100",
                "label": "呼和浩特市",
                "children": [
                    {
                        "id": "150102",
                        "label": "新城区"
                    },
                    {
                        "id": "150103",
                        "label": "回民区"
                    },
                    {
                        "id": "150104",
                        "label": "玉泉区"
                    },
                    {
                        "id": "150105",
                        "label": "赛罕区"
                    },
                    {
                        "id": "150121",
                        "label": "土默特左旗"
                    },
                    {
                        "id": "150122",
                        "label": "托克托县"
                    },
                    {
                        "id": "150123",
                        "label": "和林格尔县"
                    },
                    {
                        "id": "150124",
                        "label": "清水河县"
                    },
                    {
                        "id": "150125",
                        "label": "武川县"
                    }
                ]
            },
            {
                "id": "150200",
                "label": "包头市",
                "children": [
                    {
                        "id": "150202",
                        "label": "东河区"
                    },
                    {
                        "id": "150203",
                        "label": "昆都仑区"
                    },
                    {
                        "id": "150204",
                        "label": "青山区"
                    },
                    {
                        "id": "150205",
                        "label": "石拐区"
                    },
                    {
                        "id": "150206",
                        "label": "白云鄂博矿区"
                    },
                    {
                        "id": "150207",
                        "label": "九原区"
                    },
                    {
                        "id": "150221",
                        "label": "土默特右旗"
                    },
                    {
                        "id": "150222",
                        "label": "固阳县"
                    },
                    {
                        "id": "150223",
                        "label": "达尔罕茂明安联合旗"
                    }
                ]
            },
            {
                "id": "150300",
                "label": "乌海市",
                "children": [
                    {
                        "id": "150302",
                        "label": "海勃湾区"
                    },
                    {
                        "id": "150303",
                        "label": "海南区"
                    },
                    {
                        "id": "150304",
                        "label": "乌达区"
                    }
                ]
            },
            {
                "id": "150400",
                "label": "赤峰市",
                "children": [
                    {
                        "id": "150402",
                        "label": "红山区"
                    },
                    {
                        "id": "150403",
                        "label": "元宝山区"
                    },
                    {
                        "id": "150404",
                        "label": "松山区"
                    },
                    {
                        "id": "150421",
                        "label": "阿鲁科尔沁旗"
                    },
                    {
                        "id": "150422",
                        "label": "巴林左旗"
                    },
                    {
                        "id": "150423",
                        "label": "巴林右旗"
                    },
                    {
                        "id": "150424",
                        "label": "林西县"
                    },
                    {
                        "id": "150425",
                        "label": "克什克腾旗"
                    },
                    {
                        "id": "150426",
                        "label": "翁牛特旗"
                    },
                    {
                        "id": "150428",
                        "label": "喀喇沁旗"
                    },
                    {
                        "id": "150429",
                        "label": "宁城县"
                    },
                    {
                        "id": "150430",
                        "label": "敖汉旗"
                    }
                ]
            },
            {
                "id": "150500",
                "label": "通辽市",
                "children": [
                    {
                        "id": "150502",
                        "label": "科尔沁区"
                    },
                    {
                        "id": "150521",
                        "label": "科尔沁左翼中旗"
                    },
                    {
                        "id": "150522",
                        "label": "科尔沁左翼后旗"
                    },
                    {
                        "id": "150523",
                        "label": "开鲁县"
                    },
                    {
                        "id": "150524",
                        "label": "库伦旗"
                    },
                    {
                        "id": "150525",
                        "label": "奈曼旗"
                    },
                    {
                        "id": "150526",
                        "label": "扎鲁特旗"
                    },
                    {
                        "id": "150581",
                        "label": "霍林郭勒市"
                    }
                ]
            },
            {
                "id": "150600",
                "label": "鄂尔多斯市",
                "children": [
                    {
                        "id": "150602",
                        "label": "东胜区"
                    },
                    {
                        "id": "150621",
                        "label": "达拉特旗"
                    },
                    {
                        "id": "150622",
                        "label": "准格尔旗"
                    },
                    {
                        "id": "150623",
                        "label": "鄂托克前旗"
                    },
                    {
                        "id": "150624",
                        "label": "鄂托克旗"
                    },
                    {
                        "id": "150625",
                        "label": "杭锦旗"
                    },
                    {
                        "id": "150626",
                        "label": "乌审旗"
                    },
                    {
                        "id": "150627",
                        "label": "伊金霍洛旗"
                    }
                ]
            },
            {
                "id": "150700",
                "label": "呼伦贝尔市",
                "children": [
                    {
                        "id": "150702",
                        "label": "海拉尔区"
                    },
                    {
                        "id": "150703",
                        "label": "扎赉诺尔区"
                    },
                    {
                        "id": "150721",
                        "label": "阿荣旗"
                    },
                    {
                        "id": "150722",
                        "label": "莫力达瓦达斡尔族自治旗"
                    },
                    {
                        "id": "150723",
                        "label": "鄂伦春自治旗"
                    },
                    {
                        "id": "150724",
                        "label": "鄂温克族自治旗"
                    },
                    {
                        "id": "150725",
                        "label": "陈巴尔虎旗"
                    },
                    {
                        "id": "150726",
                        "label": "新巴尔虎左旗"
                    },
                    {
                        "id": "150727",
                        "label": "新巴尔虎右旗"
                    },
                    {
                        "id": "150781",
                        "label": "满洲里市"
                    },
                    {
                        "id": "150782",
                        "label": "牙克石市"
                    },
                    {
                        "id": "150783",
                        "label": "扎兰屯市"
                    },
                    {
                        "id": "150784",
                        "label": "额尔古纳市"
                    },
                    {
                        "id": "150785",
                        "label": "根河市"
                    }
                ]
            },
            {
                "id": "150800",
                "label": "巴彦淖尔市",
                "children": [
                    {
                        "id": "150802",
                        "label": "临河区"
                    },
                    {
                        "id": "150821",
                        "label": "五原县"
                    },
                    {
                        "id": "150822",
                        "label": "磴口县"
                    },
                    {
                        "id": "150823",
                        "label": "乌拉特前旗"
                    },
                    {
                        "id": "150824",
                        "label": "乌拉特中旗"
                    },
                    {
                        "id": "150825",
                        "label": "乌拉特后旗"
                    },
                    {
                        "id": "150826",
                        "label": "杭锦后旗"
                    }
                ]
            },
            {
                "id": "150900",
                "label": "乌兰察布市",
                "children": [
                    {
                        "id": "150902",
                        "label": "集宁区"
                    },
                    {
                        "id": "150921",
                        "label": "卓资县"
                    },
                    {
                        "id": "150922",
                        "label": "化德县"
                    },
                    {
                        "id": "150923",
                        "label": "商都县"
                    },
                    {
                        "id": "150924",
                        "label": "兴和县"
                    },
                    {
                        "id": "150925",
                        "label": "凉城县"
                    },
                    {
                        "id": "150926",
                        "label": "察哈尔右翼前旗"
                    },
                    {
                        "id": "150927",
                        "label": "察哈尔右翼中旗"
                    },
                    {
                        "id": "150928",
                        "label": "察哈尔右翼后旗"
                    },
                    {
                        "id": "150929",
                        "label": "四子王旗"
                    },
                    {
                        "id": "150981",
                        "label": "丰镇市"
                    }
                ]
            },
            {
                "id": "152200",
                "label": "兴安盟",
                "children": [
                    {
                        "id": "152201",
                        "label": "乌兰浩特市"
                    },
                    {
                        "id": "152202",
                        "label": "阿尔山市"
                    },
                    {
                        "id": "152221",
                        "label": "科尔沁右翼前旗"
                    },
                    {
                        "id": "152222",
                        "label": "科尔沁右翼中旗"
                    },
                    {
                        "id": "152223",
                        "label": "扎赉特旗"
                    },
                    {
                        "id": "152224",
                        "label": "突泉县"
                    }
                ]
            },
            {
                "id": "152500",
                "label": "锡林郭勒盟",
                "children": [
                    {
                        "id": "152501",
                        "label": "二连浩特市"
                    },
                    {
                        "id": "152502",
                        "label": "锡林浩特市"
                    },
                    {
                        "id": "152522",
                        "label": "阿巴嘎旗"
                    },
                    {
                        "id": "152523",
                        "label": "苏尼特左旗"
                    },
                    {
                        "id": "152524",
                        "label": "苏尼特右旗"
                    },
                    {
                        "id": "152525",
                        "label": "东乌珠穆沁旗"
                    },
                    {
                        "id": "152526",
                        "label": "西乌珠穆沁旗"
                    },
                    {
                        "id": "152527",
                        "label": "太仆寺旗"
                    },
                    {
                        "id": "152528",
                        "label": "镶黄旗"
                    },
                    {
                        "id": "152529",
                        "label": "正镶白旗"
                    },
                    {
                        "id": "152530",
                        "label": "正蓝旗"
                    },
                    {
                        "id": "152531",
                        "label": "多伦县"
                    }
                ]
            },
            {
                "id": "152900",
                "label": "阿拉善盟",
                "children": [
                    {
                        "id": "152921",
                        "label": "阿拉善左旗"
                    },
                    {
                        "id": "152922",
                        "label": "阿拉善右旗"
                    },
                    {
                        "id": "152923",
                        "label": "额济纳旗"
                    }
                ]
            }
        ]
    },
    {
        "id": "210000",
        "label": "辽宁省",
        "children": [
            {
                "id": "210100",
                "label": "沈阳市",
                "children": [
                    {
                        "id": "210102",
                        "label": "和平区"
                    },
                    {
                        "id": "210103",
                        "label": "沈河区"
                    },
                    {
                        "id": "210104",
                        "label": "大东区"
                    },
                    {
                        "id": "210105",
                        "label": "皇姑区"
                    },
                    {
                        "id": "210106",
                        "label": "铁西区"
                    },
                    {
                        "id": "210111",
                        "label": "苏家屯区"
                    },
                    {
                        "id": "210112",
                        "label": "东陵区"
                    },
                    {
                        "id": "210113",
                        "label": "沈北新区"
                    },
                    {
                        "id": "210114",
                        "label": "于洪区"
                    },
                    {
                        "id": "210122",
                        "label": "辽中县"
                    },
                    {
                        "id": "210123",
                        "label": "康平县"
                    },
                    {
                        "id": "210124",
                        "label": "法库县"
                    },
                    {
                        "id": "210181",
                        "label": "新民市"
                    }
                ]
            },
            {
                "id": "210200",
                "label": "大连市",
                "children": [
                    {
                        "id": "210202",
                        "label": "中山区"
                    },
                    {
                        "id": "210203",
                        "label": "西岗区"
                    },
                    {
                        "id": "210204",
                        "label": "沙河口区"
                    },
                    {
                        "id": "210211",
                        "label": "甘井子区"
                    },
                    {
                        "id": "210212",
                        "label": "旅顺口区"
                    },
                    {
                        "id": "210213",
                        "label": "金州区"
                    },
                    {
                        "id": "210224",
                        "label": "长海县"
                    },
                    {
                        "id": "210281",
                        "label": "瓦房店市"
                    },
                    {
                        "id": "210282",
                        "label": "普兰店市"
                    },
                    {
                        "id": "210283",
                        "label": "庄河市"
                    }
                ]
            },
            {
                "id": "210300",
                "label": "鞍山市",
                "children": [
                    {
                        "id": "210302",
                        "label": "铁东区"
                    },
                    {
                        "id": "210303",
                        "label": "铁西区"
                    },
                    {
                        "id": "210304",
                        "label": "立山区"
                    },
                    {
                        "id": "210311",
                        "label": "千山区"
                    },
                    {
                        "id": "210321",
                        "label": "台安县"
                    },
                    {
                        "id": "210323",
                        "label": "岫岩满族自治县"
                    },
                    {
                        "id": "210381",
                        "label": "海城市"
                    }
                ]
            },
            {
                "id": "210400",
                "label": "抚顺市",
                "children": [
                    {
                        "id": "210402",
                        "label": "新抚区"
                    },
                    {
                        "id": "210403",
                        "label": "东洲区"
                    },
                    {
                        "id": "210404",
                        "label": "望花区"
                    },
                    {
                        "id": "210411",
                        "label": "顺城区"
                    },
                    {
                        "id": "210421",
                        "label": "抚顺县"
                    },
                    {
                        "id": "210422",
                        "label": "新宾满族自治县"
                    },
                    {
                        "id": "210423",
                        "label": "清原满族自治县"
                    }
                ]
            },
            {
                "id": "210500",
                "label": "本溪市",
                "children": [
                    {
                        "id": "210502",
                        "label": "平山区"
                    },
                    {
                        "id": "210503",
                        "label": "溪湖区"
                    },
                    {
                        "id": "210504",
                        "label": "明山区"
                    },
                    {
                        "id": "210505",
                        "label": "南芬区"
                    },
                    {
                        "id": "210521",
                        "label": "本溪满族自治县"
                    },
                    {
                        "id": "210522",
                        "label": "桓仁满族自治县"
                    }
                ]
            },
            {
                "id": "210600",
                "label": "丹东市",
                "children": [
                    {
                        "id": "210602",
                        "label": "元宝区"
                    },
                    {
                        "id": "210603",
                        "label": "振兴区"
                    },
                    {
                        "id": "210604",
                        "label": "振安区"
                    },
                    {
                        "id": "210624",
                        "label": "宽甸满族自治县"
                    },
                    {
                        "id": "210681",
                        "label": "东港市"
                    },
                    {
                        "id": "210682",
                        "label": "凤城市"
                    }
                ]
            },
            {
                "id": "210700",
                "label": "锦州市",
                "children": [
                    {
                        "id": "210702",
                        "label": "古塔区"
                    },
                    {
                        "id": "210703",
                        "label": "凌河区"
                    },
                    {
                        "id": "210711",
                        "label": "太和区"
                    },
                    {
                        "id": "210726",
                        "label": "黑山县"
                    },
                    {
                        "id": "210727",
                        "label": "义县"
                    },
                    {
                        "id": "210781",
                        "label": "凌海市"
                    },
                    {
                        "id": "210782",
                        "label": "北镇市"
                    }
                ]
            },
            {
                "id": "210800",
                "label": "营口市",
                "children": [
                    {
                        "id": "210802",
                        "label": "站前区"
                    },
                    {
                        "id": "210803",
                        "label": "西市区"
                    },
                    {
                        "id": "210804",
                        "label": "鲅鱼圈区"
                    },
                    {
                        "id": "210811",
                        "label": "老边区"
                    },
                    {
                        "id": "210881",
                        "label": "盖州市"
                    },
                    {
                        "id": "210882",
                        "label": "大石桥市"
                    }
                ]
            },
            {
                "id": "210900",
                "label": "阜新市",
                "children": [
                    {
                        "id": "210902",
                        "label": "海州区"
                    },
                    {
                        "id": "210903",
                        "label": "新邱区"
                    },
                    {
                        "id": "210904",
                        "label": "太平区"
                    },
                    {
                        "id": "210905",
                        "label": "清河门区"
                    },
                    {
                        "id": "210911",
                        "label": "细河区"
                    },
                    {
                        "id": "210921",
                        "label": "阜新蒙古族自治县"
                    },
                    {
                        "id": "210922",
                        "label": "彰武县"
                    }
                ]
            },
            {
                "id": "211000",
                "label": "辽阳市",
                "children": [
                    {
                        "id": "211002",
                        "label": "白塔区"
                    },
                    {
                        "id": "211003",
                        "label": "文圣区"
                    },
                    {
                        "id": "211004",
                        "label": "宏伟区"
                    },
                    {
                        "id": "211005",
                        "label": "弓长岭区"
                    },
                    {
                        "id": "211011",
                        "label": "太子河区"
                    },
                    {
                        "id": "211021",
                        "label": "辽阳县"
                    },
                    {
                        "id": "211081",
                        "label": "灯塔市"
                    }
                ]
            },
            {
                "id": "211100",
                "label": "盘锦市",
                "children": [
                    {
                        "id": "211102",
                        "label": "双台子区"
                    },
                    {
                        "id": "211103",
                        "label": "兴隆台区"
                    },
                    {
                        "id": "211121",
                        "label": "大洼县"
                    },
                    {
                        "id": "211122",
                        "label": "盘山县"
                    }
                ]
            },
            {
                "id": "211200",
                "label": "铁岭市",
                "children": [
                    {
                        "id": "211202",
                        "label": "银州区"
                    },
                    {
                        "id": "211204",
                        "label": "清河区"
                    },
                    {
                        "id": "211221",
                        "label": "铁岭县"
                    },
                    {
                        "id": "211223",
                        "label": "西丰县"
                    },
                    {
                        "id": "211224",
                        "label": "昌图县"
                    },
                    {
                        "id": "211281",
                        "label": "调兵山市"
                    },
                    {
                        "id": "211282",
                        "label": "开原市"
                    }
                ]
            },
            {
                "id": "211300",
                "label": "朝阳市",
                "children": [
                    {
                        "id": "211302",
                        "label": "双塔区"
                    },
                    {
                        "id": "211303",
                        "label": "龙城区"
                    },
                    {
                        "id": "211321",
                        "label": "朝阳县"
                    },
                    {
                        "id": "211322",
                        "label": "建平县"
                    },
                    {
                        "id": "211324",
                        "label": "喀喇沁左翼蒙古族自治县"
                    },
                    {
                        "id": "211381",
                        "label": "北票市"
                    },
                    {
                        "id": "211382",
                        "label": "凌源市"
                    }
                ]
            },
            {
                "id": "211400",
                "label": "葫芦岛市",
                "children": [
                    {
                        "id": "211402",
                        "label": "连山区"
                    },
                    {
                        "id": "211403",
                        "label": "龙港区"
                    },
                    {
                        "id": "211404",
                        "label": "南票区"
                    },
                    {
                        "id": "211421",
                        "label": "绥中县"
                    },
                    {
                        "id": "211422",
                        "label": "建昌县"
                    },
                    {
                        "id": "211481",
                        "label": "兴城市"
                    }
                ]
            }
        ]
    },
    {
        "id": "220000",
        "label": "吉林省",
        "children": [
            {
                "id": "220100",
                "label": "长春市",
                "children": [
                    {
                        "id": "220102",
                        "label": "南关区"
                    },
                    {
                        "id": "220103",
                        "label": "宽城区"
                    },
                    {
                        "id": "220104",
                        "label": "朝阳区"
                    },
                    {
                        "id": "220105",
                        "label": "二道区"
                    },
                    {
                        "id": "220106",
                        "label": "绿园区"
                    },
                    {
                        "id": "220112",
                        "label": "双阳区"
                    },
                    {
                        "id": "220122",
                        "label": "农安县"
                    },
                    {
                        "id": "220181",
                        "label": "九台市"
                    },
                    {
                        "id": "220182",
                        "label": "榆树市"
                    },
                    {
                        "id": "220183",
                        "label": "德惠市"
                    }
                ]
            },
            {
                "id": "220200",
                "label": "吉林市",
                "children": [
                    {
                        "id": "220202",
                        "label": "昌邑区"
                    },
                    {
                        "id": "220203",
                        "label": "龙潭区"
                    },
                    {
                        "id": "220204",
                        "label": "船营区"
                    },
                    {
                        "id": "220211",
                        "label": "丰满区"
                    },
                    {
                        "id": "220221",
                        "label": "永吉县"
                    },
                    {
                        "id": "220281",
                        "label": "蛟河市"
                    },
                    {
                        "id": "220282",
                        "label": "桦甸市"
                    },
                    {
                        "id": "220283",
                        "label": "舒兰市"
                    },
                    {
                        "id": "220284",
                        "label": "磐石市"
                    }
                ]
            },
            {
                "id": "220300",
                "label": "四平市",
                "children": [
                    {
                        "id": "220302",
                        "label": "铁西区"
                    },
                    {
                        "id": "220303",
                        "label": "铁东区"
                    },
                    {
                        "id": "220322",
                        "label": "梨树县"
                    },
                    {
                        "id": "220323",
                        "label": "伊通满族自治县"
                    },
                    {
                        "id": "220381",
                        "label": "公主岭市"
                    },
                    {
                        "id": "220382",
                        "label": "双辽市"
                    }
                ]
            },
            {
                "id": "220400",
                "label": "辽源市",
                "children": [
                    {
                        "id": "220402",
                        "label": "龙山区"
                    },
                    {
                        "id": "220403",
                        "label": "西安区"
                    },
                    {
                        "id": "220421",
                        "label": "东丰县"
                    },
                    {
                        "id": "220422",
                        "label": "东辽县"
                    }
                ]
            },
            {
                "id": "220500",
                "label": "通化市",
                "children": [
                    {
                        "id": "220502",
                        "label": "东昌区"
                    },
                    {
                        "id": "220503",
                        "label": "二道江区"
                    },
                    {
                        "id": "220521",
                        "label": "通化县"
                    },
                    {
                        "id": "220523",
                        "label": "辉南县"
                    },
                    {
                        "id": "220524",
                        "label": "柳河县"
                    },
                    {
                        "id": "220581",
                        "label": "梅河口市"
                    },
                    {
                        "id": "220582",
                        "label": "集安市"
                    }
                ]
            },
            {
                "id": "220600",
                "label": "白山市",
                "children": [
                    {
                        "id": "220602",
                        "label": "浑江区"
                    },
                    {
                        "id": "220605",
                        "label": "江源区"
                    },
                    {
                        "id": "220621",
                        "label": "抚松县"
                    },
                    {
                        "id": "220622",
                        "label": "靖宇县"
                    },
                    {
                        "id": "220623",
                        "label": "长白朝鲜族自治县"
                    },
                    {
                        "id": "220681",
                        "label": "临江市"
                    }
                ]
            },
            {
                "id": "220700",
                "label": "松原市",
                "children": [
                    {
                        "id": "220702",
                        "label": "宁江区"
                    },
                    {
                        "id": "220721",
                        "label": "前郭尔罗斯蒙古族自治县"
                    },
                    {
                        "id": "220722",
                        "label": "长岭县"
                    },
                    {
                        "id": "220723",
                        "label": "乾安县"
                    },
                    {
                        "id": "220781",
                        "label": "扶余市"
                    }
                ]
            },
            {
                "id": "220800",
                "label": "白城市",
                "children": [
                    {
                        "id": "220802",
                        "label": "洮北区"
                    },
                    {
                        "id": "220821",
                        "label": "镇赉县"
                    },
                    {
                        "id": "220822",
                        "label": "通榆县"
                    },
                    {
                        "id": "220881",
                        "label": "洮南市"
                    },
                    {
                        "id": "220882",
                        "label": "大安市"
                    }
                ]
            },
            {
                "id": "222400",
                "label": "延边朝鲜族自治州",
                "children": [
                    {
                        "id": "222401",
                        "label": "延吉市"
                    },
                    {
                        "id": "222402",
                        "label": "图们市"
                    },
                    {
                        "id": "222403",
                        "label": "敦化市"
                    },
                    {
                        "id": "222404",
                        "label": "珲春市"
                    },
                    {
                        "id": "222405",
                        "label": "龙井市"
                    },
                    {
                        "id": "222406",
                        "label": "和龙市"
                    },
                    {
                        "id": "222424",
                        "label": "汪清县"
                    },
                    {
                        "id": "222426",
                        "label": "安图县"
                    }
                ]
            }
        ]
    },
    {
        "id": "230000",
        "label": "黑龙江省",
        "children": [
            {
                "id": "230100",
                "label": "哈尔滨市",
                "children": [
                    {
                        "id": "230102",
                        "label": "道里区"
                    },
                    {
                        "id": "230103",
                        "label": "南岗区"
                    },
                    {
                        "id": "230104",
                        "label": "道外区"
                    },
                    {
                        "id": "230108",
                        "label": "平房区"
                    },
                    {
                        "id": "230109",
                        "label": "松北区"
                    },
                    {
                        "id": "230110",
                        "label": "香坊区"
                    },
                    {
                        "id": "230111",
                        "label": "呼兰区"
                    },
                    {
                        "id": "230112",
                        "label": "阿城区"
                    },
                    {
                        "id": "230123",
                        "label": "依兰县"
                    },
                    {
                        "id": "230124",
                        "label": "方正县"
                    },
                    {
                        "id": "230125",
                        "label": "宾县"
                    },
                    {
                        "id": "230126",
                        "label": "巴彦县"
                    },
                    {
                        "id": "230127",
                        "label": "木兰县"
                    },
                    {
                        "id": "230128",
                        "label": "通河县"
                    },
                    {
                        "id": "230129",
                        "label": "延寿县"
                    },
                    {
                        "id": "230182",
                        "label": "双城市"
                    },
                    {
                        "id": "230183",
                        "label": "尚志市"
                    },
                    {
                        "id": "230184",
                        "label": "五常市"
                    }
                ]
            },
            {
                "id": "230200",
                "label": "齐齐哈尔市",
                "children": [
                    {
                        "id": "230202",
                        "label": "龙沙区"
                    },
                    {
                        "id": "230203",
                        "label": "建华区"
                    },
                    {
                        "id": "230204",
                        "label": "铁锋区"
                    },
                    {
                        "id": "230205",
                        "label": "昂昂溪区"
                    },
                    {
                        "id": "230206",
                        "label": "富拉尔基区"
                    },
                    {
                        "id": "230207",
                        "label": "碾子山区"
                    },
                    {
                        "id": "230208",
                        "label": "梅里斯达斡尔族区"
                    },
                    {
                        "id": "230221",
                        "label": "龙江县"
                    },
                    {
                        "id": "230223",
                        "label": "依安县"
                    },
                    {
                        "id": "230224",
                        "label": "泰来县"
                    },
                    {
                        "id": "230225",
                        "label": "甘南县"
                    },
                    {
                        "id": "230227",
                        "label": "富裕县"
                    },
                    {
                        "id": "230229",
                        "label": "克山县"
                    },
                    {
                        "id": "230230",
                        "label": "克东县"
                    },
                    {
                        "id": "230231",
                        "label": "拜泉县"
                    },
                    {
                        "id": "230281",
                        "label": "讷河市"
                    }
                ]
            },
            {
                "id": "230300",
                "label": "鸡西市",
                "children": [
                    {
                        "id": "230302",
                        "label": "鸡冠区"
                    },
                    {
                        "id": "230303",
                        "label": "恒山区"
                    },
                    {
                        "id": "230304",
                        "label": "滴道区"
                    },
                    {
                        "id": "230305",
                        "label": "梨树区"
                    },
                    {
                        "id": "230306",
                        "label": "城子河区"
                    },
                    {
                        "id": "230307",
                        "label": "麻山区"
                    },
                    {
                        "id": "230321",
                        "label": "鸡东县"
                    },
                    {
                        "id": "230381",
                        "label": "虎林市"
                    },
                    {
                        "id": "230382",
                        "label": "密山市"
                    }
                ]
            },
            {
                "id": "230400",
                "label": "鹤岗市",
                "children": [
                    {
                        "id": "230402",
                        "label": "向阳区"
                    },
                    {
                        "id": "230403",
                        "label": "工农区"
                    },
                    {
                        "id": "230404",
                        "label": "南山区"
                    },
                    {
                        "id": "230405",
                        "label": "兴安区"
                    },
                    {
                        "id": "230406",
                        "label": "东山区"
                    },
                    {
                        "id": "230407",
                        "label": "兴山区"
                    },
                    {
                        "id": "230421",
                        "label": "萝北县"
                    },
                    {
                        "id": "230422",
                        "label": "绥滨县"
                    }
                ]
            },
            {
                "id": "230500",
                "label": "双鸭山市",
                "children": [
                    {
                        "id": "230502",
                        "label": "尖山区"
                    },
                    {
                        "id": "230503",
                        "label": "岭东区"
                    },
                    {
                        "id": "230505",
                        "label": "四方台区"
                    },
                    {
                        "id": "230506",
                        "label": "宝山区"
                    },
                    {
                        "id": "230521",
                        "label": "集贤县"
                    },
                    {
                        "id": "230522",
                        "label": "友谊县"
                    },
                    {
                        "id": "230523",
                        "label": "宝清县"
                    },
                    {
                        "id": "230524",
                        "label": "饶河县"
                    }
                ]
            },
            {
                "id": "230600",
                "label": "大庆市",
                "children": [
                    {
                        "id": "230602",
                        "label": "萨尔图区"
                    },
                    {
                        "id": "230603",
                        "label": "龙凤区"
                    },
                    {
                        "id": "230604",
                        "label": "让胡路区"
                    },
                    {
                        "id": "230605",
                        "label": "红岗区"
                    },
                    {
                        "id": "230606",
                        "label": "大同区"
                    },
                    {
                        "id": "230621",
                        "label": "肇州县"
                    },
                    {
                        "id": "230622",
                        "label": "肇源县"
                    },
                    {
                        "id": "230623",
                        "label": "林甸县"
                    },
                    {
                        "id": "230624",
                        "label": "杜尔伯特蒙古族自治县"
                    }
                ]
            },
            {
                "id": "230700",
                "label": "伊春市",
                "children": [
                    {
                        "id": "230702",
                        "label": "伊春区"
                    },
                    {
                        "id": "230703",
                        "label": "南岔区"
                    },
                    {
                        "id": "230704",
                        "label": "友好区"
                    },
                    {
                        "id": "230705",
                        "label": "西林区"
                    },
                    {
                        "id": "230706",
                        "label": "翠峦区"
                    },
                    {
                        "id": "230707",
                        "label": "新青区"
                    },
                    {
                        "id": "230708",
                        "label": "美溪区"
                    },
                    {
                        "id": "230709",
                        "label": "金山屯区"
                    },
                    {
                        "id": "230710",
                        "label": "五营区"
                    },
                    {
                        "id": "230711",
                        "label": "乌马河区"
                    },
                    {
                        "id": "230712",
                        "label": "汤旺河区"
                    },
                    {
                        "id": "230713",
                        "label": "带岭区"
                    },
                    {
                        "id": "230714",
                        "label": "乌伊岭区"
                    },
                    {
                        "id": "230715",
                        "label": "红星区"
                    },
                    {
                        "id": "230716",
                        "label": "上甘岭区"
                    },
                    {
                        "id": "230722",
                        "label": "嘉荫县"
                    },
                    {
                        "id": "230781",
                        "label": "铁力市"
                    }
                ]
            },
            {
                "id": "230800",
                "label": "佳木斯市",
                "children": [
                    {
                        "id": "230803",
                        "label": "向阳区"
                    },
                    {
                        "id": "230804",
                        "label": "前进区"
                    },
                    {
                        "id": "230805",
                        "label": "东风区"
                    },
                    {
                        "id": "230811",
                        "label": "郊区"
                    },
                    {
                        "id": "230822",
                        "label": "桦南县"
                    },
                    {
                        "id": "230826",
                        "label": "桦川县"
                    },
                    {
                        "id": "230828",
                        "label": "汤原县"
                    },
                    {
                        "id": "230833",
                        "label": "抚远县"
                    },
                    {
                        "id": "230881",
                        "label": "同江市"
                    },
                    {
                        "id": "230882",
                        "label": "富锦市"
                    }
                ]
            },
            {
                "id": "230900",
                "label": "七台河市",
                "children": [
                    {
                        "id": "230902",
                        "label": "新兴区"
                    },
                    {
                        "id": "230903",
                        "label": "桃山区"
                    },
                    {
                        "id": "230904",
                        "label": "茄子河区"
                    },
                    {
                        "id": "230921",
                        "label": "勃利县"
                    }
                ]
            },
            {
                "id": "231000",
                "label": "牡丹江市",
                "children": [
                    {
                        "id": "231002",
                        "label": "东安区"
                    },
                    {
                        "id": "231003",
                        "label": "阳明区"
                    },
                    {
                        "id": "231004",
                        "label": "爱民区"
                    },
                    {
                        "id": "231005",
                        "label": "西安区"
                    },
                    {
                        "id": "231024",
                        "label": "东宁县"
                    },
                    {
                        "id": "231025",
                        "label": "林口县"
                    },
                    {
                        "id": "231081",
                        "label": "绥芬河市"
                    },
                    {
                        "id": "231083",
                        "label": "海林市"
                    },
                    {
                        "id": "231084",
                        "label": "宁安市"
                    },
                    {
                        "id": "231085",
                        "label": "穆棱市"
                    }
                ]
            },
            {
                "id": "231100",
                "label": "黑河市",
                "children": [
                    {
                        "id": "231102",
                        "label": "爱辉区"
                    },
                    {
                        "id": "231121",
                        "label": "嫩江县"
                    },
                    {
                        "id": "231123",
                        "label": "逊克县"
                    },
                    {
                        "id": "231124",
                        "label": "孙吴县"
                    },
                    {
                        "id": "231181",
                        "label": "北安市"
                    },
                    {
                        "id": "231182",
                        "label": "五大连池市"
                    }
                ]
            },
            {
                "id": "231200",
                "label": "绥化市",
                "children": [
                    {
                        "id": "231202",
                        "label": "北林区"
                    },
                    {
                        "id": "231221",
                        "label": "望奎县"
                    },
                    {
                        "id": "231222",
                        "label": "兰西县"
                    },
                    {
                        "id": "231223",
                        "label": "青冈县"
                    },
                    {
                        "id": "231224",
                        "label": "庆安县"
                    },
                    {
                        "id": "231225",
                        "label": "明水县"
                    },
                    {
                        "id": "231226",
                        "label": "绥棱县"
                    },
                    {
                        "id": "231281",
                        "label": "安达市"
                    },
                    {
                        "id": "231282",
                        "label": "肇东市"
                    },
                    {
                        "id": "231283",
                        "label": "海伦市"
                    }
                ]
            },
            {
                "id": "232700",
                "label": "大兴安岭地区",
                "children": [
                    {
                        "id": "232721",
                        "label": "呼玛县"
                    },
                    {
                        "id": "232722",
                        "label": "塔河县"
                    },
                    {
                        "id": "232723",
                        "label": "漠河县"
                    }
                ]
            }
        ]
    },
    {
        "id": "310000",
        "label": "上海市",
        "children": [
            {
                "id": "310100",
                "label": "上海市",
                "children": [
                    {
                        "id": "310101",
                        "label": "黄浦区"
                    },
                    {
                        "id": "310104",
                        "label": "徐汇区"
                    },
                    {
                        "id": "310105",
                        "label": "长宁区"
                    },
                    {
                        "id": "310106",
                        "label": "静安区"
                    },
                    {
                        "id": "310107",
                        "label": "普陀区"
                    },
                    {
                        "id": "310108",
                        "label": "闸北区"
                    },
                    {
                        "id": "310109",
                        "label": "虹口区"
                    },
                    {
                        "id": "310110",
                        "label": "杨浦区"
                    },
                    {
                        "id": "310112",
                        "label": "闵行区"
                    },
                    {
                        "id": "310113",
                        "label": "宝山区"
                    },
                    {
                        "id": "310114",
                        "label": "嘉定区"
                    },
                    {
                        "id": "310115",
                        "label": "浦东新区"
                    },
                    {
                        "id": "310116",
                        "label": "金山区"
                    },
                    {
                        "id": "310117",
                        "label": "松江区"
                    },
                    {
                        "id": "310118",
                        "label": "青浦区"
                    },
                    {
                        "id": "310120",
                        "label": "奉贤区"
                    }
                ]
            }
        ]
    },
    {
        "id": "320000",
        "label": "江苏省",
        "children": [
            {
                "id": "320100",
                "label": "南京市",
                "children": [
                    {
                        "id": "320102",
                        "label": "玄武区"
                    },
                    {
                        "id": "320104",
                        "label": "秦淮区"
                    },
                    {
                        "id": "320105",
                        "label": "建邺区"
                    },
                    {
                        "id": "320106",
                        "label": "鼓楼区"
                    },
                    {
                        "id": "320111",
                        "label": "浦口区"
                    },
                    {
                        "id": "320113",
                        "label": "栖霞区"
                    },
                    {
                        "id": "320114",
                        "label": "雨花台区"
                    },
                    {
                        "id": "320115",
                        "label": "江宁区"
                    },
                    {
                        "id": "320116",
                        "label": "六合区"
                    },
                    {
                        "id": "320117",
                        "label": "溧水区"
                    },
                    {
                        "id": "320118",
                        "label": "高淳区"
                    }
                ]
            },
            {
                "id": "320200",
                "label": "无锡市",
                "children": [
                    {
                        "id": "320202",
                        "label": "崇安区"
                    },
                    {
                        "id": "320203",
                        "label": "南长区"
                    },
                    {
                        "id": "320204",
                        "label": "北塘区"
                    },
                    {
                        "id": "320205",
                        "label": "锡山区"
                    },
                    {
                        "id": "320206",
                        "label": "惠山区"
                    },
                    {
                        "id": "320211",
                        "label": "滨湖区"
                    },
                    {
                        "id": "320281",
                        "label": "江阴市"
                    },
                    {
                        "id": "320282",
                        "label": "宜兴市"
                    }
                ]
            },
            {
                "id": "320300",
                "label": "徐州市",
                "children": [
                    {
                        "id": "320302",
                        "label": "鼓楼区"
                    },
                    {
                        "id": "320303",
                        "label": "云龙区"
                    },
                    {
                        "id": "320305",
                        "label": "贾汪区"
                    },
                    {
                        "id": "320311",
                        "label": "泉山区"
                    },
                    {
                        "id": "320312",
                        "label": "铜山区"
                    },
                    {
                        "id": "320321",
                        "label": "丰县"
                    },
                    {
                        "id": "320322",
                        "label": "沛县"
                    },
                    {
                        "id": "320324",
                        "label": "睢宁县"
                    },
                    {
                        "id": "320381",
                        "label": "新沂市"
                    },
                    {
                        "id": "320382",
                        "label": "邳州市"
                    }
                ]
            },
            {
                "id": "320400",
                "label": "常州市",
                "children": [
                    {
                        "id": "320402",
                        "label": "天宁区"
                    },
                    {
                        "id": "320404",
                        "label": "钟楼区"
                    },
                    {
                        "id": "320405",
                        "label": "戚墅堰区"
                    },
                    {
                        "id": "320411",
                        "label": "新北区"
                    },
                    {
                        "id": "320412",
                        "label": "武进区"
                    },
                    {
                        "id": "320481",
                        "label": "溧阳市"
                    },
                    {
                        "id": "320482",
                        "label": "金坛市"
                    }
                ]
            },
            {
                "id": "320500",
                "label": "苏州市",
                "children": [
                    {
                        "id": "320505",
                        "label": "虎丘区"
                    },
                    {
                        "id": "320506",
                        "label": "吴中区"
                    },
                    {
                        "id": "320507",
                        "label": "相城区"
                    },
                    {
                        "id": "320508",
                        "label": "姑苏区"
                    },
                    {
                        "id": "320509",
                        "label": "吴江区"
                    },
                    {
                        "id": "320581",
                        "label": "常熟市"
                    },
                    {
                        "id": "320582",
                        "label": "张家港市"
                    },
                    {
                        "id": "320583",
                        "label": "昆山市"
                    },
                    {
                        "id": "320585",
                        "label": "太仓市"
                    }
                ]
            },
            {
                "id": "320600",
                "label": "南通市",
                "children": [
                    {
                        "id": "320602",
                        "label": "崇川区"
                    },
                    {
                        "id": "320611",
                        "label": "港闸区"
                    },
                    {
                        "id": "320612",
                        "label": "通州区"
                    },
                    {
                        "id": "320621",
                        "label": "海安县"
                    },
                    {
                        "id": "320623",
                        "label": "如东县"
                    },
                    {
                        "id": "320681",
                        "label": "启东市"
                    },
                    {
                        "id": "320682",
                        "label": "如皋市"
                    },
                    {
                        "id": "320684",
                        "label": "海门市"
                    }
                ]
            },
            {
                "id": "320700",
                "label": "连云港市",
                "children": [
                    {
                        "id": "320703",
                        "label": "连云区"
                    },
                    {
                        "id": "320705",
                        "label": "新浦区"
                    },
                    {
                        "id": "320706",
                        "label": "海州区"
                    },
                    {
                        "id": "320721",
                        "label": "赣榆县"
                    },
                    {
                        "id": "320722",
                        "label": "东海县"
                    },
                    {
                        "id": "320723",
                        "label": "灌云县"
                    },
                    {
                        "id": "320724",
                        "label": "灌南县"
                    }
                ]
            },
            {
                "id": "320800",
                "label": "淮安市",
                "children": [
                    {
                        "id": "320802",
                        "label": "清河区"
                    },
                    {
                        "id": "320803",
                        "label": "淮安区"
                    },
                    {
                        "id": "320804",
                        "label": "淮阴区"
                    },
                    {
                        "id": "320811",
                        "label": "清浦区"
                    },
                    {
                        "id": "320826",
                        "label": "涟水县"
                    },
                    {
                        "id": "320829",
                        "label": "洪泽县"
                    },
                    {
                        "id": "320830",
                        "label": "盱眙县"
                    },
                    {
                        "id": "320831",
                        "label": "金湖县"
                    }
                ]
            },
            {
                "id": "320900",
                "label": "盐城市",
                "children": [
                    {
                        "id": "320902",
                        "label": "亭湖区"
                    },
                    {
                        "id": "320903",
                        "label": "盐都区"
                    },
                    {
                        "id": "320921",
                        "label": "响水县"
                    },
                    {
                        "id": "320922",
                        "label": "滨海县"
                    },
                    {
                        "id": "320923",
                        "label": "阜宁县"
                    },
                    {
                        "id": "320924",
                        "label": "射阳县"
                    },
                    {
                        "id": "320925",
                        "label": "建湖县"
                    },
                    {
                        "id": "320981",
                        "label": "东台市"
                    },
                    {
                        "id": "320982",
                        "label": "大丰市"
                    }
                ]
            },
            {
                "id": "321000",
                "label": "扬州市",
                "children": [
                    {
                        "id": "321002",
                        "label": "广陵区"
                    },
                    {
                        "id": "321003",
                        "label": "邗江区"
                    },
                    {
                        "id": "321012",
                        "label": "江都区"
                    },
                    {
                        "id": "321023",
                        "label": "宝应县"
                    },
                    {
                        "id": "321081",
                        "label": "仪征市"
                    },
                    {
                        "id": "321084",
                        "label": "高邮市"
                    }
                ]
            },
            {
                "id": "321100",
                "label": "镇江市",
                "children": [
                    {
                        "id": "321102",
                        "label": "京口区"
                    },
                    {
                        "id": "321111",
                        "label": "润州区"
                    },
                    {
                        "id": "321112",
                        "label": "丹徒区"
                    },
                    {
                        "id": "321181",
                        "label": "丹阳市"
                    },
                    {
                        "id": "321182",
                        "label": "扬中市"
                    },
                    {
                        "id": "321183",
                        "label": "句容市"
                    }
                ]
            },
            {
                "id": "321200",
                "label": "泰州市",
                "children": [
                    {
                        "id": "321202",
                        "label": "海陵区"
                    },
                    {
                        "id": "321203",
                        "label": "高港区"
                    },
                    {
                        "id": "321204",
                        "label": "姜堰区"
                    },
                    {
                        "id": "321281",
                        "label": "兴化市"
                    },
                    {
                        "id": "321282",
                        "label": "靖江市"
                    },
                    {
                        "id": "321283",
                        "label": "泰兴市"
                    }
                ]
            },
            {
                "id": "321300",
                "label": "宿迁市",
                "children": [
                    {
                        "id": "321302",
                        "label": "宿城区"
                    },
                    {
                        "id": "321311",
                        "label": "宿豫区"
                    },
                    {
                        "id": "321322",
                        "label": "沭阳县"
                    },
                    {
                        "id": "321323",
                        "label": "泗阳县"
                    },
                    {
                        "id": "321324",
                        "label": "泗洪县"
                    }
                ]
            }
        ]
    },
    {
        "id": "330000",
        "label": "浙江省",
        "children": [
            {
                "id": "330100",
                "label": "杭州市",
                "children": [
                    {
                        "id": "330102",
                        "label": "上城区"
                    },
                    {
                        "id": "330103",
                        "label": "下城区"
                    },
                    {
                        "id": "330104",
                        "label": "江干区"
                    },
                    {
                        "id": "330105",
                        "label": "拱墅区"
                    },
                    {
                        "id": "330106",
                        "label": "西湖区"
                    },
                    {
                        "id": "330108",
                        "label": "滨江区"
                    },
                    {
                        "id": "330109",
                        "label": "萧山区"
                    },
                    {
                        "id": "330110",
                        "label": "余杭区"
                    },
                    {
                        "id": "330122",
                        "label": "桐庐县"
                    },
                    {
                        "id": "330127",
                        "label": "淳安县"
                    },
                    {
                        "id": "330182",
                        "label": "建德市"
                    },
                    {
                        "id": "330183",
                        "label": "富阳市"
                    },
                    {
                        "id": "330185",
                        "label": "临安市"
                    }
                ]
            },
            {
                "id": "330200",
                "label": "宁波市",
                "children": [
                    {
                        "id": "330203",
                        "label": "海曙区"
                    },
                    {
                        "id": "330204",
                        "label": "江东区"
                    },
                    {
                        "id": "330205",
                        "label": "江北区"
                    },
                    {
                        "id": "330206",
                        "label": "北仑区"
                    },
                    {
                        "id": "330211",
                        "label": "镇海区"
                    },
                    {
                        "id": "330212",
                        "label": "鄞州区"
                    },
                    {
                        "id": "330225",
                        "label": "象山县"
                    },
                    {
                        "id": "330226",
                        "label": "宁海县"
                    },
                    {
                        "id": "330281",
                        "label": "余姚市"
                    },
                    {
                        "id": "330282",
                        "label": "慈溪市"
                    },
                    {
                        "id": "330283",
                        "label": "奉化市"
                    }
                ]
            },
            {
                "id": "330300",
                "label": "温州市",
                "children": [
                    {
                        "id": "330302",
                        "label": "鹿城区"
                    },
                    {
                        "id": "330303",
                        "label": "龙湾区"
                    },
                    {
                        "id": "330304",
                        "label": "瓯海区"
                    },
                    {
                        "id": "330322",
                        "label": "洞头县"
                    },
                    {
                        "id": "330324",
                        "label": "永嘉县"
                    },
                    {
                        "id": "330326",
                        "label": "平阳县"
                    },
                    {
                        "id": "330327",
                        "label": "苍南县"
                    },
                    {
                        "id": "330328",
                        "label": "文成县"
                    },
                    {
                        "id": "330329",
                        "label": "泰顺县"
                    },
                    {
                        "id": "330381",
                        "label": "瑞安市"
                    },
                    {
                        "id": "330382",
                        "label": "乐清市"
                    }
                ]
            },
            {
                "id": "330400",
                "label": "嘉兴市",
                "children": [
                    {
                        "id": "330402",
                        "label": "南湖区"
                    },
                    {
                        "id": "330411",
                        "label": "秀洲区"
                    },
                    {
                        "id": "330421",
                        "label": "嘉善县"
                    },
                    {
                        "id": "330424",
                        "label": "海盐县"
                    },
                    {
                        "id": "330481",
                        "label": "海宁市"
                    },
                    {
                        "id": "330482",
                        "label": "平湖市"
                    },
                    {
                        "id": "330483",
                        "label": "桐乡市"
                    }
                ]
            },
            {
                "id": "330500",
                "label": "湖州市",
                "children": [
                    {
                        "id": "330502",
                        "label": "吴兴区"
                    },
                    {
                        "id": "330503",
                        "label": "南浔区"
                    },
                    {
                        "id": "330521",
                        "label": "德清县"
                    },
                    {
                        "id": "330522",
                        "label": "长兴县"
                    },
                    {
                        "id": "330523",
                        "label": "安吉县"
                    }
                ]
            },
            {
                "id": "330600",
                "label": "绍兴市",
                "children": [
                    {
                        "id": "330602",
                        "label": "越城区"
                    },
                    {
                        "id": "330621",
                        "label": "绍兴县"
                    },
                    {
                        "id": "330624",
                        "label": "新昌县"
                    },
                    {
                        "id": "330681",
                        "label": "诸暨市"
                    },
                    {
                        "id": "330682",
                        "label": "上虞市"
                    },
                    {
                        "id": "330683",
                        "label": "嵊州市"
                    }
                ]
            },
            {
                "id": "330700",
                "label": "金华市",
                "children": [
                    {
                        "id": "330702",
                        "label": "婺城区"
                    },
                    {
                        "id": "330703",
                        "label": "金东区"
                    },
                    {
                        "id": "330723",
                        "label": "武义县"
                    },
                    {
                        "id": "330726",
                        "label": "浦江县"
                    },
                    {
                        "id": "330727",
                        "label": "磐安县"
                    },
                    {
                        "id": "330781",
                        "label": "兰溪市"
                    },
                    {
                        "id": "330782",
                        "label": "义乌市"
                    },
                    {
                        "id": "330783",
                        "label": "东阳市"
                    },
                    {
                        "id": "330784",
                        "label": "永康市"
                    }
                ]
            },
            {
                "id": "330800",
                "label": "衢州市",
                "children": [
                    {
                        "id": "330802",
                        "label": "柯城区"
                    },
                    {
                        "id": "330803",
                        "label": "衢江区"
                    },
                    {
                        "id": "330822",
                        "label": "常山县"
                    },
                    {
                        "id": "330824",
                        "label": "开化县"
                    },
                    {
                        "id": "330825",
                        "label": "龙游县"
                    },
                    {
                        "id": "330881",
                        "label": "江山市"
                    }
                ]
            },
            {
                "id": "330900",
                "label": "舟山市",
                "children": [
                    {
                        "id": "330902",
                        "label": "定海区"
                    },
                    {
                        "id": "330903",
                        "label": "普陀区"
                    },
                    {
                        "id": "330921",
                        "label": "岱山县"
                    },
                    {
                        "id": "330922",
                        "label": "嵊泗县"
                    }
                ]
            },
            {
                "id": "331000",
                "label": "台州市",
                "children": [
                    {
                        "id": "331002",
                        "label": "椒江区"
                    },
                    {
                        "id": "331003",
                        "label": "黄岩区"
                    },
                    {
                        "id": "331004",
                        "label": "路桥区"
                    },
                    {
                        "id": "331021",
                        "label": "玉环县"
                    },
                    {
                        "id": "331022",
                        "label": "三门县"
                    },
                    {
                        "id": "331023",
                        "label": "天台县"
                    },
                    {
                        "id": "331024",
                        "label": "仙居县"
                    },
                    {
                        "id": "331081",
                        "label": "温岭市"
                    },
                    {
                        "id": "331082",
                        "label": "临海市"
                    }
                ]
            },
            {
                "id": "331100",
                "label": "丽水市",
                "children": [
                    {
                        "id": "331102",
                        "label": "莲都区"
                    },
                    {
                        "id": "331121",
                        "label": "青田县"
                    },
                    {
                        "id": "331122",
                        "label": "缙云县"
                    },
                    {
                        "id": "331123",
                        "label": "遂昌县"
                    },
                    {
                        "id": "331124",
                        "label": "松阳县"
                    },
                    {
                        "id": "331125",
                        "label": "云和县"
                    },
                    {
                        "id": "331126",
                        "label": "庆元县"
                    },
                    {
                        "id": "331127",
                        "label": "景宁畲族自治县"
                    },
                    {
                        "id": "331181",
                        "label": "龙泉市"
                    }
                ]
            }
        ]
    },
    {
        "id": "340000",
        "label": "安徽省",
        "children": [
            {
                "id": "340100",
                "label": "合肥市",
                "children": [
                    {
                        "id": "340102",
                        "label": "瑶海区"
                    },
                    {
                        "id": "340103",
                        "label": "庐阳区"
                    },
                    {
                        "id": "340104",
                        "label": "蜀山区"
                    },
                    {
                        "id": "340111",
                        "label": "包河区"
                    },
                    {
                        "id": "340121",
                        "label": "长丰县"
                    },
                    {
                        "id": "340122",
                        "label": "肥东县"
                    },
                    {
                        "id": "340123",
                        "label": "肥西县"
                    },
                    {
                        "id": "340124",
                        "label": "庐江县"
                    },
                    {
                        "id": "340181",
                        "label": "巢湖市"
                    }
                ]
            },
            {
                "id": "340200",
                "label": "芜湖市",
                "children": [
                    {
                        "id": "340202",
                        "label": "镜湖区"
                    },
                    {
                        "id": "340203",
                        "label": "弋江区"
                    },
                    {
                        "id": "340207",
                        "label": "鸠江区"
                    },
                    {
                        "id": "340208",
                        "label": "三山区"
                    },
                    {
                        "id": "340221",
                        "label": "芜湖县"
                    },
                    {
                        "id": "340222",
                        "label": "繁昌县"
                    },
                    {
                        "id": "340223",
                        "label": "南陵县"
                    },
                    {
                        "id": "340225",
                        "label": "无为县"
                    }
                ]
            },
            {
                "id": "340300",
                "label": "蚌埠市",
                "children": [
                    {
                        "id": "340302",
                        "label": "龙子湖区"
                    },
                    {
                        "id": "340303",
                        "label": "蚌山区"
                    },
                    {
                        "id": "340304",
                        "label": "禹会区"
                    },
                    {
                        "id": "340311",
                        "label": "淮上区"
                    },
                    {
                        "id": "340321",
                        "label": "怀远县"
                    },
                    {
                        "id": "340322",
                        "label": "五河县"
                    },
                    {
                        "id": "340323",
                        "label": "固镇县"
                    }
                ]
            },
            {
                "id": "340400",
                "label": "淮南市",
                "children": [
                    {
                        "id": "340402",
                        "label": "大通区"
                    },
                    {
                        "id": "340403",
                        "label": "田家庵区"
                    },
                    {
                        "id": "340404",
                        "label": "谢家集区"
                    },
                    {
                        "id": "340405",
                        "label": "八公山区"
                    },
                    {
                        "id": "340406",
                        "label": "潘集区"
                    },
                    {
                        "id": "340421",
                        "label": "凤台县"
                    }
                ]
            },
            {
                "id": "340500",
                "label": "马鞍山市",
                "children": [
                    {
                        "id": "340503",
                        "label": "花山区"
                    },
                    {
                        "id": "340504",
                        "label": "雨山区"
                    },
                    {
                        "id": "340506",
                        "label": "博望区"
                    },
                    {
                        "id": "340521",
                        "label": "当涂县"
                    },
                    {
                        "id": "340522",
                        "label": "含山县"
                    },
                    {
                        "id": "340523",
                        "label": "和县"
                    }
                ]
            },
            {
                "id": "340600",
                "label": "淮北市",
                "children": [
                    {
                        "id": "340602",
                        "label": "杜集区"
                    },
                    {
                        "id": "340603",
                        "label": "相山区"
                    },
                    {
                        "id": "340604",
                        "label": "烈山区"
                    },
                    {
                        "id": "340621",
                        "label": "濉溪县"
                    }
                ]
            },
            {
                "id": "340700",
                "label": "铜陵市",
                "children": [
                    {
                        "id": "340702",
                        "label": "铜官山区"
                    },
                    {
                        "id": "340703",
                        "label": "狮子山区"
                    },
                    {
                        "id": "340711",
                        "label": "郊区"
                    },
                    {
                        "id": "340721",
                        "label": "铜陵县"
                    }
                ]
            },
            {
                "id": "340800",
                "label": "安庆市",
                "children": [
                    {
                        "id": "340802",
                        "label": "迎江区"
                    },
                    {
                        "id": "340803",
                        "label": "大观区"
                    },
                    {
                        "id": "340811",
                        "label": "宜秀区"
                    },
                    {
                        "id": "340822",
                        "label": "怀宁县"
                    },
                    {
                        "id": "340823",
                        "label": "枞阳县"
                    },
                    {
                        "id": "340824",
                        "label": "潜山县"
                    },
                    {
                        "id": "340825",
                        "label": "太湖县"
                    },
                    {
                        "id": "340826",
                        "label": "宿松县"
                    },
                    {
                        "id": "340827",
                        "label": "望江县"
                    },
                    {
                        "id": "340828",
                        "label": "岳西县"
                    },
                    {
                        "id": "340881",
                        "label": "桐城市"
                    }
                ]
            },
            {
                "id": "341000",
                "label": "黄山市",
                "children": [
                    {
                        "id": "341002",
                        "label": "屯溪区"
                    },
                    {
                        "id": "341003",
                        "label": "黄山区"
                    },
                    {
                        "id": "341004",
                        "label": "徽州区"
                    },
                    {
                        "id": "341021",
                        "label": "歙县"
                    },
                    {
                        "id": "341022",
                        "label": "休宁县"
                    },
                    {
                        "id": "341023",
                        "label": "黟县"
                    },
                    {
                        "id": "341024",
                        "label": "祁门县"
                    }
                ]
            },
            {
                "id": "341100",
                "label": "滁州市",
                "children": [
                    {
                        "id": "341102",
                        "label": "琅琊区"
                    },
                    {
                        "id": "341103",
                        "label": "南谯区"
                    },
                    {
                        "id": "341122",
                        "label": "来安县"
                    },
                    {
                        "id": "341124",
                        "label": "全椒县"
                    },
                    {
                        "id": "341125",
                        "label": "定远县"
                    },
                    {
                        "id": "341126",
                        "label": "凤阳县"
                    },
                    {
                        "id": "341181",
                        "label": "天长市"
                    },
                    {
                        "id": "341182",
                        "label": "明光市"
                    }
                ]
            },
            {
                "id": "341200",
                "label": "阜阳市",
                "children": [
                    {
                        "id": "341202",
                        "label": "颍州区"
                    },
                    {
                        "id": "341203",
                        "label": "颍东区"
                    },
                    {
                        "id": "341204",
                        "label": "颍泉区"
                    },
                    {
                        "id": "341221",
                        "label": "临泉县"
                    },
                    {
                        "id": "341222",
                        "label": "太和县"
                    },
                    {
                        "id": "341225",
                        "label": "阜南县"
                    },
                    {
                        "id": "341226",
                        "label": "颍上县"
                    },
                    {
                        "id": "341282",
                        "label": "界首市"
                    }
                ]
            },
            {
                "id": "341300",
                "label": "宿州市",
                "children": [
                    {
                        "id": "341302",
                        "label": "埇桥区"
                    },
                    {
                        "id": "341321",
                        "label": "砀山县"
                    },
                    {
                        "id": "341322",
                        "label": "萧县"
                    },
                    {
                        "id": "341323",
                        "label": "灵璧县"
                    },
                    {
                        "id": "341324",
                        "label": "泗县"
                    }
                ]
            },
            {
                "id": "341500",
                "label": "六安市",
                "children": [
                    {
                        "id": "341502",
                        "label": "金安区"
                    },
                    {
                        "id": "341503",
                        "label": "裕安区"
                    },
                    {
                        "id": "341521",
                        "label": "寿县"
                    },
                    {
                        "id": "341522",
                        "label": "霍邱县"
                    },
                    {
                        "id": "341523",
                        "label": "舒城县"
                    },
                    {
                        "id": "341524",
                        "label": "金寨县"
                    },
                    {
                        "id": "341525",
                        "label": "霍山县"
                    }
                ]
            },
            {
                "id": "341600",
                "label": "亳州市",
                "children": [
                    {
                        "id": "341602",
                        "label": "谯城区"
                    },
                    {
                        "id": "341621",
                        "label": "涡阳县"
                    },
                    {
                        "id": "341622",
                        "label": "蒙城县"
                    },
                    {
                        "id": "341623",
                        "label": "利辛县"
                    }
                ]
            },
            {
                "id": "341700",
                "label": "池州市",
                "children": [
                    {
                        "id": "341702",
                        "label": "贵池区"
                    },
                    {
                        "id": "341721",
                        "label": "东至县"
                    },
                    {
                        "id": "341722",
                        "label": "石台县"
                    },
                    {
                        "id": "341723",
                        "label": "青阳县"
                    }
                ]
            },
            {
                "id": "341800",
                "label": "宣城市",
                "children": [
                    {
                        "id": "341802",
                        "label": "宣州区"
                    },
                    {
                        "id": "341821",
                        "label": "郎溪县"
                    },
                    {
                        "id": "341822",
                        "label": "广德县"
                    },
                    {
                        "id": "341823",
                        "label": "泾县"
                    },
                    {
                        "id": "341824",
                        "label": "绩溪县"
                    },
                    {
                        "id": "341825",
                        "label": "旌德县"
                    },
                    {
                        "id": "341881",
                        "label": "宁国市"
                    }
                ]
            }
        ]
    },
    {
        "id": "350000",
        "label": "福建省",
        "children": [
            {
                "id": "350100",
                "label": "福州市",
                "children": [
                    {
                        "id": "350102",
                        "label": "鼓楼区"
                    },
                    {
                        "id": "350103",
                        "label": "台江区"
                    },
                    {
                        "id": "350104",
                        "label": "仓山区"
                    },
                    {
                        "id": "350105",
                        "label": "马尾区"
                    },
                    {
                        "id": "350111",
                        "label": "晋安区"
                    },
                    {
                        "id": "350121",
                        "label": "闽侯县"
                    },
                    {
                        "id": "350122",
                        "label": "连江县"
                    },
                    {
                        "id": "350123",
                        "label": "罗源县"
                    },
                    {
                        "id": "350124",
                        "label": "闽清县"
                    },
                    {
                        "id": "350125",
                        "label": "永泰县"
                    },
                    {
                        "id": "350128",
                        "label": "平潭县"
                    },
                    {
                        "id": "350181",
                        "label": "福清市"
                    },
                    {
                        "id": "350182",
                        "label": "长乐市"
                    }
                ]
            },
            {
                "id": "350200",
                "label": "厦门市",
                "children": [
                    {
                        "id": "350203",
                        "label": "思明区"
                    },
                    {
                        "id": "350205",
                        "label": "海沧区"
                    },
                    {
                        "id": "350206",
                        "label": "湖里区"
                    },
                    {
                        "id": "350211",
                        "label": "集美区"
                    },
                    {
                        "id": "350212",
                        "label": "同安区"
                    },
                    {
                        "id": "350213",
                        "label": "翔安区"
                    }
                ]
            },
            {
                "id": "350300",
                "label": "莆田市",
                "children": [
                    {
                        "id": "350302",
                        "label": "城厢区"
                    },
                    {
                        "id": "350303",
                        "label": "涵江区"
                    },
                    {
                        "id": "350304",
                        "label": "荔城区"
                    },
                    {
                        "id": "350305",
                        "label": "秀屿区"
                    },
                    {
                        "id": "350322",
                        "label": "仙游县"
                    }
                ]
            },
            {
                "id": "350400",
                "label": "三明市",
                "children": [
                    {
                        "id": "350402",
                        "label": "梅列区"
                    },
                    {
                        "id": "350403",
                        "label": "三元区"
                    },
                    {
                        "id": "350421",
                        "label": "明溪县"
                    },
                    {
                        "id": "350423",
                        "label": "清流县"
                    },
                    {
                        "id": "350424",
                        "label": "宁化县"
                    },
                    {
                        "id": "350425",
                        "label": "大田县"
                    },
                    {
                        "id": "350426",
                        "label": "尤溪县"
                    },
                    {
                        "id": "350427",
                        "label": "沙县"
                    },
                    {
                        "id": "350428",
                        "label": "将乐县"
                    },
                    {
                        "id": "350429",
                        "label": "泰宁县"
                    },
                    {
                        "id": "350430",
                        "label": "建宁县"
                    },
                    {
                        "id": "350481",
                        "label": "永安市"
                    }
                ]
            },
            {
                "id": "350500",
                "label": "泉州市",
                "children": [
                    {
                        "id": "350502",
                        "label": "鲤城区"
                    },
                    {
                        "id": "350503",
                        "label": "丰泽区"
                    },
                    {
                        "id": "350504",
                        "label": "洛江区"
                    },
                    {
                        "id": "350505",
                        "label": "泉港区"
                    },
                    {
                        "id": "350521",
                        "label": "惠安县"
                    },
                    {
                        "id": "350524",
                        "label": "安溪县"
                    },
                    {
                        "id": "350525",
                        "label": "永春县"
                    },
                    {
                        "id": "350526",
                        "label": "德化县"
                    },
                    {
                        "id": "350527",
                        "label": "金门县"
                    },
                    {
                        "id": "350581",
                        "label": "石狮市"
                    },
                    {
                        "id": "350582",
                        "label": "晋江市"
                    },
                    {
                        "id": "350583",
                        "label": "南安市"
                    }
                ]
            },
            {
                "id": "350600",
                "label": "漳州市",
                "children": [
                    {
                        "id": "350602",
                        "label": "芗城区"
                    },
                    {
                        "id": "350603",
                        "label": "龙文区"
                    },
                    {
                        "id": "350622",
                        "label": "云霄县"
                    },
                    {
                        "id": "350623",
                        "label": "漳浦县"
                    },
                    {
                        "id": "350624",
                        "label": "诏安县"
                    },
                    {
                        "id": "350625",
                        "label": "长泰县"
                    },
                    {
                        "id": "350626",
                        "label": "东山县"
                    },
                    {
                        "id": "350627",
                        "label": "南靖县"
                    },
                    {
                        "id": "350628",
                        "label": "平和县"
                    },
                    {
                        "id": "350629",
                        "label": "华安县"
                    },
                    {
                        "id": "350681",
                        "label": "龙海市"
                    }
                ]
            },
            {
                "id": "350700",
                "label": "南平市",
                "children": [
                    {
                        "id": "350702",
                        "label": "延平区"
                    },
                    {
                        "id": "350721",
                        "label": "顺昌县"
                    },
                    {
                        "id": "350722",
                        "label": "浦城县"
                    },
                    {
                        "id": "350723",
                        "label": "光泽县"
                    },
                    {
                        "id": "350724",
                        "label": "松溪县"
                    },
                    {
                        "id": "350725",
                        "label": "政和县"
                    },
                    {
                        "id": "350781",
                        "label": "邵武市"
                    },
                    {
                        "id": "350782",
                        "label": "武夷山市"
                    },
                    {
                        "id": "350783",
                        "label": "建瓯市"
                    },
                    {
                        "id": "350784",
                        "label": "建阳市"
                    }
                ]
            },
            {
                "id": "350800",
                "label": "龙岩市",
                "children": [
                    {
                        "id": "350802",
                        "label": "新罗区"
                    },
                    {
                        "id": "350821",
                        "label": "长汀县"
                    },
                    {
                        "id": "350822",
                        "label": "永定县"
                    },
                    {
                        "id": "350823",
                        "label": "上杭县"
                    },
                    {
                        "id": "350824",
                        "label": "武平县"
                    },
                    {
                        "id": "350825",
                        "label": "连城县"
                    },
                    {
                        "id": "350881",
                        "label": "漳平市"
                    }
                ]
            },
            {
                "id": "350900",
                "label": "宁德市",
                "children": [
                    {
                        "id": "350902",
                        "label": "蕉城区"
                    },
                    {
                        "id": "350921",
                        "label": "霞浦县"
                    },
                    {
                        "id": "350922",
                        "label": "古田县"
                    },
                    {
                        "id": "350923",
                        "label": "屏南县"
                    },
                    {
                        "id": "350924",
                        "label": "寿宁县"
                    },
                    {
                        "id": "350925",
                        "label": "周宁县"
                    },
                    {
                        "id": "350926",
                        "label": "柘荣县"
                    },
                    {
                        "id": "350981",
                        "label": "福安市"
                    },
                    {
                        "id": "350982",
                        "label": "福鼎市"
                    }
                ]
            }
        ]
    },
    {
        "id": "360000",
        "label": "江西省",
        "children": [
            {
                "id": "360100",
                "label": "南昌市",
                "children": [
                    {
                        "id": "360102",
                        "label": "东湖区"
                    },
                    {
                        "id": "360103",
                        "label": "西湖区"
                    },
                    {
                        "id": "360104",
                        "label": "青云谱区"
                    },
                    {
                        "id": "360105",
                        "label": "湾里区"
                    },
                    {
                        "id": "360111",
                        "label": "青山湖区"
                    },
                    {
                        "id": "360121",
                        "label": "南昌县"
                    },
                    {
                        "id": "360122",
                        "label": "新建县"
                    },
                    {
                        "id": "360123",
                        "label": "安义县"
                    },
                    {
                        "id": "360124",
                        "label": "进贤县"
                    }
                ]
            },
            {
                "id": "360200",
                "label": "景德镇市",
                "children": [
                    {
                        "id": "360202",
                        "label": "昌江区"
                    },
                    {
                        "id": "360203",
                        "label": "珠山区"
                    },
                    {
                        "id": "360222",
                        "label": "浮梁县"
                    },
                    {
                        "id": "360281",
                        "label": "乐平市"
                    }
                ]
            },
            {
                "id": "360300",
                "label": "萍乡市",
                "children": [
                    {
                        "id": "360302",
                        "label": "安源区"
                    },
                    {
                        "id": "360313",
                        "label": "湘东区"
                    },
                    {
                        "id": "360321",
                        "label": "莲花县"
                    },
                    {
                        "id": "360322",
                        "label": "上栗县"
                    },
                    {
                        "id": "360323",
                        "label": "芦溪县"
                    }
                ]
            },
            {
                "id": "360400",
                "label": "九江市",
                "children": [
                    {
                        "id": "360402",
                        "label": "庐山区"
                    },
                    {
                        "id": "360403",
                        "label": "浔阳区"
                    },
                    {
                        "id": "360421",
                        "label": "九江县"
                    },
                    {
                        "id": "360423",
                        "label": "武宁县"
                    },
                    {
                        "id": "360424",
                        "label": "修水县"
                    },
                    {
                        "id": "360425",
                        "label": "永修县"
                    },
                    {
                        "id": "360426",
                        "label": "德安县"
                    },
                    {
                        "id": "360427",
                        "label": "星子县"
                    },
                    {
                        "id": "360428",
                        "label": "都昌县"
                    },
                    {
                        "id": "360429",
                        "label": "湖口县"
                    },
                    {
                        "id": "360430",
                        "label": "彭泽县"
                    },
                    {
                        "id": "360481",
                        "label": "瑞昌市"
                    },
                    {
                        "id": "360482",
                        "label": "共青城市"
                    }
                ]
            },
            {
                "id": "360500",
                "label": "新余市",
                "children": [
                    {
                        "id": "360502",
                        "label": "渝水区"
                    },
                    {
                        "id": "360521",
                        "label": "分宜县"
                    }
                ]
            },
            {
                "id": "360600",
                "label": "鹰潭市",
                "children": [
                    {
                        "id": "360602",
                        "label": "月湖区"
                    },
                    {
                        "id": "360622",
                        "label": "余江县"
                    },
                    {
                        "id": "360681",
                        "label": "贵溪市"
                    }
                ]
            },
            {
                "id": "360700",
                "label": "赣州市",
                "children": [
                    {
                        "id": "360702",
                        "label": "章贡区"
                    },
                    {
                        "id": "360721",
                        "label": "赣县"
                    },
                    {
                        "id": "360722",
                        "label": "信丰县"
                    },
                    {
                        "id": "360723",
                        "label": "大余县"
                    },
                    {
                        "id": "360724",
                        "label": "上犹县"
                    },
                    {
                        "id": "360725",
                        "label": "崇义县"
                    },
                    {
                        "id": "360726",
                        "label": "安远县"
                    },
                    {
                        "id": "360727",
                        "label": "龙南县"
                    },
                    {
                        "id": "360728",
                        "label": "定南县"
                    },
                    {
                        "id": "360729",
                        "label": "全南县"
                    },
                    {
                        "id": "360730",
                        "label": "宁都县"
                    },
                    {
                        "id": "360731",
                        "label": "于都县"
                    },
                    {
                        "id": "360732",
                        "label": "兴国县"
                    },
                    {
                        "id": "360733",
                        "label": "会昌县"
                    },
                    {
                        "id": "360734",
                        "label": "寻乌县"
                    },
                    {
                        "id": "360735",
                        "label": "石城县"
                    },
                    {
                        "id": "360781",
                        "label": "瑞金市"
                    },
                    {
                        "id": "360782",
                        "label": "南康市"
                    }
                ]
            },
            {
                "id": "360800",
                "label": "吉安市",
                "children": [
                    {
                        "id": "360802",
                        "label": "吉州区"
                    },
                    {
                        "id": "360803",
                        "label": "青原区"
                    },
                    {
                        "id": "360821",
                        "label": "吉安县"
                    },
                    {
                        "id": "360822",
                        "label": "吉水县"
                    },
                    {
                        "id": "360823",
                        "label": "峡江县"
                    },
                    {
                        "id": "360824",
                        "label": "新干县"
                    },
                    {
                        "id": "360825",
                        "label": "永丰县"
                    },
                    {
                        "id": "360826",
                        "label": "泰和县"
                    },
                    {
                        "id": "360827",
                        "label": "遂川县"
                    },
                    {
                        "id": "360828",
                        "label": "万安县"
                    },
                    {
                        "id": "360829",
                        "label": "安福县"
                    },
                    {
                        "id": "360830",
                        "label": "永新县"
                    },
                    {
                        "id": "360881",
                        "label": "井冈山市"
                    }
                ]
            },
            {
                "id": "360900",
                "label": "宜春市",
                "children": [
                    {
                        "id": "360902",
                        "label": "袁州区"
                    },
                    {
                        "id": "360921",
                        "label": "奉新县"
                    },
                    {
                        "id": "360922",
                        "label": "万载县"
                    },
                    {
                        "id": "360923",
                        "label": "上高县"
                    },
                    {
                        "id": "360924",
                        "label": "宜丰县"
                    },
                    {
                        "id": "360925",
                        "label": "靖安县"
                    },
                    {
                        "id": "360926",
                        "label": "铜鼓县"
                    },
                    {
                        "id": "360981",
                        "label": "丰城市"
                    },
                    {
                        "id": "360982",
                        "label": "樟树市"
                    },
                    {
                        "id": "360983",
                        "label": "高安市"
                    }
                ]
            },
            {
                "id": "361000",
                "label": "抚州市",
                "children": [
                    {
                        "id": "361002",
                        "label": "临川区"
                    },
                    {
                        "id": "361021",
                        "label": "南城县"
                    },
                    {
                        "id": "361022",
                        "label": "黎川县"
                    },
                    {
                        "id": "361023",
                        "label": "南丰县"
                    },
                    {
                        "id": "361024",
                        "label": "崇仁县"
                    },
                    {
                        "id": "361025",
                        "label": "乐安县"
                    },
                    {
                        "id": "361026",
                        "label": "宜黄县"
                    },
                    {
                        "id": "361027",
                        "label": "金溪县"
                    },
                    {
                        "id": "361028",
                        "label": "资溪县"
                    },
                    {
                        "id": "361029",
                        "label": "东乡县"
                    },
                    {
                        "id": "361030",
                        "label": "广昌县"
                    }
                ]
            },
            {
                "id": "361100",
                "label": "上饶市",
                "children": [
                    {
                        "id": "361102",
                        "label": "信州区"
                    },
                    {
                        "id": "361121",
                        "label": "上饶县"
                    },
                    {
                        "id": "361122",
                        "label": "广丰县"
                    },
                    {
                        "id": "361123",
                        "label": "玉山县"
                    },
                    {
                        "id": "361124",
                        "label": "铅山县"
                    },
                    {
                        "id": "361125",
                        "label": "横峰县"
                    },
                    {
                        "id": "361126",
                        "label": "弋阳县"
                    },
                    {
                        "id": "361127",
                        "label": "余干县"
                    },
                    {
                        "id": "361128",
                        "label": "鄱阳县"
                    },
                    {
                        "id": "361129",
                        "label": "万年县"
                    },
                    {
                        "id": "361130",
                        "label": "婺源县"
                    },
                    {
                        "id": "361181",
                        "label": "德兴市"
                    }
                ]
            }
        ]
    },
    {
        "id": "370000",
        "label": "山东省",
        "children": [
            {
                "id": "370100",
                "label": "济南市",
                "children": [
                    {
                        "id": "370102",
                        "label": "历下区"
                    },
                    {
                        "id": "370103",
                        "label": "市中区"
                    },
                    {
                        "id": "370104",
                        "label": "槐荫区"
                    },
                    {
                        "id": "370105",
                        "label": "天桥区"
                    },
                    {
                        "id": "370112",
                        "label": "历城区"
                    },
                    {
                        "id": "370113",
                        "label": "长清区"
                    },
                    {
                        "id": "370124",
                        "label": "平阴县"
                    },
                    {
                        "id": "370125",
                        "label": "济阳县"
                    },
                    {
                        "id": "370126",
                        "label": "商河县"
                    },
                    {
                        "id": "370181",
                        "label": "章丘市"
                    }
                ]
            },
            {
                "id": "370200",
                "label": "青岛市",
                "children": [
                    {
                        "id": "370202",
                        "label": "市南区"
                    },
                    {
                        "id": "370203",
                        "label": "市北区"
                    },
                    {
                        "id": "370211",
                        "label": "黄岛区"
                    },
                    {
                        "id": "370212",
                        "label": "崂山区"
                    },
                    {
                        "id": "370213",
                        "label": "李沧区"
                    },
                    {
                        "id": "370214",
                        "label": "城阳区"
                    },
                    {
                        "id": "370281",
                        "label": "胶州市"
                    },
                    {
                        "id": "370282",
                        "label": "即墨市"
                    },
                    {
                        "id": "370283",
                        "label": "平度市"
                    },
                    {
                        "id": "370285",
                        "label": "莱西市"
                    }
                ]
            },
            {
                "id": "370300",
                "label": "淄博市",
                "children": [
                    {
                        "id": "370302",
                        "label": "淄川区"
                    },
                    {
                        "id": "370303",
                        "label": "张店区"
                    },
                    {
                        "id": "370304",
                        "label": "博山区"
                    },
                    {
                        "id": "370305",
                        "label": "临淄区"
                    },
                    {
                        "id": "370306",
                        "label": "周村区"
                    },
                    {
                        "id": "370321",
                        "label": "桓台县"
                    },
                    {
                        "id": "370322",
                        "label": "高青县"
                    },
                    {
                        "id": "370323",
                        "label": "沂源县"
                    }
                ]
            },
            {
                "id": "370400",
                "label": "枣庄市",
                "children": [
                    {
                        "id": "370402",
                        "label": "市中区"
                    },
                    {
                        "id": "370403",
                        "label": "薛城区"
                    },
                    {
                        "id": "370404",
                        "label": "峄城区"
                    },
                    {
                        "id": "370405",
                        "label": "台儿庄区"
                    },
                    {
                        "id": "370406",
                        "label": "山亭区"
                    },
                    {
                        "id": "370481",
                        "label": "滕州市"
                    }
                ]
            },
            {
                "id": "370500",
                "label": "东营市",
                "children": [
                    {
                        "id": "370502",
                        "label": "东营区"
                    },
                    {
                        "id": "370503",
                        "label": "河口区"
                    },
                    {
                        "id": "370521",
                        "label": "垦利县"
                    },
                    {
                        "id": "370522",
                        "label": "利津县"
                    },
                    {
                        "id": "370523",
                        "label": "广饶县"
                    }
                ]
            },
            {
                "id": "370600",
                "label": "烟台市",
                "children": [
                    {
                        "id": "370602",
                        "label": "芝罘区"
                    },
                    {
                        "id": "370611",
                        "label": "福山区"
                    },
                    {
                        "id": "370612",
                        "label": "牟平区"
                    },
                    {
                        "id": "370613",
                        "label": "莱山区"
                    },
                    {
                        "id": "370634",
                        "label": "长岛县"
                    },
                    {
                        "id": "370681",
                        "label": "龙口市"
                    },
                    {
                        "id": "370682",
                        "label": "莱阳市"
                    },
                    {
                        "id": "370683",
                        "label": "莱州市"
                    },
                    {
                        "id": "370684",
                        "label": "蓬莱市"
                    },
                    {
                        "id": "370685",
                        "label": "招远市"
                    },
                    {
                        "id": "370686",
                        "label": "栖霞市"
                    },
                    {
                        "id": "370687",
                        "label": "海阳市"
                    }
                ]
            },
            {
                "id": "370700",
                "label": "潍坊市",
                "children": [
                    {
                        "id": "370702",
                        "label": "潍城区"
                    },
                    {
                        "id": "370703",
                        "label": "寒亭区"
                    },
                    {
                        "id": "370704",
                        "label": "坊子区"
                    },
                    {
                        "id": "370705",
                        "label": "奎文区"
                    },
                    {
                        "id": "370724",
                        "label": "临朐县"
                    },
                    {
                        "id": "370725",
                        "label": "昌乐县"
                    },
                    {
                        "id": "370781",
                        "label": "青州市"
                    },
                    {
                        "id": "370782",
                        "label": "诸城市"
                    },
                    {
                        "id": "370783",
                        "label": "寿光市"
                    },
                    {
                        "id": "370784",
                        "label": "安丘市"
                    },
                    {
                        "id": "370785",
                        "label": "高密市"
                    },
                    {
                        "id": "370786",
                        "label": "昌邑市"
                    }
                ]
            },
            {
                "id": "370800",
                "label": "济宁市",
                "children": [
                    {
                        "id": "370802",
                        "label": "市中区"
                    },
                    {
                        "id": "370811",
                        "label": "任城区"
                    },
                    {
                        "id": "370826",
                        "label": "微山县"
                    },
                    {
                        "id": "370827",
                        "label": "鱼台县"
                    },
                    {
                        "id": "370828",
                        "label": "金乡县"
                    },
                    {
                        "id": "370829",
                        "label": "嘉祥县"
                    },
                    {
                        "id": "370830",
                        "label": "汶上县"
                    },
                    {
                        "id": "370831",
                        "label": "泗水县"
                    },
                    {
                        "id": "370832",
                        "label": "梁山县"
                    },
                    {
                        "id": "370881",
                        "label": "曲阜市"
                    },
                    {
                        "id": "370882",
                        "label": "兖州市"
                    },
                    {
                        "id": "370883",
                        "label": "邹城市"
                    }
                ]
            },
            {
                "id": "370900",
                "label": "泰安市",
                "children": [
                    {
                        "id": "370902",
                        "label": "泰山区"
                    },
                    {
                        "id": "370911",
                        "label": "岱岳区"
                    },
                    {
                        "id": "370921",
                        "label": "宁阳县"
                    },
                    {
                        "id": "370923",
                        "label": "东平县"
                    },
                    {
                        "id": "370982",
                        "label": "新泰市"
                    },
                    {
                        "id": "370983",
                        "label": "肥城市"
                    }
                ]
            },
            {
                "id": "371000",
                "label": "威海市",
                "children": [
                    {
                        "id": "371002",
                        "label": "环翠区"
                    },
                    {
                        "id": "371081",
                        "label": "文登市"
                    },
                    {
                        "id": "371082",
                        "label": "荣成市"
                    },
                    {
                        "id": "371083",
                        "label": "乳山市"
                    }
                ]
            },
            {
                "id": "371100",
                "label": "日照市",
                "children": [
                    {
                        "id": "371102",
                        "label": "东港区"
                    },
                    {
                        "id": "371103",
                        "label": "岚山区"
                    },
                    {
                        "id": "371121",
                        "label": "五莲县"
                    },
                    {
                        "id": "371122",
                        "label": "莒县"
                    }
                ]
            },
            {
                "id": "371200",
                "label": "莱芜市",
                "children": [
                    {
                        "id": "371202",
                        "label": "莱城区"
                    },
                    {
                        "id": "371203",
                        "label": "钢城区"
                    }
                ]
            },
            {
                "id": "371300",
                "label": "临沂市",
                "children": [
                    {
                        "id": "371302",
                        "label": "兰山区"
                    },
                    {
                        "id": "371311",
                        "label": "罗庄区"
                    },
                    {
                        "id": "371312",
                        "label": "河东区"
                    },
                    {
                        "id": "371321",
                        "label": "沂南县"
                    },
                    {
                        "id": "371322",
                        "label": "郯城县"
                    },
                    {
                        "id": "371323",
                        "label": "沂水县"
                    },
                    {
                        "id": "371324",
                        "label": "苍山县"
                    },
                    {
                        "id": "371325",
                        "label": "费县"
                    },
                    {
                        "id": "371326",
                        "label": "平邑县"
                    },
                    {
                        "id": "371327",
                        "label": "莒南县"
                    },
                    {
                        "id": "371328",
                        "label": "蒙阴县"
                    },
                    {
                        "id": "371329",
                        "label": "临沭县"
                    }
                ]
            },
            {
                "id": "371400",
                "label": "德州市",
                "children": [
                    {
                        "id": "371402",
                        "label": "德城区"
                    },
                    {
                        "id": "371421",
                        "label": "陵县"
                    },
                    {
                        "id": "371422",
                        "label": "宁津县"
                    },
                    {
                        "id": "371423",
                        "label": "庆云县"
                    },
                    {
                        "id": "371424",
                        "label": "临邑县"
                    },
                    {
                        "id": "371425",
                        "label": "齐河县"
                    },
                    {
                        "id": "371426",
                        "label": "平原县"
                    },
                    {
                        "id": "371427",
                        "label": "夏津县"
                    },
                    {
                        "id": "371428",
                        "label": "武城县"
                    },
                    {
                        "id": "371481",
                        "label": "乐陵市"
                    },
                    {
                        "id": "371482",
                        "label": "禹城市"
                    }
                ]
            },
            {
                "id": "371500",
                "label": "聊城市",
                "children": [
                    {
                        "id": "371502",
                        "label": "东昌府区"
                    },
                    {
                        "id": "371521",
                        "label": "阳谷县"
                    },
                    {
                        "id": "371522",
                        "label": "莘县"
                    },
                    {
                        "id": "371523",
                        "label": "茌平县"
                    },
                    {
                        "id": "371524",
                        "label": "东阿县"
                    },
                    {
                        "id": "371525",
                        "label": "冠县"
                    },
                    {
                        "id": "371526",
                        "label": "高唐县"
                    },
                    {
                        "id": "371581",
                        "label": "临清市"
                    }
                ]
            },
            {
                "id": "371600",
                "label": "滨州市",
                "children": [
                    {
                        "id": "371602",
                        "label": "滨城区"
                    },
                    {
                        "id": "371621",
                        "label": "惠民县"
                    },
                    {
                        "id": "371622",
                        "label": "阳信县"
                    },
                    {
                        "id": "371623",
                        "label": "无棣县"
                    },
                    {
                        "id": "371624",
                        "label": "沾化县"
                    },
                    {
                        "id": "371625",
                        "label": "博兴县"
                    },
                    {
                        "id": "371626",
                        "label": "邹平县"
                    }
                ]
            },
            {
                "id": "371700",
                "label": "菏泽市",
                "children": [
                    {
                        "id": "371702",
                        "label": "牡丹区"
                    },
                    {
                        "id": "371721",
                        "label": "曹县"
                    },
                    {
                        "id": "371722",
                        "label": "单县"
                    },
                    {
                        "id": "371723",
                        "label": "成武县"
                    },
                    {
                        "id": "371724",
                        "label": "巨野县"
                    },
                    {
                        "id": "371725",
                        "label": "郓城县"
                    },
                    {
                        "id": "371726",
                        "label": "鄄城县"
                    },
                    {
                        "id": "371727",
                        "label": "定陶县"
                    },
                    {
                        "id": "371728",
                        "label": "东明县"
                    }
                ]
            }
        ]
    },
    {
        "id": "410000",
        "label": "河南省",
        "children": [
            {
                "id": "410100",
                "label": "郑州市",
                "children": [
                    {
                        "id": "410102",
                        "label": "中原区"
                    },
                    {
                        "id": "410103",
                        "label": "二七区"
                    },
                    {
                        "id": "410104",
                        "label": "管城回族区"
                    },
                    {
                        "id": "410105",
                        "label": "金水区"
                    },
                    {
                        "id": "410106",
                        "label": "上街区"
                    },
                    {
                        "id": "410108",
                        "label": "惠济区"
                    },
                    {
                        "id": "410122",
                        "label": "中牟县"
                    },
                    {
                        "id": "410181",
                        "label": "巩义市"
                    },
                    {
                        "id": "410182",
                        "label": "荥阳市"
                    },
                    {
                        "id": "410183",
                        "label": "新密市"
                    },
                    {
                        "id": "410184",
                        "label": "新郑市"
                    },
                    {
                        "id": "410185",
                        "label": "登封市"
                    }
                ]
            },
            {
                "id": "410200",
                "label": "开封市",
                "children": [
                    {
                        "id": "410202",
                        "label": "龙亭区"
                    },
                    {
                        "id": "410203",
                        "label": "顺河回族区"
                    },
                    {
                        "id": "410204",
                        "label": "鼓楼区"
                    },
                    {
                        "id": "410205",
                        "label": "禹王台区"
                    },
                    {
                        "id": "410211",
                        "label": "金明区"
                    },
                    {
                        "id": "410221",
                        "label": "杞县"
                    },
                    {
                        "id": "410222",
                        "label": "通许县"
                    },
                    {
                        "id": "410223",
                        "label": "尉氏县"
                    },
                    {
                        "id": "410224",
                        "label": "开封县"
                    },
                    {
                        "id": "410225",
                        "label": "兰考县"
                    }
                ]
            },
            {
                "id": "410300",
                "label": "洛阳市",
                "children": [
                    {
                        "id": "410302",
                        "label": "老城区"
                    },
                    {
                        "id": "410303",
                        "label": "西工区"
                    },
                    {
                        "id": "410304",
                        "label": "瀍河回族区"
                    },
                    {
                        "id": "410305",
                        "label": "涧西区"
                    },
                    {
                        "id": "410306",
                        "label": "吉利区"
                    },
                    {
                        "id": "410311",
                        "label": "洛龙区"
                    },
                    {
                        "id": "410322",
                        "label": "孟津县"
                    },
                    {
                        "id": "410323",
                        "label": "新安县"
                    },
                    {
                        "id": "410324",
                        "label": "栾川县"
                    },
                    {
                        "id": "410325",
                        "label": "嵩县"
                    },
                    {
                        "id": "410326",
                        "label": "汝阳县"
                    },
                    {
                        "id": "410327",
                        "label": "宜阳县"
                    },
                    {
                        "id": "410328",
                        "label": "洛宁县"
                    },
                    {
                        "id": "410329",
                        "label": "伊川县"
                    },
                    {
                        "id": "410381",
                        "label": "偃师市"
                    }
                ]
            },
            {
                "id": "410400",
                "label": "平顶山市",
                "children": [
                    {
                        "id": "410402",
                        "label": "新华区"
                    },
                    {
                        "id": "410403",
                        "label": "卫东区"
                    },
                    {
                        "id": "410404",
                        "label": "石龙区"
                    },
                    {
                        "id": "410411",
                        "label": "湛河区"
                    },
                    {
                        "id": "410421",
                        "label": "宝丰县"
                    },
                    {
                        "id": "410422",
                        "label": "叶县"
                    },
                    {
                        "id": "410423",
                        "label": "鲁山县"
                    },
                    {
                        "id": "410425",
                        "label": "郏县"
                    },
                    {
                        "id": "410481",
                        "label": "舞钢市"
                    },
                    {
                        "id": "410482",
                        "label": "汝州市"
                    }
                ]
            },
            {
                "id": "410500",
                "label": "安阳市",
                "children": [
                    {
                        "id": "410502",
                        "label": "文峰区"
                    },
                    {
                        "id": "410503",
                        "label": "北关区"
                    },
                    {
                        "id": "410505",
                        "label": "殷都区"
                    },
                    {
                        "id": "410506",
                        "label": "龙安区"
                    },
                    {
                        "id": "410522",
                        "label": "安阳县"
                    },
                    {
                        "id": "410523",
                        "label": "汤阴县"
                    },
                    {
                        "id": "410526",
                        "label": "滑县"
                    },
                    {
                        "id": "410527",
                        "label": "内黄县"
                    },
                    {
                        "id": "410581",
                        "label": "林州市"
                    }
                ]
            },
            {
                "id": "410600",
                "label": "鹤壁市",
                "children": [
                    {
                        "id": "410602",
                        "label": "鹤山区"
                    },
                    {
                        "id": "410603",
                        "label": "山城区"
                    },
                    {
                        "id": "410611",
                        "label": "淇滨区"
                    },
                    {
                        "id": "410621",
                        "label": "浚县"
                    },
                    {
                        "id": "410622",
                        "label": "淇县"
                    }
                ]
            },
            {
                "id": "410700",
                "label": "新乡市",
                "children": [
                    {
                        "id": "410702",
                        "label": "红旗区"
                    },
                    {
                        "id": "410703",
                        "label": "卫滨区"
                    },
                    {
                        "id": "410704",
                        "label": "凤泉区"
                    },
                    {
                        "id": "410711",
                        "label": "牧野区"
                    },
                    {
                        "id": "410721",
                        "label": "新乡县"
                    },
                    {
                        "id": "410724",
                        "label": "获嘉县"
                    },
                    {
                        "id": "410725",
                        "label": "原阳县"
                    },
                    {
                        "id": "410726",
                        "label": "延津县"
                    },
                    {
                        "id": "410727",
                        "label": "封丘县"
                    },
                    {
                        "id": "410728",
                        "label": "长垣县"
                    },
                    {
                        "id": "410781",
                        "label": "卫辉市"
                    },
                    {
                        "id": "410782",
                        "label": "辉县市"
                    }
                ]
            },
            {
                "id": "410800",
                "label": "焦作市",
                "children": [
                    {
                        "id": "410802",
                        "label": "解放区"
                    },
                    {
                        "id": "410803",
                        "label": "中站区"
                    },
                    {
                        "id": "410804",
                        "label": "马村区"
                    },
                    {
                        "id": "410811",
                        "label": "山阳区"
                    },
                    {
                        "id": "410821",
                        "label": "修武县"
                    },
                    {
                        "id": "410822",
                        "label": "博爱县"
                    },
                    {
                        "id": "410823",
                        "label": "武陟县"
                    },
                    {
                        "id": "410825",
                        "label": "温县"
                    },
                    {
                        "id": "410882",
                        "label": "沁阳市"
                    },
                    {
                        "id": "410883",
                        "label": "孟州市"
                    }
                ]
            },
            {
                "id": "410900",
                "label": "濮阳市",
                "children": [
                    {
                        "id": "410902",
                        "label": "华龙区"
                    },
                    {
                        "id": "410922",
                        "label": "清丰县"
                    },
                    {
                        "id": "410923",
                        "label": "南乐县"
                    },
                    {
                        "id": "410926",
                        "label": "范县"
                    },
                    {
                        "id": "410927",
                        "label": "台前县"
                    },
                    {
                        "id": "410928",
                        "label": "濮阳县"
                    }
                ]
            },
            {
                "id": "411000",
                "label": "许昌市",
                "children": [
                    {
                        "id": "411002",
                        "label": "魏都区"
                    },
                    {
                        "id": "411023",
                        "label": "许昌县"
                    },
                    {
                        "id": "411024",
                        "label": "鄢陵县"
                    },
                    {
                        "id": "411025",
                        "label": "襄城县"
                    },
                    {
                        "id": "411081",
                        "label": "禹州市"
                    },
                    {
                        "id": "411082",
                        "label": "长葛市"
                    }
                ]
            },
            {
                "id": "411100",
                "label": "漯河市",
                "children": [
                    {
                        "id": "411102",
                        "label": "源汇区"
                    },
                    {
                        "id": "411103",
                        "label": "郾城区"
                    },
                    {
                        "id": "411104",
                        "label": "召陵区"
                    },
                    {
                        "id": "411121",
                        "label": "舞阳县"
                    },
                    {
                        "id": "411122",
                        "label": "临颍县"
                    }
                ]
            },
            {
                "id": "411200",
                "label": "三门峡市",
                "children": [
                    {
                        "id": "411202",
                        "label": "湖滨区"
                    },
                    {
                        "id": "411221",
                        "label": "渑池县"
                    },
                    {
                        "id": "411222",
                        "label": "陕县"
                    },
                    {
                        "id": "411224",
                        "label": "卢氏县"
                    },
                    {
                        "id": "411281",
                        "label": "义马市"
                    },
                    {
                        "id": "411282",
                        "label": "灵宝市"
                    }
                ]
            },
            {
                "id": "411300",
                "label": "南阳市",
                "children": [
                    {
                        "id": "411302",
                        "label": "宛城区"
                    },
                    {
                        "id": "411303",
                        "label": "卧龙区"
                    },
                    {
                        "id": "411321",
                        "label": "南召县"
                    },
                    {
                        "id": "411322",
                        "label": "方城县"
                    },
                    {
                        "id": "411323",
                        "label": "西峡县"
                    },
                    {
                        "id": "411324",
                        "label": "镇平县"
                    },
                    {
                        "id": "411325",
                        "label": "内乡县"
                    },
                    {
                        "id": "411326",
                        "label": "淅川县"
                    },
                    {
                        "id": "411327",
                        "label": "社旗县"
                    },
                    {
                        "id": "411328",
                        "label": "唐河县"
                    },
                    {
                        "id": "411329",
                        "label": "新野县"
                    },
                    {
                        "id": "411330",
                        "label": "桐柏县"
                    },
                    {
                        "id": "411381",
                        "label": "邓州市"
                    }
                ]
            },
            {
                "id": "411400",
                "label": "商丘市",
                "children": [
                    {
                        "id": "411402",
                        "label": "梁园区"
                    },
                    {
                        "id": "411403",
                        "label": "睢阳区"
                    },
                    {
                        "id": "411421",
                        "label": "民权县"
                    },
                    {
                        "id": "411422",
                        "label": "睢县"
                    },
                    {
                        "id": "411423",
                        "label": "宁陵县"
                    },
                    {
                        "id": "411424",
                        "label": "柘城县"
                    },
                    {
                        "id": "411425",
                        "label": "虞城县"
                    },
                    {
                        "id": "411426",
                        "label": "夏邑县"
                    },
                    {
                        "id": "411481",
                        "label": "永城市"
                    }
                ]
            },
            {
                "id": "411500",
                "label": "信阳市",
                "children": [
                    {
                        "id": "411502",
                        "label": "浉河区"
                    },
                    {
                        "id": "411503",
                        "label": "平桥区"
                    },
                    {
                        "id": "411521",
                        "label": "罗山县"
                    },
                    {
                        "id": "411522",
                        "label": "光山县"
                    },
                    {
                        "id": "411523",
                        "label": "新县"
                    },
                    {
                        "id": "411524",
                        "label": "商城县"
                    },
                    {
                        "id": "411525",
                        "label": "固始县"
                    },
                    {
                        "id": "411526",
                        "label": "潢川县"
                    },
                    {
                        "id": "411527",
                        "label": "淮滨县"
                    },
                    {
                        "id": "411528",
                        "label": "息县"
                    }
                ]
            },
            {
                "id": "411600",
                "label": "周口市",
                "children": [
                    {
                        "id": "411602",
                        "label": "川汇区"
                    },
                    {
                        "id": "411621",
                        "label": "扶沟县"
                    },
                    {
                        "id": "411622",
                        "label": "西华县"
                    },
                    {
                        "id": "411623",
                        "label": "商水县"
                    },
                    {
                        "id": "411624",
                        "label": "沈丘县"
                    },
                    {
                        "id": "411625",
                        "label": "郸城县"
                    },
                    {
                        "id": "411626",
                        "label": "淮阳县"
                    },
                    {
                        "id": "411627",
                        "label": "太康县"
                    },
                    {
                        "id": "411628",
                        "label": "鹿邑县"
                    },
                    {
                        "id": "411681",
                        "label": "项城市"
                    }
                ]
            },
            {
                "id": "411700",
                "label": "驻马店市",
                "children": [
                    {
                        "id": "411702",
                        "label": "驿城区"
                    },
                    {
                        "id": "411721",
                        "label": "西平县"
                    },
                    {
                        "id": "411722",
                        "label": "上蔡县"
                    },
                    {
                        "id": "411723",
                        "label": "平舆县"
                    },
                    {
                        "id": "411724",
                        "label": "正阳县"
                    },
                    {
                        "id": "411725",
                        "label": "确山县"
                    },
                    {
                        "id": "411726",
                        "label": "泌阳县"
                    },
                    {
                        "id": "411727",
                        "label": "汝南县"
                    },
                    {
                        "id": "411728",
                        "label": "遂平县"
                    },
                    {
                        "id": "411729",
                        "label": "新蔡县"
                    }
                ]
            },
            {
                "id": "419000",
                "label": "省直辖县级行政区划",
                "children": [
                    {
                        "id": "419001",
                        "label": "济源市"
                    }
                ]
            }
        ]
    },
    {
        "id": "420000",
        "label": "湖北省",
        "children": [
            {
                "id": "420100",
                "label": "武汉市",
                "children": [
                    {
                        "id": "420102",
                        "label": "江岸区"
                    },
                    {
                        "id": "420103",
                        "label": "江汉区"
                    },
                    {
                        "id": "420104",
                        "label": "硚口区"
                    },
                    {
                        "id": "420105",
                        "label": "汉阳区"
                    },
                    {
                        "id": "420106",
                        "label": "武昌区"
                    },
                    {
                        "id": "420107",
                        "label": "青山区"
                    },
                    {
                        "id": "420111",
                        "label": "洪山区"
                    },
                    {
                        "id": "420112",
                        "label": "东西湖区"
                    },
                    {
                        "id": "420113",
                        "label": "汉南区"
                    },
                    {
                        "id": "420114",
                        "label": "蔡甸区"
                    },
                    {
                        "id": "420115",
                        "label": "江夏区"
                    },
                    {
                        "id": "420116",
                        "label": "黄陂区"
                    },
                    {
                        "id": "420117",
                        "label": "新洲区"
                    }
                ]
            },
            {
                "id": "420200",
                "label": "黄石市",
                "children": [
                    {
                        "id": "420202",
                        "label": "黄石港区"
                    },
                    {
                        "id": "420203",
                        "label": "西塞山区"
                    },
                    {
                        "id": "420204",
                        "label": "下陆区"
                    },
                    {
                        "id": "420205",
                        "label": "铁山区"
                    },
                    {
                        "id": "420222",
                        "label": "阳新县"
                    },
                    {
                        "id": "420281",
                        "label": "大冶市"
                    }
                ]
            },
            {
                "id": "420300",
                "label": "十堰市",
                "children": [
                    {
                        "id": "420302",
                        "label": "茅箭区"
                    },
                    {
                        "id": "420303",
                        "label": "张湾区"
                    },
                    {
                        "id": "420321",
                        "label": "郧县"
                    },
                    {
                        "id": "420322",
                        "label": "郧西县"
                    },
                    {
                        "id": "420323",
                        "label": "竹山县"
                    },
                    {
                        "id": "420324",
                        "label": "竹溪县"
                    },
                    {
                        "id": "420325",
                        "label": "房县"
                    },
                    {
                        "id": "420381",
                        "label": "丹江口市"
                    }
                ]
            },
            {
                "id": "420500",
                "label": "宜昌市",
                "children": [
                    {
                        "id": "420502",
                        "label": "西陵区"
                    },
                    {
                        "id": "420503",
                        "label": "伍家岗区"
                    },
                    {
                        "id": "420504",
                        "label": "点军区"
                    },
                    {
                        "id": "420505",
                        "label": "猇亭区"
                    },
                    {
                        "id": "420506",
                        "label": "夷陵区"
                    },
                    {
                        "id": "420525",
                        "label": "远安县"
                    },
                    {
                        "id": "420526",
                        "label": "兴山县"
                    },
                    {
                        "id": "420527",
                        "label": "秭归县"
                    },
                    {
                        "id": "420528",
                        "label": "长阳土家族自治县"
                    },
                    {
                        "id": "420529",
                        "label": "五峰土家族自治县"
                    },
                    {
                        "id": "420581",
                        "label": "宜都市"
                    },
                    {
                        "id": "420582",
                        "label": "当阳市"
                    },
                    {
                        "id": "420583",
                        "label": "枝江市"
                    }
                ]
            },
            {
                "id": "420600",
                "label": "襄阳市",
                "children": [
                    {
                        "id": "420602",
                        "label": "襄城区"
                    },
                    {
                        "id": "420606",
                        "label": "樊城区"
                    },
                    {
                        "id": "420607",
                        "label": "襄州区"
                    },
                    {
                        "id": "420624",
                        "label": "南漳县"
                    },
                    {
                        "id": "420625",
                        "label": "谷城县"
                    },
                    {
                        "id": "420626",
                        "label": "保康县"
                    },
                    {
                        "id": "420682",
                        "label": "老河口市"
                    },
                    {
                        "id": "420683",
                        "label": "枣阳市"
                    },
                    {
                        "id": "420684",
                        "label": "宜城市"
                    }
                ]
            },
            {
                "id": "420700",
                "label": "鄂州市",
                "children": [
                    {
                        "id": "420702",
                        "label": "梁子湖区"
                    },
                    {
                        "id": "420703",
                        "label": "华容区"
                    },
                    {
                        "id": "420704",
                        "label": "鄂城区"
                    }
                ]
            },
            {
                "id": "420800",
                "label": "荆门市",
                "children": [
                    {
                        "id": "420802",
                        "label": "东宝区"
                    },
                    {
                        "id": "420804",
                        "label": "掇刀区"
                    },
                    {
                        "id": "420821",
                        "label": "京山县"
                    },
                    {
                        "id": "420822",
                        "label": "沙洋县"
                    },
                    {
                        "id": "420881",
                        "label": "钟祥市"
                    }
                ]
            },
            {
                "id": "420900",
                "label": "孝感市",
                "children": [
                    {
                        "id": "420902",
                        "label": "孝南区"
                    },
                    {
                        "id": "420921",
                        "label": "孝昌县"
                    },
                    {
                        "id": "420922",
                        "label": "大悟县"
                    },
                    {
                        "id": "420923",
                        "label": "云梦县"
                    },
                    {
                        "id": "420981",
                        "label": "应城市"
                    },
                    {
                        "id": "420982",
                        "label": "安陆市"
                    },
                    {
                        "id": "420984",
                        "label": "汉川市"
                    }
                ]
            },
            {
                "id": "421000",
                "label": "荆州市",
                "children": [
                    {
                        "id": "421002",
                        "label": "沙市区"
                    },
                    {
                        "id": "421003",
                        "label": "荆州区"
                    },
                    {
                        "id": "421022",
                        "label": "公安县"
                    },
                    {
                        "id": "421023",
                        "label": "监利县"
                    },
                    {
                        "id": "421024",
                        "label": "江陵县"
                    },
                    {
                        "id": "421081",
                        "label": "石首市"
                    },
                    {
                        "id": "421083",
                        "label": "洪湖市"
                    },
                    {
                        "id": "421087",
                        "label": "松滋市"
                    }
                ]
            },
            {
                "id": "421100",
                "label": "黄冈市",
                "children": [
                    {
                        "id": "421102",
                        "label": "黄州区"
                    },
                    {
                        "id": "421121",
                        "label": "团风县"
                    },
                    {
                        "id": "421122",
                        "label": "红安县"
                    },
                    {
                        "id": "421123",
                        "label": "罗田县"
                    },
                    {
                        "id": "421124",
                        "label": "英山县"
                    },
                    {
                        "id": "421125",
                        "label": "浠水县"
                    },
                    {
                        "id": "421126",
                        "label": "蕲春县"
                    },
                    {
                        "id": "421127",
                        "label": "黄梅县"
                    },
                    {
                        "id": "421181",
                        "label": "麻城市"
                    },
                    {
                        "id": "421182",
                        "label": "武穴市"
                    }
                ]
            },
            {
                "id": "421200",
                "label": "咸宁市",
                "children": [
                    {
                        "id": "421202",
                        "label": "咸安区"
                    },
                    {
                        "id": "421221",
                        "label": "嘉鱼县"
                    },
                    {
                        "id": "421222",
                        "label": "通城县"
                    },
                    {
                        "id": "421223",
                        "label": "崇阳县"
                    },
                    {
                        "id": "421224",
                        "label": "通山县"
                    },
                    {
                        "id": "421281",
                        "label": "赤壁市"
                    }
                ]
            },
            {
                "id": "421300",
                "label": "随州市",
                "children": [
                    {
                        "id": "421303",
                        "label": "曾都区"
                    },
                    {
                        "id": "421321",
                        "label": "随县"
                    },
                    {
                        "id": "421381",
                        "label": "广水市"
                    }
                ]
            },
            {
                "id": "422800",
                "label": "恩施土家族苗族自治州",
                "children": [
                    {
                        "id": "422801",
                        "label": "恩施市"
                    },
                    {
                        "id": "422802",
                        "label": "利川市"
                    },
                    {
                        "id": "422822",
                        "label": "建始县"
                    },
                    {
                        "id": "422823",
                        "label": "巴东县"
                    },
                    {
                        "id": "422825",
                        "label": "宣恩县"
                    },
                    {
                        "id": "422826",
                        "label": "咸丰县"
                    },
                    {
                        "id": "422827",
                        "label": "来凤县"
                    },
                    {
                        "id": "422828",
                        "label": "鹤峰县"
                    }
                ]
            },
            {
                "id": "429000",
                "label": "省直辖县级行政区划",
                "children": [
                    {
                        "id": "429004",
                        "label": "仙桃市"
                    },
                    {
                        "id": "429005",
                        "label": "潜江市"
                    },
                    {
                        "id": "429006",
                        "label": "天门市"
                    },
                    {
                        "id": "429021",
                        "label": "神农架林区"
                    }
                ]
            }
        ]
    },
    {
        "id": "430000",
        "label": "湖南省",
        "children": [
            {
                "id": "430100",
                "label": "长沙市",
                "children": [
                    {
                        "id": "430102",
                        "label": "芙蓉区"
                    },
                    {
                        "id": "430103",
                        "label": "天心区"
                    },
                    {
                        "id": "430104",
                        "label": "岳麓区"
                    },
                    {
                        "id": "430105",
                        "label": "开福区"
                    },
                    {
                        "id": "430111",
                        "label": "雨花区"
                    },
                    {
                        "id": "430112",
                        "label": "望城区"
                    },
                    {
                        "id": "430121",
                        "label": "长沙县"
                    },
                    {
                        "id": "430124",
                        "label": "宁乡县"
                    },
                    {
                        "id": "430181",
                        "label": "浏阳市"
                    }
                ]
            },
            {
                "id": "430200",
                "label": "株洲市",
                "children": [
                    {
                        "id": "430202",
                        "label": "荷塘区"
                    },
                    {
                        "id": "430203",
                        "label": "芦淞区"
                    },
                    {
                        "id": "430204",
                        "label": "石峰区"
                    },
                    {
                        "id": "430211",
                        "label": "天元区"
                    },
                    {
                        "id": "430221",
                        "label": "株洲县"
                    },
                    {
                        "id": "430223",
                        "label": "攸县"
                    },
                    {
                        "id": "430224",
                        "label": "茶陵县"
                    },
                    {
                        "id": "430225",
                        "label": "炎陵县"
                    },
                    {
                        "id": "430281",
                        "label": "醴陵市"
                    }
                ]
            },
            {
                "id": "430300",
                "label": "湘潭市",
                "children": [
                    {
                        "id": "430302",
                        "label": "雨湖区"
                    },
                    {
                        "id": "430304",
                        "label": "岳塘区"
                    },
                    {
                        "id": "430321",
                        "label": "湘潭县"
                    },
                    {
                        "id": "430381",
                        "label": "湘乡市"
                    },
                    {
                        "id": "430382",
                        "label": "韶山市"
                    }
                ]
            },
            {
                "id": "430400",
                "label": "衡阳市",
                "children": [
                    {
                        "id": "430405",
                        "label": "珠晖区"
                    },
                    {
                        "id": "430406",
                        "label": "雁峰区"
                    },
                    {
                        "id": "430407",
                        "label": "石鼓区"
                    },
                    {
                        "id": "430408",
                        "label": "蒸湘区"
                    },
                    {
                        "id": "430412",
                        "label": "南岳区"
                    },
                    {
                        "id": "430421",
                        "label": "衡阳县"
                    },
                    {
                        "id": "430422",
                        "label": "衡南县"
                    },
                    {
                        "id": "430423",
                        "label": "衡山县"
                    },
                    {
                        "id": "430424",
                        "label": "衡东县"
                    },
                    {
                        "id": "430426",
                        "label": "祁东县"
                    },
                    {
                        "id": "430481",
                        "label": "耒阳市"
                    },
                    {
                        "id": "430482",
                        "label": "常宁市"
                    }
                ]
            },
            {
                "id": "430500",
                "label": "邵阳市",
                "children": [
                    {
                        "id": "430502",
                        "label": "双清区"
                    },
                    {
                        "id": "430503",
                        "label": "大祥区"
                    },
                    {
                        "id": "430511",
                        "label": "北塔区"
                    },
                    {
                        "id": "430521",
                        "label": "邵东县"
                    },
                    {
                        "id": "430522",
                        "label": "新邵县"
                    },
                    {
                        "id": "430523",
                        "label": "邵阳县"
                    },
                    {
                        "id": "430524",
                        "label": "隆回县"
                    },
                    {
                        "id": "430525",
                        "label": "洞口县"
                    },
                    {
                        "id": "430527",
                        "label": "绥宁县"
                    },
                    {
                        "id": "430528",
                        "label": "新宁县"
                    },
                    {
                        "id": "430529",
                        "label": "城步苗族自治县"
                    },
                    {
                        "id": "430581",
                        "label": "武冈市"
                    }
                ]
            },
            {
                "id": "430600",
                "label": "岳阳市",
                "children": [
                    {
                        "id": "430602",
                        "label": "岳阳楼区"
                    },
                    {
                        "id": "430603",
                        "label": "云溪区"
                    },
                    {
                        "id": "430611",
                        "label": "君山区"
                    },
                    {
                        "id": "430621",
                        "label": "岳阳县"
                    },
                    {
                        "id": "430623",
                        "label": "华容县"
                    },
                    {
                        "id": "430624",
                        "label": "湘阴县"
                    },
                    {
                        "id": "430626",
                        "label": "平江县"
                    },
                    {
                        "id": "430681",
                        "label": "汨罗市"
                    },
                    {
                        "id": "430682",
                        "label": "临湘市"
                    }
                ]
            },
            {
                "id": "430700",
                "label": "常德市",
                "children": [
                    {
                        "id": "430702",
                        "label": "武陵区"
                    },
                    {
                        "id": "430703",
                        "label": "鼎城区"
                    },
                    {
                        "id": "430721",
                        "label": "安乡县"
                    },
                    {
                        "id": "430722",
                        "label": "汉寿县"
                    },
                    {
                        "id": "430723",
                        "label": "澧县"
                    },
                    {
                        "id": "430724",
                        "label": "临澧县"
                    },
                    {
                        "id": "430725",
                        "label": "桃源县"
                    },
                    {
                        "id": "430726",
                        "label": "石门县"
                    },
                    {
                        "id": "430781",
                        "label": "津市市"
                    }
                ]
            },
            {
                "id": "430800",
                "label": "张家界市",
                "children": [
                    {
                        "id": "430802",
                        "label": "永定区"
                    },
                    {
                        "id": "430811",
                        "label": "武陵源区"
                    },
                    {
                        "id": "430821",
                        "label": "慈利县"
                    },
                    {
                        "id": "430822",
                        "label": "桑植县"
                    }
                ]
            },
            {
                "id": "430900",
                "label": "益阳市",
                "children": [
                    {
                        "id": "430902",
                        "label": "资阳区"
                    },
                    {
                        "id": "430903",
                        "label": "赫山区"
                    },
                    {
                        "id": "430921",
                        "label": "南县"
                    },
                    {
                        "id": "430922",
                        "label": "桃江县"
                    },
                    {
                        "id": "430923",
                        "label": "安化县"
                    },
                    {
                        "id": "430981",
                        "label": "沅江市"
                    }
                ]
            },
            {
                "id": "431000",
                "label": "郴州市",
                "children": [
                    {
                        "id": "431002",
                        "label": "北湖区"
                    },
                    {
                        "id": "431003",
                        "label": "苏仙区"
                    },
                    {
                        "id": "431021",
                        "label": "桂阳县"
                    },
                    {
                        "id": "431022",
                        "label": "宜章县"
                    },
                    {
                        "id": "431023",
                        "label": "永兴县"
                    },
                    {
                        "id": "431024",
                        "label": "嘉禾县"
                    },
                    {
                        "id": "431025",
                        "label": "临武县"
                    },
                    {
                        "id": "431026",
                        "label": "汝城县"
                    },
                    {
                        "id": "431027",
                        "label": "桂东县"
                    },
                    {
                        "id": "431028",
                        "label": "安仁县"
                    },
                    {
                        "id": "431081",
                        "label": "资兴市"
                    }
                ]
            },
            {
                "id": "431100",
                "label": "永州市",
                "children": [
                    {
                        "id": "431102",
                        "label": "零陵区"
                    },
                    {
                        "id": "431103",
                        "label": "冷水滩区"
                    },
                    {
                        "id": "431121",
                        "label": "祁阳县"
                    },
                    {
                        "id": "431122",
                        "label": "东安县"
                    },
                    {
                        "id": "431123",
                        "label": "双牌县"
                    },
                    {
                        "id": "431124",
                        "label": "道县"
                    },
                    {
                        "id": "431125",
                        "label": "江永县"
                    },
                    {
                        "id": "431126",
                        "label": "宁远县"
                    },
                    {
                        "id": "431127",
                        "label": "蓝山县"
                    },
                    {
                        "id": "431128",
                        "label": "新田县"
                    },
                    {
                        "id": "431129",
                        "label": "江华瑶族自治县"
                    }
                ]
            },
            {
                "id": "431200",
                "label": "怀化市",
                "children": [
                    {
                        "id": "431202",
                        "label": "鹤城区"
                    },
                    {
                        "id": "431221",
                        "label": "中方县"
                    },
                    {
                        "id": "431222",
                        "label": "沅陵县"
                    },
                    {
                        "id": "431223",
                        "label": "辰溪县"
                    },
                    {
                        "id": "431224",
                        "label": "溆浦县"
                    },
                    {
                        "id": "431225",
                        "label": "会同县"
                    },
                    {
                        "id": "431226",
                        "label": "麻阳苗族自治县"
                    },
                    {
                        "id": "431227",
                        "label": "新晃侗族自治县"
                    },
                    {
                        "id": "431228",
                        "label": "芷江侗族自治县"
                    },
                    {
                        "id": "431229",
                        "label": "靖州苗族侗族自治县"
                    },
                    {
                        "id": "431230",
                        "label": "通道侗族自治县"
                    },
                    {
                        "id": "431281",
                        "label": "洪江市"
                    }
                ]
            },
            {
                "id": "431300",
                "label": "娄底市",
                "children": [
                    {
                        "id": "431302",
                        "label": "娄星区"
                    },
                    {
                        "id": "431321",
                        "label": "双峰县"
                    },
                    {
                        "id": "431322",
                        "label": "新化县"
                    },
                    {
                        "id": "431381",
                        "label": "冷水江市"
                    },
                    {
                        "id": "431382",
                        "label": "涟源市"
                    }
                ]
            },
            {
                "id": "433100",
                "label": "湘西土家族苗族自治州",
                "children": [
                    {
                        "id": "433101",
                        "label": "吉首市"
                    },
                    {
                        "id": "433122",
                        "label": "泸溪县"
                    },
                    {
                        "id": "433123",
                        "label": "凤凰县"
                    },
                    {
                        "id": "433124",
                        "label": "花垣县"
                    },
                    {
                        "id": "433125",
                        "label": "保靖县"
                    },
                    {
                        "id": "433126",
                        "label": "古丈县"
                    },
                    {
                        "id": "433127",
                        "label": "永顺县"
                    },
                    {
                        "id": "433130",
                        "label": "龙山县"
                    }
                ]
            }
        ]
    },
    {
        "id": "440000",
        "label": "广东省",
        "children": [
            {
                "id": "440100",
                "label": "广州市",
                "children": [
                    {
                        "id": "440103",
                        "label": "荔湾区"
                    },
                    {
                        "id": "440104",
                        "label": "越秀区"
                    },
                    {
                        "id": "440105",
                        "label": "海珠区"
                    },
                    {
                        "id": "440106",
                        "label": "天河区"
                    },
                    {
                        "id": "440111",
                        "label": "白云区"
                    },
                    {
                        "id": "440112",
                        "label": "黄埔区"
                    },
                    {
                        "id": "440113",
                        "label": "番禺区"
                    },
                    {
                        "id": "440114",
                        "label": "花都区"
                    },
                    {
                        "id": "440115",
                        "label": "南沙区"
                    },
                    {
                        "id": "440116",
                        "label": "萝岗区"
                    },
                    {
                        "id": "440183",
                        "label": "增城市"
                    },
                    {
                        "id": "440184",
                        "label": "从化市"
                    }
                ]
            },
            {
                "id": "440200",
                "label": "韶关市",
                "children": [
                    {
                        "id": "440203",
                        "label": "武江区"
                    },
                    {
                        "id": "440204",
                        "label": "浈江区"
                    },
                    {
                        "id": "440205",
                        "label": "曲江区"
                    },
                    {
                        "id": "440222",
                        "label": "始兴县"
                    },
                    {
                        "id": "440224",
                        "label": "仁化县"
                    },
                    {
                        "id": "440229",
                        "label": "翁源县"
                    },
                    {
                        "id": "440232",
                        "label": "乳源瑶族自治县"
                    },
                    {
                        "id": "440233",
                        "label": "新丰县"
                    },
                    {
                        "id": "440281",
                        "label": "乐昌市"
                    },
                    {
                        "id": "440282",
                        "label": "南雄市"
                    }
                ]
            },
            {
                "id": "440300",
                "label": "深圳市",
                "children": [
                    {
                        "id": "440303",
                        "label": "罗湖区"
                    },
                    {
                        "id": "440304",
                        "label": "福田区"
                    },
                    {
                        "id": "440305",
                        "label": "南山区"
                    },
                    {
                        "id": "440306",
                        "label": "宝安区"
                    },
                    {
                        "id": "440307",
                        "label": "龙岗区"
                    },
                    {
                        "id": "440308",
                        "label": "盐田区"
                    }
                ]
            },
            {
                "id": "440400",
                "label": "珠海市",
                "children": [
                    {
                        "id": "440402",
                        "label": "香洲区"
                    },
                    {
                        "id": "440403",
                        "label": "斗门区"
                    },
                    {
                        "id": "440404",
                        "label": "金湾区"
                    }
                ]
            },
            {
                "id": "440500",
                "label": "汕头市",
                "children": [
                    {
                        "id": "440507",
                        "label": "龙湖区"
                    },
                    {
                        "id": "440511",
                        "label": "金平区"
                    },
                    {
                        "id": "440512",
                        "label": "濠江区"
                    },
                    {
                        "id": "440513",
                        "label": "潮阳区"
                    },
                    {
                        "id": "440514",
                        "label": "潮南区"
                    },
                    {
                        "id": "440515",
                        "label": "澄海区"
                    },
                    {
                        "id": "440523",
                        "label": "南澳县"
                    }
                ]
            },
            {
                "id": "440600",
                "label": "佛山市",
                "children": [
                    {
                        "id": "440604",
                        "label": "禅城区"
                    },
                    {
                        "id": "440605",
                        "label": "南海区"
                    },
                    {
                        "id": "440606",
                        "label": "顺德区"
                    },
                    {
                        "id": "440607",
                        "label": "三水区"
                    },
                    {
                        "id": "440608",
                        "label": "高明区"
                    }
                ]
            },
            {
                "id": "440700",
                "label": "江门市",
                "children": [
                    {
                        "id": "440703",
                        "label": "蓬江区"
                    },
                    {
                        "id": "440704",
                        "label": "江海区"
                    },
                    {
                        "id": "440705",
                        "label": "新会区"
                    },
                    {
                        "id": "440781",
                        "label": "台山市"
                    },
                    {
                        "id": "440783",
                        "label": "开平市"
                    },
                    {
                        "id": "440784",
                        "label": "鹤山市"
                    },
                    {
                        "id": "440785",
                        "label": "恩平市"
                    }
                ]
            },
            {
                "id": "440800",
                "label": "湛江市",
                "children": [
                    {
                        "id": "440802",
                        "label": "赤坎区"
                    },
                    {
                        "id": "440803",
                        "label": "霞山区"
                    },
                    {
                        "id": "440804",
                        "label": "坡头区"
                    },
                    {
                        "id": "440811",
                        "label": "麻章区"
                    },
                    {
                        "id": "440823",
                        "label": "遂溪县"
                    },
                    {
                        "id": "440825",
                        "label": "徐闻县"
                    },
                    {
                        "id": "440881",
                        "label": "廉江市"
                    },
                    {
                        "id": "440882",
                        "label": "雷州市"
                    },
                    {
                        "id": "440883",
                        "label": "吴川市"
                    }
                ]
            },
            {
                "id": "440900",
                "label": "茂名市",
                "children": [
                    {
                        "id": "440902",
                        "label": "茂南区"
                    },
                    {
                        "id": "440903",
                        "label": "茂港区"
                    },
                    {
                        "id": "440923",
                        "label": "电白县"
                    },
                    {
                        "id": "440981",
                        "label": "高州市"
                    },
                    {
                        "id": "440982",
                        "label": "化州市"
                    },
                    {
                        "id": "440983",
                        "label": "信宜市"
                    }
                ]
            },
            {
                "id": "441200",
                "label": "肇庆市",
                "children": [
                    {
                        "id": "441202",
                        "label": "端州区"
                    },
                    {
                        "id": "441203",
                        "label": "鼎湖区"
                    },
                    {
                        "id": "441223",
                        "label": "广宁县"
                    },
                    {
                        "id": "441224",
                        "label": "怀集县"
                    },
                    {
                        "id": "441225",
                        "label": "封开县"
                    },
                    {
                        "id": "441226",
                        "label": "德庆县"
                    },
                    {
                        "id": "441283",
                        "label": "高要市"
                    },
                    {
                        "id": "441284",
                        "label": "四会市"
                    }
                ]
            },
            {
                "id": "441300",
                "label": "惠州市",
                "children": [
                    {
                        "id": "441302",
                        "label": "惠城区"
                    },
                    {
                        "id": "441303",
                        "label": "惠阳区"
                    },
                    {
                        "id": "441322",
                        "label": "博罗县"
                    },
                    {
                        "id": "441323",
                        "label": "惠东县"
                    },
                    {
                        "id": "441324",
                        "label": "龙门县"
                    }
                ]
            },
            {
                "id": "441400",
                "label": "梅州市",
                "children": [
                    {
                        "id": "441402",
                        "label": "梅江区"
                    },
                    {
                        "id": "441421",
                        "label": "梅县"
                    },
                    {
                        "id": "441422",
                        "label": "大埔县"
                    },
                    {
                        "id": "441423",
                        "label": "丰顺县"
                    },
                    {
                        "id": "441424",
                        "label": "五华县"
                    },
                    {
                        "id": "441426",
                        "label": "平远县"
                    },
                    {
                        "id": "441427",
                        "label": "蕉岭县"
                    },
                    {
                        "id": "441481",
                        "label": "兴宁市"
                    }
                ]
            },
            {
                "id": "441500",
                "label": "汕尾市",
                "children": [
                    {
                        "id": "441502",
                        "label": "城区"
                    },
                    {
                        "id": "441521",
                        "label": "海丰县"
                    },
                    {
                        "id": "441523",
                        "label": "陆河县"
                    },
                    {
                        "id": "441581",
                        "label": "陆丰市"
                    }
                ]
            },
            {
                "id": "441600",
                "label": "河源市",
                "children": [
                    {
                        "id": "441602",
                        "label": "源城区"
                    },
                    {
                        "id": "441621",
                        "label": "紫金县"
                    },
                    {
                        "id": "441622",
                        "label": "龙川县"
                    },
                    {
                        "id": "441623",
                        "label": "连平县"
                    },
                    {
                        "id": "441624",
                        "label": "和平县"
                    },
                    {
                        "id": "441625",
                        "label": "东源县"
                    }
                ]
            },
            {
                "id": "441700",
                "label": "阳江市",
                "children": [
                    {
                        "id": "441702",
                        "label": "江城区"
                    },
                    {
                        "id": "441721",
                        "label": "阳西县"
                    },
                    {
                        "id": "441723",
                        "label": "阳东县"
                    },
                    {
                        "id": "441781",
                        "label": "阳春市"
                    }
                ]
            },
            {
                "id": "441800",
                "label": "清远市",
                "children": [
                    {
                        "id": "441802",
                        "label": "清城区"
                    },
                    {
                        "id": "441803",
                        "label": "清新区"
                    },
                    {
                        "id": "441821",
                        "label": "佛冈县"
                    },
                    {
                        "id": "441823",
                        "label": "阳山县"
                    },
                    {
                        "id": "441825",
                        "label": "连山壮族瑶族自治县"
                    },
                    {
                        "id": "441826",
                        "label": "连南瑶族自治县"
                    },
                    {
                        "id": "441881",
                        "label": "英德市"
                    },
                    {
                        "id": "441882",
                        "label": "连州市"
                    }
                ]
            },
            {
                "id": "441900",
                "label": "东莞市",
                "children": []
            },
            {
                "id": "442000",
                "label": "中山市",
                "children": []
            },
            {
                "id": "445100",
                "label": "潮州市",
                "children": [
                    {
                        "id": "445102",
                        "label": "湘桥区"
                    },
                    {
                        "id": "445103",
                        "label": "潮安区"
                    },
                    {
                        "id": "445122",
                        "label": "饶平县"
                    }
                ]
            },
            {
                "id": "445200",
                "label": "揭阳市",
                "children": [
                    {
                        "id": "445202",
                        "label": "榕城区"
                    },
                    {
                        "id": "445203",
                        "label": "揭东区"
                    },
                    {
                        "id": "445222",
                        "label": "揭西县"
                    },
                    {
                        "id": "445224",
                        "label": "惠来县"
                    },
                    {
                        "id": "445281",
                        "label": "普宁市"
                    }
                ]
            },
            {
                "id": "445300",
                "label": "云浮市",
                "children": [
                    {
                        "id": "445302",
                        "label": "云城区"
                    },
                    {
                        "id": "445321",
                        "label": "新兴县"
                    },
                    {
                        "id": "445322",
                        "label": "郁南县"
                    },
                    {
                        "id": "445323",
                        "label": "云安县"
                    },
                    {
                        "id": "445381",
                        "label": "罗定市"
                    }
                ]
            }
        ]
    },
    {
        "id": "450000",
        "label": "广西壮族自治区",
        "children": [
            {
                "id": "450100",
                "label": "南宁市",
                "children": [
                    {
                        "id": "450102",
                        "label": "兴宁区"
                    },
                    {
                        "id": "450103",
                        "label": "青秀区"
                    },
                    {
                        "id": "450105",
                        "label": "江南区"
                    },
                    {
                        "id": "450107",
                        "label": "西乡塘区"
                    },
                    {
                        "id": "450108",
                        "label": "良庆区"
                    },
                    {
                        "id": "450109",
                        "label": "邕宁区"
                    },
                    {
                        "id": "450122",
                        "label": "武鸣县"
                    },
                    {
                        "id": "450123",
                        "label": "隆安县"
                    },
                    {
                        "id": "450124",
                        "label": "马山县"
                    },
                    {
                        "id": "450125",
                        "label": "上林县"
                    },
                    {
                        "id": "450126",
                        "label": "宾阳县"
                    },
                    {
                        "id": "450127",
                        "label": "横县"
                    }
                ]
            },
            {
                "id": "450200",
                "label": "柳州市",
                "children": [
                    {
                        "id": "450202",
                        "label": "城中区"
                    },
                    {
                        "id": "450203",
                        "label": "鱼峰区"
                    },
                    {
                        "id": "450204",
                        "label": "柳南区"
                    },
                    {
                        "id": "450205",
                        "label": "柳北区"
                    },
                    {
                        "id": "450221",
                        "label": "柳江县"
                    },
                    {
                        "id": "450222",
                        "label": "柳城县"
                    },
                    {
                        "id": "450223",
                        "label": "鹿寨县"
                    },
                    {
                        "id": "450224",
                        "label": "融安县"
                    },
                    {
                        "id": "450225",
                        "label": "融水苗族自治县"
                    },
                    {
                        "id": "450226",
                        "label": "三江侗族自治县"
                    }
                ]
            },
            {
                "id": "450300",
                "label": "桂林市",
                "children": [
                    {
                        "id": "450302",
                        "label": "秀峰区"
                    },
                    {
                        "id": "450303",
                        "label": "叠彩区"
                    },
                    {
                        "id": "450304",
                        "label": "象山区"
                    },
                    {
                        "id": "450305",
                        "label": "七星区"
                    },
                    {
                        "id": "450311",
                        "label": "雁山区"
                    },
                    {
                        "id": "450312",
                        "label": "临桂区"
                    },
                    {
                        "id": "450321",
                        "label": "阳朔县"
                    },
                    {
                        "id": "450323",
                        "label": "灵川县"
                    },
                    {
                        "id": "450324",
                        "label": "全州县"
                    },
                    {
                        "id": "450325",
                        "label": "兴安县"
                    },
                    {
                        "id": "450326",
                        "label": "永福县"
                    },
                    {
                        "id": "450327",
                        "label": "灌阳县"
                    },
                    {
                        "id": "450328",
                        "label": "龙胜各族自治县"
                    },
                    {
                        "id": "450329",
                        "label": "资源县"
                    },
                    {
                        "id": "450330",
                        "label": "平乐县"
                    },
                    {
                        "id": "450331",
                        "label": "荔浦县"
                    },
                    {
                        "id": "450332",
                        "label": "恭城瑶族自治县"
                    }
                ]
            },
            {
                "id": "450400",
                "label": "梧州市",
                "children": [
                    {
                        "id": "450403",
                        "label": "万秀区"
                    },
                    {
                        "id": "450405",
                        "label": "长洲区"
                    },
                    {
                        "id": "450406",
                        "label": "龙圩区"
                    },
                    {
                        "id": "450421",
                        "label": "苍梧县"
                    },
                    {
                        "id": "450422",
                        "label": "藤县"
                    },
                    {
                        "id": "450423",
                        "label": "蒙山县"
                    },
                    {
                        "id": "450481",
                        "label": "岑溪市"
                    }
                ]
            },
            {
                "id": "450500",
                "label": "北海市",
                "children": [
                    {
                        "id": "450502",
                        "label": "海城区"
                    },
                    {
                        "id": "450503",
                        "label": "银海区"
                    },
                    {
                        "id": "450512",
                        "label": "铁山港区"
                    },
                    {
                        "id": "450521",
                        "label": "合浦县"
                    }
                ]
            },
            {
                "id": "450600",
                "label": "防城港市",
                "children": [
                    {
                        "id": "450602",
                        "label": "港口区"
                    },
                    {
                        "id": "450603",
                        "label": "防城区"
                    },
                    {
                        "id": "450621",
                        "label": "上思县"
                    },
                    {
                        "id": "450681",
                        "label": "东兴市"
                    }
                ]
            },
            {
                "id": "450700",
                "label": "钦州市",
                "children": [
                    {
                        "id": "450702",
                        "label": "钦南区"
                    },
                    {
                        "id": "450703",
                        "label": "钦北区"
                    },
                    {
                        "id": "450721",
                        "label": "灵山县"
                    },
                    {
                        "id": "450722",
                        "label": "浦北县"
                    }
                ]
            },
            {
                "id": "450800",
                "label": "贵港市",
                "children": [
                    {
                        "id": "450802",
                        "label": "港北区"
                    },
                    {
                        "id": "450803",
                        "label": "港南区"
                    },
                    {
                        "id": "450804",
                        "label": "覃塘区"
                    },
                    {
                        "id": "450821",
                        "label": "平南县"
                    },
                    {
                        "id": "450881",
                        "label": "桂平市"
                    }
                ]
            },
            {
                "id": "450900",
                "label": "玉林市",
                "children": [
                    {
                        "id": "450902",
                        "label": "玉州区"
                    },
                    {
                        "id": "450903",
                        "label": "福绵区"
                    },
                    {
                        "id": "450921",
                        "label": "容县"
                    },
                    {
                        "id": "450922",
                        "label": "陆川县"
                    },
                    {
                        "id": "450923",
                        "label": "博白县"
                    },
                    {
                        "id": "450924",
                        "label": "兴业县"
                    },
                    {
                        "id": "450981",
                        "label": "北流市"
                    }
                ]
            },
            {
                "id": "451000",
                "label": "百色市",
                "children": [
                    {
                        "id": "451002",
                        "label": "右江区"
                    },
                    {
                        "id": "451021",
                        "label": "田阳县"
                    },
                    {
                        "id": "451022",
                        "label": "田东县"
                    },
                    {
                        "id": "451023",
                        "label": "平果县"
                    },
                    {
                        "id": "451024",
                        "label": "德保县"
                    },
                    {
                        "id": "451025",
                        "label": "靖西县"
                    },
                    {
                        "id": "451026",
                        "label": "那坡县"
                    },
                    {
                        "id": "451027",
                        "label": "凌云县"
                    },
                    {
                        "id": "451028",
                        "label": "乐业县"
                    },
                    {
                        "id": "451029",
                        "label": "田林县"
                    },
                    {
                        "id": "451030",
                        "label": "西林县"
                    },
                    {
                        "id": "451031",
                        "label": "隆林各族自治县"
                    }
                ]
            },
            {
                "id": "451100",
                "label": "贺州市",
                "children": [
                    {
                        "id": "451102",
                        "label": "八步区"
                    },
                    {
                        "id": "451121",
                        "label": "昭平县"
                    },
                    {
                        "id": "451122",
                        "label": "钟山县"
                    },
                    {
                        "id": "451123",
                        "label": "富川瑶族自治县"
                    }
                ]
            },
            {
                "id": "451200",
                "label": "河池市",
                "children": [
                    {
                        "id": "451202",
                        "label": "金城江区"
                    },
                    {
                        "id": "451221",
                        "label": "南丹县"
                    },
                    {
                        "id": "451222",
                        "label": "天峨县"
                    },
                    {
                        "id": "451223",
                        "label": "凤山县"
                    },
                    {
                        "id": "451224",
                        "label": "东兰县"
                    },
                    {
                        "id": "451225",
                        "label": "罗城仫佬族自治县"
                    },
                    {
                        "id": "451226",
                        "label": "环江毛南族自治县"
                    },
                    {
                        "id": "451227",
                        "label": "巴马瑶族自治县"
                    },
                    {
                        "id": "451228",
                        "label": "都安瑶族自治县"
                    },
                    {
                        "id": "451229",
                        "label": "大化瑶族自治县"
                    },
                    {
                        "id": "451281",
                        "label": "宜州市"
                    }
                ]
            },
            {
                "id": "451300",
                "label": "来宾市",
                "children": [
                    {
                        "id": "451302",
                        "label": "兴宾区"
                    },
                    {
                        "id": "451321",
                        "label": "忻城县"
                    },
                    {
                        "id": "451322",
                        "label": "象州县"
                    },
                    {
                        "id": "451323",
                        "label": "武宣县"
                    },
                    {
                        "id": "451324",
                        "label": "金秀瑶族自治县"
                    },
                    {
                        "id": "451381",
                        "label": "合山市"
                    }
                ]
            },
            {
                "id": "451400",
                "label": "崇左市",
                "children": [
                    {
                        "id": "451402",
                        "label": "江州区"
                    },
                    {
                        "id": "451421",
                        "label": "扶绥县"
                    },
                    {
                        "id": "451422",
                        "label": "宁明县"
                    },
                    {
                        "id": "451423",
                        "label": "龙州县"
                    },
                    {
                        "id": "451424",
                        "label": "大新县"
                    },
                    {
                        "id": "451425",
                        "label": "天等县"
                    },
                    {
                        "id": "451481",
                        "label": "凭祥市"
                    }
                ]
            }
        ]
    },
    {
        "id": "460000",
        "label": "海南省",
        "children": [
            {
                "id": "460100",
                "label": "海口市",
                "children": [
                    {
                        "id": "460105",
                        "label": "秀英区"
                    },
                    {
                        "id": "460106",
                        "label": "龙华区"
                    },
                    {
                        "id": "460107",
                        "label": "琼山区"
                    },
                    {
                        "id": "460108",
                        "label": "美兰区"
                    }
                ]
            },
            {
                "id": "460200",
                "label": "三亚市",
                "children": []
            },
            {
                "id": "460300",
                "label": "三沙市",
                "children": [
                    {
                        "id": "460321",
                        "label": "西沙群岛"
                    },
                    {
                        "id": "460322",
                        "label": "南沙群岛"
                    },
                    {
                        "id": "460323",
                        "label": "中沙群岛的岛礁及其海域"
                    }
                ]
            },
            {
                "id": "469000",
                "label": "省直辖县级行政区划",
                "children": [
                    {
                        "id": "469001",
                        "label": "五指山市"
                    },
                    {
                        "id": "469002",
                        "label": "琼海市"
                    },
                    {
                        "id": "469003",
                        "label": "儋州市"
                    },
                    {
                        "id": "469005",
                        "label": "文昌市"
                    },
                    {
                        "id": "469006",
                        "label": "万宁市"
                    },
                    {
                        "id": "469007",
                        "label": "东方市"
                    },
                    {
                        "id": "469021",
                        "label": "定安县"
                    },
                    {
                        "id": "469022",
                        "label": "屯昌县"
                    },
                    {
                        "id": "469023",
                        "label": "澄迈县"
                    },
                    {
                        "id": "469024",
                        "label": "临高县"
                    },
                    {
                        "id": "469025",
                        "label": "白沙黎族自治县"
                    },
                    {
                        "id": "469026",
                        "label": "昌江黎族自治县"
                    },
                    {
                        "id": "469027",
                        "label": "乐东黎族自治县"
                    },
                    {
                        "id": "469028",
                        "label": "陵水黎族自治县"
                    },
                    {
                        "id": "469029",
                        "label": "保亭黎族苗族自治县"
                    },
                    {
                        "id": "469030",
                        "label": "琼中黎族苗族自治县"
                    }
                ]
            }
        ]
    },
    {
        "id": "500000",
        "label": "重庆市",
        "children": [
            {
                "id": "500100",
                "label": "重庆市",
                "children": [
                    {
                        "id": "500101",
                        "label": "万州区"
                    },
                    {
                        "id": "500102",
                        "label": "涪陵区"
                    },
                    {
                        "id": "500103",
                        "label": "渝中区"
                    },
                    {
                        "id": "500104",
                        "label": "大渡口区"
                    },
                    {
                        "id": "500105",
                        "label": "江北区"
                    },
                    {
                        "id": "500106",
                        "label": "沙坪坝区"
                    },
                    {
                        "id": "500107",
                        "label": "九龙坡区"
                    },
                    {
                        "id": "500108",
                        "label": "南岸区"
                    },
                    {
                        "id": "500109",
                        "label": "北碚区"
                    },
                    {
                        "id": "500110",
                        "label": "綦江区"
                    },
                    {
                        "id": "500111",
                        "label": "大足区"
                    },
                    {
                        "id": "500112",
                        "label": "渝北区"
                    },
                    {
                        "id": "500113",
                        "label": "巴南区"
                    },
                    {
                        "id": "500114",
                        "label": "黔江区"
                    },
                    {
                        "id": "500115",
                        "label": "长寿区"
                    },
                    {
                        "id": "500116",
                        "label": "江津区"
                    },
                    {
                        "id": "500117",
                        "label": "合川区"
                    },
                    {
                        "id": "500118",
                        "label": "永川区"
                    },
                    {
                        "id": "500119",
                        "label": "南川区"
                    }
                ]
            }
        ]
    },
    {
        "id": "510000",
        "label": "四川省",
        "children": [
            {
                "id": "510100",
                "label": "成都市",
                "children": [
                    {
                        "id": "510104",
                        "label": "锦江区"
                    },
                    {
                        "id": "510105",
                        "label": "青羊区"
                    },
                    {
                        "id": "510106",
                        "label": "金牛区"
                    },
                    {
                        "id": "510107",
                        "label": "武侯区"
                    },
                    {
                        "id": "510108",
                        "label": "成华区"
                    },
                    {
                        "id": "510112",
                        "label": "龙泉驿区"
                    },
                    {
                        "id": "510113",
                        "label": "青白江区"
                    },
                    {
                        "id": "510114",
                        "label": "新都区"
                    },
                    {
                        "id": "510115",
                        "label": "温江区"
                    },
                    {
                        "id": "510121",
                        "label": "金堂县"
                    },
                    {
                        "id": "510122",
                        "label": "双流县"
                    },
                    {
                        "id": "510124",
                        "label": "郫县"
                    },
                    {
                        "id": "510129",
                        "label": "大邑县"
                    },
                    {
                        "id": "510131",
                        "label": "蒲江县"
                    },
                    {
                        "id": "510132",
                        "label": "新津县"
                    },
                    {
                        "id": "510181",
                        "label": "都江堰市"
                    },
                    {
                        "id": "510182",
                        "label": "彭州市"
                    },
                    {
                        "id": "510183",
                        "label": "邛崃市"
                    },
                    {
                        "id": "510184",
                        "label": "崇州市"
                    }
                ]
            },
            {
                "id": "510300",
                "label": "自贡市",
                "children": [
                    {
                        "id": "510302",
                        "label": "自流井区"
                    },
                    {
                        "id": "510303",
                        "label": "贡井区"
                    },
                    {
                        "id": "510304",
                        "label": "大安区"
                    },
                    {
                        "id": "510311",
                        "label": "沿滩区"
                    },
                    {
                        "id": "510321",
                        "label": "荣县"
                    },
                    {
                        "id": "510322",
                        "label": "富顺县"
                    }
                ]
            },
            {
                "id": "510400",
                "label": "攀枝花市",
                "children": [
                    {
                        "id": "510402",
                        "label": "东区"
                    },
                    {
                        "id": "510403",
                        "label": "西区"
                    },
                    {
                        "id": "510411",
                        "label": "仁和区"
                    },
                    {
                        "id": "510421",
                        "label": "米易县"
                    },
                    {
                        "id": "510422",
                        "label": "盐边县"
                    }
                ]
            },
            {
                "id": "510500",
                "label": "泸州市",
                "children": [
                    {
                        "id": "510502",
                        "label": "江阳区"
                    },
                    {
                        "id": "510503",
                        "label": "纳溪区"
                    },
                    {
                        "id": "510504",
                        "label": "龙马潭区"
                    },
                    {
                        "id": "510521",
                        "label": "泸县"
                    },
                    {
                        "id": "510522",
                        "label": "合江县"
                    },
                    {
                        "id": "510524",
                        "label": "叙永县"
                    },
                    {
                        "id": "510525",
                        "label": "古蔺县"
                    }
                ]
            },
            {
                "id": "510600",
                "label": "德阳市",
                "children": [
                    {
                        "id": "510603",
                        "label": "旌阳区"
                    },
                    {
                        "id": "510623",
                        "label": "中江县"
                    },
                    {
                        "id": "510626",
                        "label": "罗江县"
                    },
                    {
                        "id": "510681",
                        "label": "广汉市"
                    },
                    {
                        "id": "510682",
                        "label": "什邡市"
                    },
                    {
                        "id": "510683",
                        "label": "绵竹市"
                    }
                ]
            },
            {
                "id": "510700",
                "label": "绵阳市",
                "children": [
                    {
                        "id": "510703",
                        "label": "涪城区"
                    },
                    {
                        "id": "510704",
                        "label": "游仙区"
                    },
                    {
                        "id": "510722",
                        "label": "三台县"
                    },
                    {
                        "id": "510723",
                        "label": "盐亭县"
                    },
                    {
                        "id": "510724",
                        "label": "安县"
                    },
                    {
                        "id": "510725",
                        "label": "梓潼县"
                    },
                    {
                        "id": "510726",
                        "label": "北川羌族自治县"
                    },
                    {
                        "id": "510727",
                        "label": "平武县"
                    },
                    {
                        "id": "510781",
                        "label": "江油市"
                    }
                ]
            },
            {
                "id": "510800",
                "label": "广元市",
                "children": [
                    {
                        "id": "510802",
                        "label": "利州区"
                    },
                    {
                        "id": "510811",
                        "label": "元坝区"
                    },
                    {
                        "id": "510812",
                        "label": "朝天区"
                    },
                    {
                        "id": "510821",
                        "label": "旺苍县"
                    },
                    {
                        "id": "510822",
                        "label": "青川县"
                    },
                    {
                        "id": "510823",
                        "label": "剑阁县"
                    },
                    {
                        "id": "510824",
                        "label": "苍溪县"
                    }
                ]
            },
            {
                "id": "510900",
                "label": "遂宁市",
                "children": [
                    {
                        "id": "510903",
                        "label": "船山区"
                    },
                    {
                        "id": "510904",
                        "label": "安居区"
                    },
                    {
                        "id": "510921",
                        "label": "蓬溪县"
                    },
                    {
                        "id": "510922",
                        "label": "射洪县"
                    },
                    {
                        "id": "510923",
                        "label": "大英县"
                    }
                ]
            },
            {
                "id": "511000",
                "label": "内江市",
                "children": [
                    {
                        "id": "511002",
                        "label": "市中区"
                    },
                    {
                        "id": "511011",
                        "label": "东兴区"
                    },
                    {
                        "id": "511024",
                        "label": "威远县"
                    },
                    {
                        "id": "511025",
                        "label": "资中县"
                    },
                    {
                        "id": "511028",
                        "label": "隆昌县"
                    }
                ]
            },
            {
                "id": "511100",
                "label": "乐山市",
                "children": [
                    {
                        "id": "511102",
                        "label": "市中区"
                    },
                    {
                        "id": "511111",
                        "label": "沙湾区"
                    },
                    {
                        "id": "511112",
                        "label": "五通桥区"
                    },
                    {
                        "id": "511113",
                        "label": "金口河区"
                    },
                    {
                        "id": "511123",
                        "label": "犍为县"
                    },
                    {
                        "id": "511124",
                        "label": "井研县"
                    },
                    {
                        "id": "511126",
                        "label": "夹江县"
                    },
                    {
                        "id": "511129",
                        "label": "沐川县"
                    },
                    {
                        "id": "511132",
                        "label": "峨边彝族自治县"
                    },
                    {
                        "id": "511133",
                        "label": "马边彝族自治县"
                    },
                    {
                        "id": "511181",
                        "label": "峨眉山市"
                    }
                ]
            },
            {
                "id": "511300",
                "label": "南充市",
                "children": [
                    {
                        "id": "511302",
                        "label": "顺庆区"
                    },
                    {
                        "id": "511303",
                        "label": "高坪区"
                    },
                    {
                        "id": "511304",
                        "label": "嘉陵区"
                    },
                    {
                        "id": "511321",
                        "label": "南部县"
                    },
                    {
                        "id": "511322",
                        "label": "营山县"
                    },
                    {
                        "id": "511323",
                        "label": "蓬安县"
                    },
                    {
                        "id": "511324",
                        "label": "仪陇县"
                    },
                    {
                        "id": "511325",
                        "label": "西充县"
                    },
                    {
                        "id": "511381",
                        "label": "阆中市"
                    }
                ]
            },
            {
                "id": "511400",
                "label": "眉山市",
                "children": [
                    {
                        "id": "511402",
                        "label": "东坡区"
                    },
                    {
                        "id": "511421",
                        "label": "仁寿县"
                    },
                    {
                        "id": "511422",
                        "label": "彭山县"
                    },
                    {
                        "id": "511423",
                        "label": "洪雅县"
                    },
                    {
                        "id": "511424",
                        "label": "丹棱县"
                    },
                    {
                        "id": "511425",
                        "label": "青神县"
                    }
                ]
            },
            {
                "id": "511500",
                "label": "宜宾市",
                "children": [
                    {
                        "id": "511502",
                        "label": "翠屏区"
                    },
                    {
                        "id": "511503",
                        "label": "南溪区"
                    },
                    {
                        "id": "511521",
                        "label": "宜宾县"
                    },
                    {
                        "id": "511523",
                        "label": "江安县"
                    },
                    {
                        "id": "511524",
                        "label": "长宁县"
                    },
                    {
                        "id": "511525",
                        "label": "高县"
                    },
                    {
                        "id": "511526",
                        "label": "珙县"
                    },
                    {
                        "id": "511527",
                        "label": "筠连县"
                    },
                    {
                        "id": "511528",
                        "label": "兴文县"
                    },
                    {
                        "id": "511529",
                        "label": "屏山县"
                    }
                ]
            },
            {
                "id": "511600",
                "label": "广安市",
                "children": [
                    {
                        "id": "511602",
                        "label": "广安区"
                    },
                    {
                        "id": "511603",
                        "label": "前锋区"
                    },
                    {
                        "id": "511621",
                        "label": "岳池县"
                    },
                    {
                        "id": "511622",
                        "label": "武胜县"
                    },
                    {
                        "id": "511623",
                        "label": "邻水县"
                    },
                    {
                        "id": "511681",
                        "label": "华蓥市"
                    }
                ]
            },
            {
                "id": "511700",
                "label": "达州市",
                "children": [
                    {
                        "id": "511702",
                        "label": "通川区"
                    },
                    {
                        "id": "511703",
                        "label": "达川区"
                    },
                    {
                        "id": "511722",
                        "label": "宣汉县"
                    },
                    {
                        "id": "511723",
                        "label": "开江县"
                    },
                    {
                        "id": "511724",
                        "label": "大竹县"
                    },
                    {
                        "id": "511725",
                        "label": "渠县"
                    },
                    {
                        "id": "511781",
                        "label": "万源市"
                    }
                ]
            },
            {
                "id": "511800",
                "label": "雅安市",
                "children": [
                    {
                        "id": "511802",
                        "label": "雨城区"
                    },
                    {
                        "id": "511803",
                        "label": "名山区"
                    },
                    {
                        "id": "511822",
                        "label": "荥经县"
                    },
                    {
                        "id": "511823",
                        "label": "汉源县"
                    },
                    {
                        "id": "511824",
                        "label": "石棉县"
                    },
                    {
                        "id": "511825",
                        "label": "天全县"
                    },
                    {
                        "id": "511826",
                        "label": "芦山县"
                    },
                    {
                        "id": "511827",
                        "label": "宝兴县"
                    }
                ]
            },
            {
                "id": "511900",
                "label": "巴中市",
                "children": [
                    {
                        "id": "511902",
                        "label": "巴州区"
                    },
                    {
                        "id": "511903",
                        "label": "恩阳区"
                    },
                    {
                        "id": "511921",
                        "label": "通江县"
                    },
                    {
                        "id": "511922",
                        "label": "南江县"
                    },
                    {
                        "id": "511923",
                        "label": "平昌县"
                    }
                ]
            },
            {
                "id": "512000",
                "label": "资阳市",
                "children": [
                    {
                        "id": "512002",
                        "label": "雁江区"
                    },
                    {
                        "id": "512021",
                        "label": "安岳县"
                    },
                    {
                        "id": "512022",
                        "label": "乐至县"
                    },
                    {
                        "id": "512081",
                        "label": "简阳市"
                    }
                ]
            },
            {
                "id": "513200",
                "label": "阿坝藏族羌族自治州",
                "children": [
                    {
                        "id": "513221",
                        "label": "汶川县"
                    },
                    {
                        "id": "513222",
                        "label": "理县"
                    },
                    {
                        "id": "513223",
                        "label": "茂县"
                    },
                    {
                        "id": "513224",
                        "label": "松潘县"
                    },
                    {
                        "id": "513225",
                        "label": "九寨沟县"
                    },
                    {
                        "id": "513226",
                        "label": "金川县"
                    },
                    {
                        "id": "513227",
                        "label": "小金县"
                    },
                    {
                        "id": "513228",
                        "label": "黑水县"
                    },
                    {
                        "id": "513229",
                        "label": "马尔康县"
                    },
                    {
                        "id": "513230",
                        "label": "壤塘县"
                    },
                    {
                        "id": "513231",
                        "label": "阿坝县"
                    },
                    {
                        "id": "513232",
                        "label": "若尔盖县"
                    },
                    {
                        "id": "513233",
                        "label": "红原县"
                    }
                ]
            },
            {
                "id": "513300",
                "label": "甘孜藏族自治州",
                "children": [
                    {
                        "id": "513321",
                        "label": "康定县"
                    },
                    {
                        "id": "513322",
                        "label": "泸定县"
                    },
                    {
                        "id": "513323",
                        "label": "丹巴县"
                    },
                    {
                        "id": "513324",
                        "label": "九龙县"
                    },
                    {
                        "id": "513325",
                        "label": "雅江县"
                    },
                    {
                        "id": "513326",
                        "label": "道孚县"
                    },
                    {
                        "id": "513327",
                        "label": "炉霍县"
                    },
                    {
                        "id": "513328",
                        "label": "甘孜县"
                    },
                    {
                        "id": "513329",
                        "label": "新龙县"
                    },
                    {
                        "id": "513330",
                        "label": "德格县"
                    },
                    {
                        "id": "513331",
                        "label": "白玉县"
                    },
                    {
                        "id": "513332",
                        "label": "石渠县"
                    },
                    {
                        "id": "513333",
                        "label": "色达县"
                    },
                    {
                        "id": "513334",
                        "label": "理塘县"
                    },
                    {
                        "id": "513335",
                        "label": "巴塘县"
                    },
                    {
                        "id": "513336",
                        "label": "乡城县"
                    },
                    {
                        "id": "513337",
                        "label": "稻城县"
                    },
                    {
                        "id": "513338",
                        "label": "得荣县"
                    }
                ]
            },
            {
                "id": "513400",
                "label": "凉山彝族自治州",
                "children": [
                    {
                        "id": "513401",
                        "label": "西昌市"
                    },
                    {
                        "id": "513422",
                        "label": "木里藏族自治县"
                    },
                    {
                        "id": "513423",
                        "label": "盐源县"
                    },
                    {
                        "id": "513424",
                        "label": "德昌县"
                    },
                    {
                        "id": "513425",
                        "label": "会理县"
                    },
                    {
                        "id": "513426",
                        "label": "会东县"
                    },
                    {
                        "id": "513427",
                        "label": "宁南县"
                    },
                    {
                        "id": "513428",
                        "label": "普格县"
                    },
                    {
                        "id": "513429",
                        "label": "布拖县"
                    },
                    {
                        "id": "513430",
                        "label": "金阳县"
                    },
                    {
                        "id": "513431",
                        "label": "昭觉县"
                    },
                    {
                        "id": "513432",
                        "label": "喜德县"
                    },
                    {
                        "id": "513433",
                        "label": "冕宁县"
                    },
                    {
                        "id": "513434",
                        "label": "越西县"
                    },
                    {
                        "id": "513435",
                        "label": "甘洛县"
                    },
                    {
                        "id": "513436",
                        "label": "美姑县"
                    },
                    {
                        "id": "513437",
                        "label": "雷波县"
                    }
                ]
            }
        ]
    },
    {
        "id": "520000",
        "label": "贵州省",
        "children": [
            {
                "id": "520100",
                "label": "贵阳市",
                "children": [
                    {
                        "id": "520102",
                        "label": "南明区"
                    },
                    {
                        "id": "520103",
                        "label": "云岩区"
                    },
                    {
                        "id": "520111",
                        "label": "花溪区"
                    },
                    {
                        "id": "520112",
                        "label": "乌当区"
                    },
                    {
                        "id": "520113",
                        "label": "白云区"
                    },
                    {
                        "id": "520115",
                        "label": "观山湖区"
                    },
                    {
                        "id": "520121",
                        "label": "开阳县"
                    },
                    {
                        "id": "520122",
                        "label": "息烽县"
                    },
                    {
                        "id": "520123",
                        "label": "修文县"
                    },
                    {
                        "id": "520181",
                        "label": "清镇市"
                    }
                ]
            },
            {
                "id": "520200",
                "label": "六盘水市",
                "children": [
                    {
                        "id": "520201",
                        "label": "钟山区"
                    },
                    {
                        "id": "520203",
                        "label": "六枝特区"
                    },
                    {
                        "id": "520221",
                        "label": "水城县"
                    },
                    {
                        "id": "520222",
                        "label": "盘县"
                    }
                ]
            },
            {
                "id": "520300",
                "label": "遵义市",
                "children": [
                    {
                        "id": "520302",
                        "label": "红花岗区"
                    },
                    {
                        "id": "520303",
                        "label": "汇川区"
                    },
                    {
                        "id": "520321",
                        "label": "遵义县"
                    },
                    {
                        "id": "520322",
                        "label": "桐梓县"
                    },
                    {
                        "id": "520323",
                        "label": "绥阳县"
                    },
                    {
                        "id": "520324",
                        "label": "正安县"
                    },
                    {
                        "id": "520325",
                        "label": "道真仡佬族苗族自治县"
                    },
                    {
                        "id": "520326",
                        "label": "务川仡佬族苗族自治县"
                    },
                    {
                        "id": "520327",
                        "label": "凤冈县"
                    },
                    {
                        "id": "520328",
                        "label": "湄潭县"
                    },
                    {
                        "id": "520329",
                        "label": "余庆县"
                    },
                    {
                        "id": "520330",
                        "label": "习水县"
                    },
                    {
                        "id": "520381",
                        "label": "赤水市"
                    },
                    {
                        "id": "520382",
                        "label": "仁怀市"
                    }
                ]
            },
            {
                "id": "520400",
                "label": "安顺市",
                "children": [
                    {
                        "id": "520402",
                        "label": "西秀区"
                    },
                    {
                        "id": "520421",
                        "label": "平坝县"
                    },
                    {
                        "id": "520422",
                        "label": "普定县"
                    },
                    {
                        "id": "520423",
                        "label": "镇宁布依族苗族自治县"
                    },
                    {
                        "id": "520424",
                        "label": "关岭布依族苗族自治县"
                    },
                    {
                        "id": "520425",
                        "label": "紫云苗族布依族自治县"
                    }
                ]
            },
            {
                "id": "520500",
                "label": "毕节市",
                "children": [
                    {
                        "id": "520502",
                        "label": "七星关区"
                    },
                    {
                        "id": "520521",
                        "label": "大方县"
                    },
                    {
                        "id": "520522",
                        "label": "黔西县"
                    },
                    {
                        "id": "520523",
                        "label": "金沙县"
                    },
                    {
                        "id": "520524",
                        "label": "织金县"
                    },
                    {
                        "id": "520525",
                        "label": "纳雍县"
                    },
                    {
                        "id": "520526",
                        "label": "威宁彝族回族苗族自治县"
                    },
                    {
                        "id": "520527",
                        "label": "赫章县"
                    }
                ]
            },
            {
                "id": "520600",
                "label": "铜仁市",
                "children": [
                    {
                        "id": "520602",
                        "label": "碧江区"
                    },
                    {
                        "id": "520603",
                        "label": "万山区"
                    },
                    {
                        "id": "520621",
                        "label": "江口县"
                    },
                    {
                        "id": "520622",
                        "label": "玉屏侗族自治县"
                    },
                    {
                        "id": "520623",
                        "label": "石阡县"
                    },
                    {
                        "id": "520624",
                        "label": "思南县"
                    },
                    {
                        "id": "520625",
                        "label": "印江土家族苗族自治县"
                    },
                    {
                        "id": "520626",
                        "label": "德江县"
                    },
                    {
                        "id": "520627",
                        "label": "沿河土家族自治县"
                    },
                    {
                        "id": "520628",
                        "label": "松桃苗族自治县"
                    }
                ]
            },
            {
                "id": "522300",
                "label": "黔西南布依族苗族自治州",
                "children": [
                    {
                        "id": "522301",
                        "label": "兴义市"
                    },
                    {
                        "id": "522322",
                        "label": "兴仁县"
                    },
                    {
                        "id": "522323",
                        "label": "普安县"
                    },
                    {
                        "id": "522324",
                        "label": "晴隆县"
                    },
                    {
                        "id": "522325",
                        "label": "贞丰县"
                    },
                    {
                        "id": "522326",
                        "label": "望谟县"
                    },
                    {
                        "id": "522327",
                        "label": "册亨县"
                    },
                    {
                        "id": "522328",
                        "label": "安龙县"
                    }
                ]
            },
            {
                "id": "522600",
                "label": "黔东南苗族侗族自治州",
                "children": [
                    {
                        "id": "522601",
                        "label": "凯里市"
                    },
                    {
                        "id": "522622",
                        "label": "黄平县"
                    },
                    {
                        "id": "522623",
                        "label": "施秉县"
                    },
                    {
                        "id": "522624",
                        "label": "三穗县"
                    },
                    {
                        "id": "522625",
                        "label": "镇远县"
                    },
                    {
                        "id": "522626",
                        "label": "岑巩县"
                    },
                    {
                        "id": "522627",
                        "label": "天柱县"
                    },
                    {
                        "id": "522628",
                        "label": "锦屏县"
                    },
                    {
                        "id": "522629",
                        "label": "剑河县"
                    },
                    {
                        "id": "522630",
                        "label": "台江县"
                    },
                    {
                        "id": "522631",
                        "label": "黎平县"
                    },
                    {
                        "id": "522632",
                        "label": "榕江县"
                    },
                    {
                        "id": "522633",
                        "label": "从江县"
                    },
                    {
                        "id": "522634",
                        "label": "雷山县"
                    },
                    {
                        "id": "522635",
                        "label": "麻江县"
                    },
                    {
                        "id": "522636",
                        "label": "丹寨县"
                    }
                ]
            },
            {
                "id": "522700",
                "label": "黔南布依族苗族自治州",
                "children": [
                    {
                        "id": "522701",
                        "label": "都匀市"
                    },
                    {
                        "id": "522702",
                        "label": "福泉市"
                    },
                    {
                        "id": "522722",
                        "label": "荔波县"
                    },
                    {
                        "id": "522723",
                        "label": "贵定县"
                    },
                    {
                        "id": "522725",
                        "label": "瓮安县"
                    },
                    {
                        "id": "522726",
                        "label": "独山县"
                    },
                    {
                        "id": "522727",
                        "label": "平塘县"
                    },
                    {
                        "id": "522728",
                        "label": "罗甸县"
                    },
                    {
                        "id": "522729",
                        "label": "长顺县"
                    },
                    {
                        "id": "522730",
                        "label": "龙里县"
                    },
                    {
                        "id": "522731",
                        "label": "惠水县"
                    },
                    {
                        "id": "522732",
                        "label": "三都水族自治县"
                    }
                ]
            }
        ]
    },
    {
        "id": "530000",
        "label": "云南省",
        "children": [
            {
                "id": "530100",
                "label": "昆明市",
                "children": [
                    {
                        "id": "530102",
                        "label": "五华区"
                    },
                    {
                        "id": "530103",
                        "label": "盘龙区"
                    },
                    {
                        "id": "530111",
                        "label": "官渡区"
                    },
                    {
                        "id": "530112",
                        "label": "西山区"
                    },
                    {
                        "id": "530113",
                        "label": "东川区"
                    },
                    {
                        "id": "530114",
                        "label": "呈贡区"
                    },
                    {
                        "id": "530122",
                        "label": "晋宁县"
                    },
                    {
                        "id": "530124",
                        "label": "富民县"
                    },
                    {
                        "id": "530125",
                        "label": "宜良县"
                    },
                    {
                        "id": "530126",
                        "label": "石林彝族自治县"
                    },
                    {
                        "id": "530127",
                        "label": "嵩明县"
                    },
                    {
                        "id": "530128",
                        "label": "禄劝彝族苗族自治县"
                    },
                    {
                        "id": "530129",
                        "label": "寻甸回族彝族自治县"
                    },
                    {
                        "id": "530181",
                        "label": "安宁市"
                    }
                ]
            },
            {
                "id": "530300",
                "label": "曲靖市",
                "children": [
                    {
                        "id": "530302",
                        "label": "麒麟区"
                    },
                    {
                        "id": "530321",
                        "label": "马龙县"
                    },
                    {
                        "id": "530322",
                        "label": "陆良县"
                    },
                    {
                        "id": "530323",
                        "label": "师宗县"
                    },
                    {
                        "id": "530324",
                        "label": "罗平县"
                    },
                    {
                        "id": "530325",
                        "label": "富源县"
                    },
                    {
                        "id": "530326",
                        "label": "会泽县"
                    },
                    {
                        "id": "530328",
                        "label": "沾益县"
                    },
                    {
                        "id": "530381",
                        "label": "宣威市"
                    }
                ]
            },
            {
                "id": "530400",
                "label": "玉溪市",
                "children": [
                    {
                        "id": "530402",
                        "label": "红塔区"
                    },
                    {
                        "id": "530421",
                        "label": "江川县"
                    },
                    {
                        "id": "530422",
                        "label": "澄江县"
                    },
                    {
                        "id": "530423",
                        "label": "通海县"
                    },
                    {
                        "id": "530424",
                        "label": "华宁县"
                    },
                    {
                        "id": "530425",
                        "label": "易门县"
                    },
                    {
                        "id": "530426",
                        "label": "峨山彝族自治县"
                    },
                    {
                        "id": "530427",
                        "label": "新平彝族傣族自治县"
                    },
                    {
                        "id": "530428",
                        "label": "元江哈尼族彝族傣族自治县"
                    }
                ]
            },
            {
                "id": "530500",
                "label": "保山市",
                "children": [
                    {
                        "id": "530502",
                        "label": "隆阳区"
                    },
                    {
                        "id": "530521",
                        "label": "施甸县"
                    },
                    {
                        "id": "530522",
                        "label": "腾冲县"
                    },
                    {
                        "id": "530523",
                        "label": "龙陵县"
                    },
                    {
                        "id": "530524",
                        "label": "昌宁县"
                    }
                ]
            },
            {
                "id": "530600",
                "label": "昭通市",
                "children": [
                    {
                        "id": "530602",
                        "label": "昭阳区"
                    },
                    {
                        "id": "530621",
                        "label": "鲁甸县"
                    },
                    {
                        "id": "530622",
                        "label": "巧家县"
                    },
                    {
                        "id": "530623",
                        "label": "盐津县"
                    },
                    {
                        "id": "530624",
                        "label": "大关县"
                    },
                    {
                        "id": "530625",
                        "label": "永善县"
                    },
                    {
                        "id": "530626",
                        "label": "绥江县"
                    },
                    {
                        "id": "530627",
                        "label": "镇雄县"
                    },
                    {
                        "id": "530628",
                        "label": "彝良县"
                    },
                    {
                        "id": "530629",
                        "label": "威信县"
                    },
                    {
                        "id": "530630",
                        "label": "水富县"
                    }
                ]
            },
            {
                "id": "530700",
                "label": "丽江市",
                "children": [
                    {
                        "id": "530702",
                        "label": "古城区"
                    },
                    {
                        "id": "530721",
                        "label": "玉龙纳西族自治县"
                    },
                    {
                        "id": "530722",
                        "label": "永胜县"
                    },
                    {
                        "id": "530723",
                        "label": "华坪县"
                    },
                    {
                        "id": "530724",
                        "label": "宁蒗彝族自治县"
                    }
                ]
            },
            {
                "id": "530800",
                "label": "普洱市",
                "children": [
                    {
                        "id": "530802",
                        "label": "思茅区"
                    },
                    {
                        "id": "530821",
                        "label": "宁洱哈尼族彝族自治县"
                    },
                    {
                        "id": "530822",
                        "label": "墨江哈尼族自治县"
                    },
                    {
                        "id": "530823",
                        "label": "景东彝族自治县"
                    },
                    {
                        "id": "530824",
                        "label": "景谷傣族彝族自治县"
                    },
                    {
                        "id": "530825",
                        "label": "镇沅彝族哈尼族拉祜族自治县"
                    },
                    {
                        "id": "530826",
                        "label": "江城哈尼族彝族自治县"
                    },
                    {
                        "id": "530827",
                        "label": "孟连傣族拉祜族佤族自治县"
                    },
                    {
                        "id": "530828",
                        "label": "澜沧拉祜族自治县"
                    },
                    {
                        "id": "530829",
                        "label": "西盟佤族自治县"
                    }
                ]
            },
            {
                "id": "530900",
                "label": "临沧市",
                "children": [
                    {
                        "id": "530902",
                        "label": "临翔区"
                    },
                    {
                        "id": "530921",
                        "label": "凤庆县"
                    },
                    {
                        "id": "530922",
                        "label": "云县"
                    },
                    {
                        "id": "530923",
                        "label": "永德县"
                    },
                    {
                        "id": "530924",
                        "label": "镇康县"
                    },
                    {
                        "id": "530925",
                        "label": "双江拉祜族佤族布朗族傣族自治县"
                    },
                    {
                        "id": "530926",
                        "label": "耿马傣族佤族自治县"
                    },
                    {
                        "id": "530927",
                        "label": "沧源佤族自治县"
                    }
                ]
            },
            {
                "id": "532300",
                "label": "楚雄彝族自治州",
                "children": [
                    {
                        "id": "532301",
                        "label": "楚雄市"
                    },
                    {
                        "id": "532322",
                        "label": "双柏县"
                    },
                    {
                        "id": "532323",
                        "label": "牟定县"
                    },
                    {
                        "id": "532324",
                        "label": "南华县"
                    },
                    {
                        "id": "532325",
                        "label": "姚安县"
                    },
                    {
                        "id": "532326",
                        "label": "大姚县"
                    },
                    {
                        "id": "532327",
                        "label": "永仁县"
                    },
                    {
                        "id": "532328",
                        "label": "元谋县"
                    },
                    {
                        "id": "532329",
                        "label": "武定县"
                    },
                    {
                        "id": "532331",
                        "label": "禄丰县"
                    }
                ]
            },
            {
                "id": "532500",
                "label": "红河哈尼族彝族自治州",
                "children": [
                    {
                        "id": "532501",
                        "label": "个旧市"
                    },
                    {
                        "id": "532502",
                        "label": "开远市"
                    },
                    {
                        "id": "532503",
                        "label": "蒙自市"
                    },
                    {
                        "id": "532504",
                        "label": "弥勒市"
                    },
                    {
                        "id": "532523",
                        "label": "屏边苗族自治县"
                    },
                    {
                        "id": "532524",
                        "label": "建水县"
                    },
                    {
                        "id": "532525",
                        "label": "石屏县"
                    },
                    {
                        "id": "532527",
                        "label": "泸西县"
                    },
                    {
                        "id": "532528",
                        "label": "元阳县"
                    },
                    {
                        "id": "532529",
                        "label": "红河县"
                    },
                    {
                        "id": "532530",
                        "label": "金平苗族瑶族傣族自治县"
                    },
                    {
                        "id": "532531",
                        "label": "绿春县"
                    },
                    {
                        "id": "532532",
                        "label": "河口瑶族自治县"
                    }
                ]
            },
            {
                "id": "532600",
                "label": "文山壮族苗族自治州",
                "children": [
                    {
                        "id": "532601",
                        "label": "文山市"
                    },
                    {
                        "id": "532622",
                        "label": "砚山县"
                    },
                    {
                        "id": "532623",
                        "label": "西畴县"
                    },
                    {
                        "id": "532624",
                        "label": "麻栗坡县"
                    },
                    {
                        "id": "532625",
                        "label": "马关县"
                    },
                    {
                        "id": "532626",
                        "label": "丘北县"
                    },
                    {
                        "id": "532627",
                        "label": "广南县"
                    },
                    {
                        "id": "532628",
                        "label": "富宁县"
                    }
                ]
            },
            {
                "id": "532800",
                "label": "西双版纳傣族自治州",
                "children": [
                    {
                        "id": "532801",
                        "label": "景洪市"
                    },
                    {
                        "id": "532822",
                        "label": "勐海县"
                    },
                    {
                        "id": "532823",
                        "label": "勐腊县"
                    }
                ]
            },
            {
                "id": "532900",
                "label": "大理白族自治州",
                "children": [
                    {
                        "id": "532901",
                        "label": "大理市"
                    },
                    {
                        "id": "532922",
                        "label": "漾濞彝族自治县"
                    },
                    {
                        "id": "532923",
                        "label": "祥云县"
                    },
                    {
                        "id": "532924",
                        "label": "宾川县"
                    },
                    {
                        "id": "532925",
                        "label": "弥渡县"
                    },
                    {
                        "id": "532926",
                        "label": "南涧彝族自治县"
                    },
                    {
                        "id": "532927",
                        "label": "巍山彝族回族自治县"
                    },
                    {
                        "id": "532928",
                        "label": "永平县"
                    },
                    {
                        "id": "532929",
                        "label": "云龙县"
                    },
                    {
                        "id": "532930",
                        "label": "洱源县"
                    },
                    {
                        "id": "532931",
                        "label": "剑川县"
                    },
                    {
                        "id": "532932",
                        "label": "鹤庆县"
                    }
                ]
            },
            {
                "id": "533100",
                "label": "德宏傣族景颇族自治州",
                "children": [
                    {
                        "id": "533102",
                        "label": "瑞丽市"
                    },
                    {
                        "id": "533103",
                        "label": "芒市"
                    },
                    {
                        "id": "533122",
                        "label": "梁河县"
                    },
                    {
                        "id": "533123",
                        "label": "盈江县"
                    },
                    {
                        "id": "533124",
                        "label": "陇川县"
                    }
                ]
            },
            {
                "id": "533300",
                "label": "怒江傈僳族自治州",
                "children": [
                    {
                        "id": "533321",
                        "label": "泸水县"
                    },
                    {
                        "id": "533323",
                        "label": "福贡县"
                    },
                    {
                        "id": "533324",
                        "label": "贡山独龙族怒族自治县"
                    },
                    {
                        "id": "533325",
                        "label": "兰坪白族普米族自治县"
                    }
                ]
            },
            {
                "id": "533400",
                "label": "迪庆藏族自治州",
                "children": [
                    {
                        "id": "533421",
                        "label": "香格里拉县"
                    },
                    {
                        "id": "533422",
                        "label": "德钦县"
                    },
                    {
                        "id": "533423",
                        "label": "维西傈僳族自治县"
                    }
                ]
            }
        ]
    },
    {
        "id": "540000",
        "label": "西藏自治区",
        "children": [
            {
                "id": "540100",
                "label": "拉萨市",
                "children": [
                    {
                        "id": "540102",
                        "label": "城关区"
                    },
                    {
                        "id": "540121",
                        "label": "林周县"
                    },
                    {
                        "id": "540122",
                        "label": "当雄县"
                    },
                    {
                        "id": "540123",
                        "label": "尼木县"
                    },
                    {
                        "id": "540124",
                        "label": "曲水县"
                    },
                    {
                        "id": "540125",
                        "label": "堆龙德庆县"
                    },
                    {
                        "id": "540126",
                        "label": "达孜县"
                    },
                    {
                        "id": "540127",
                        "label": "墨竹工卡县"
                    }
                ]
            },
            {
                "id": "542100",
                "label": "昌都地区",
                "children": [
                    {
                        "id": "542121",
                        "label": "昌都县"
                    },
                    {
                        "id": "542122",
                        "label": "江达县"
                    },
                    {
                        "id": "542123",
                        "label": "贡觉县"
                    },
                    {
                        "id": "542124",
                        "label": "类乌齐县"
                    },
                    {
                        "id": "542125",
                        "label": "丁青县"
                    },
                    {
                        "id": "542126",
                        "label": "察雅县"
                    },
                    {
                        "id": "542127",
                        "label": "八宿县"
                    },
                    {
                        "id": "542128",
                        "label": "左贡县"
                    },
                    {
                        "id": "542129",
                        "label": "芒康县"
                    },
                    {
                        "id": "542132",
                        "label": "洛隆县"
                    },
                    {
                        "id": "542133",
                        "label": "边坝县"
                    }
                ]
            },
            {
                "id": "542200",
                "label": "山南地区",
                "children": [
                    {
                        "id": "542221",
                        "label": "乃东县"
                    },
                    {
                        "id": "542222",
                        "label": "扎囊县"
                    },
                    {
                        "id": "542223",
                        "label": "贡嘎县"
                    },
                    {
                        "id": "542224",
                        "label": "桑日县"
                    },
                    {
                        "id": "542225",
                        "label": "琼结县"
                    },
                    {
                        "id": "542226",
                        "label": "曲松县"
                    },
                    {
                        "id": "542227",
                        "label": "措美县"
                    },
                    {
                        "id": "542228",
                        "label": "洛扎县"
                    },
                    {
                        "id": "542229",
                        "label": "加查县"
                    },
                    {
                        "id": "542231",
                        "label": "隆子县"
                    },
                    {
                        "id": "542232",
                        "label": "错那县"
                    },
                    {
                        "id": "542233",
                        "label": "浪卡子县"
                    }
                ]
            },
            {
                "id": "542300",
                "label": "日喀则地区",
                "children": [
                    {
                        "id": "542301",
                        "label": "日喀则市"
                    },
                    {
                        "id": "542322",
                        "label": "南木林县"
                    },
                    {
                        "id": "542323",
                        "label": "江孜县"
                    },
                    {
                        "id": "542324",
                        "label": "定日县"
                    },
                    {
                        "id": "542325",
                        "label": "萨迦县"
                    },
                    {
                        "id": "542326",
                        "label": "拉孜县"
                    },
                    {
                        "id": "542327",
                        "label": "昂仁县"
                    },
                    {
                        "id": "542328",
                        "label": "谢通门县"
                    },
                    {
                        "id": "542329",
                        "label": "白朗县"
                    },
                    {
                        "id": "542330",
                        "label": "仁布县"
                    },
                    {
                        "id": "542331",
                        "label": "康马县"
                    },
                    {
                        "id": "542332",
                        "label": "定结县"
                    },
                    {
                        "id": "542333",
                        "label": "仲巴县"
                    },
                    {
                        "id": "542334",
                        "label": "亚东县"
                    },
                    {
                        "id": "542335",
                        "label": "吉隆县"
                    },
                    {
                        "id": "542336",
                        "label": "聂拉木县"
                    },
                    {
                        "id": "542337",
                        "label": "萨嘎县"
                    },
                    {
                        "id": "542338",
                        "label": "岗巴县"
                    }
                ]
            },
            {
                "id": "542400",
                "label": "那曲地区",
                "children": [
                    {
                        "id": "542421",
                        "label": "那曲县"
                    },
                    {
                        "id": "542422",
                        "label": "嘉黎县"
                    },
                    {
                        "id": "542423",
                        "label": "比如县"
                    },
                    {
                        "id": "542424",
                        "label": "聂荣县"
                    },
                    {
                        "id": "542425",
                        "label": "安多县"
                    },
                    {
                        "id": "542426",
                        "label": "申扎县"
                    },
                    {
                        "id": "542427",
                        "label": "索县"
                    },
                    {
                        "id": "542428",
                        "label": "班戈县"
                    },
                    {
                        "id": "542429",
                        "label": "巴青县"
                    },
                    {
                        "id": "542430",
                        "label": "尼玛县"
                    },
                    {
                        "id": "542431",
                        "label": "双湖县"
                    }
                ]
            },
            {
                "id": "542500",
                "label": "阿里地区",
                "children": [
                    {
                        "id": "542521",
                        "label": "普兰县"
                    },
                    {
                        "id": "542522",
                        "label": "札达县"
                    },
                    {
                        "id": "542523",
                        "label": "噶尔县"
                    },
                    {
                        "id": "542524",
                        "label": "日土县"
                    },
                    {
                        "id": "542525",
                        "label": "革吉县"
                    },
                    {
                        "id": "542526",
                        "label": "改则县"
                    },
                    {
                        "id": "542527",
                        "label": "措勤县"
                    }
                ]
            },
            {
                "id": "542600",
                "label": "林芝地区",
                "children": [
                    {
                        "id": "542621",
                        "label": "林芝县"
                    },
                    {
                        "id": "542622",
                        "label": "工布江达县"
                    },
                    {
                        "id": "542623",
                        "label": "米林县"
                    },
                    {
                        "id": "542624",
                        "label": "墨脱县"
                    },
                    {
                        "id": "542625",
                        "label": "波密县"
                    },
                    {
                        "id": "542626",
                        "label": "察隅县"
                    },
                    {
                        "id": "542627",
                        "label": "朗县"
                    }
                ]
            }
        ]
    },
    {
        "id": "610000",
        "label": "陕西省",
        "children": [
            {
                "id": "610100",
                "label": "西安市",
                "children": [
                    {
                        "id": "610102",
                        "label": "新城区"
                    },
                    {
                        "id": "610103",
                        "label": "碑林区"
                    },
                    {
                        "id": "610104",
                        "label": "莲湖区"
                    },
                    {
                        "id": "610111",
                        "label": "灞桥区"
                    },
                    {
                        "id": "610112",
                        "label": "未央区"
                    },
                    {
                        "id": "610113",
                        "label": "雁塔区"
                    },
                    {
                        "id": "610114",
                        "label": "阎良区"
                    },
                    {
                        "id": "610115",
                        "label": "临潼区"
                    },
                    {
                        "id": "610116",
                        "label": "长安区"
                    },
                    {
                        "id": "610122",
                        "label": "蓝田县"
                    },
                    {
                        "id": "610124",
                        "label": "周至县"
                    },
                    {
                        "id": "610125",
                        "label": "户县"
                    },
                    {
                        "id": "610126",
                        "label": "高陵县"
                    }
                ]
            },
            {
                "id": "610200",
                "label": "铜川市",
                "children": [
                    {
                        "id": "610202",
                        "label": "王益区"
                    },
                    {
                        "id": "610203",
                        "label": "印台区"
                    },
                    {
                        "id": "610204",
                        "label": "耀州区"
                    },
                    {
                        "id": "610222",
                        "label": "宜君县"
                    }
                ]
            },
            {
                "id": "610300",
                "label": "宝鸡市",
                "children": [
                    {
                        "id": "610302",
                        "label": "渭滨区"
                    },
                    {
                        "id": "610303",
                        "label": "金台区"
                    },
                    {
                        "id": "610304",
                        "label": "陈仓区"
                    },
                    {
                        "id": "610322",
                        "label": "凤翔县"
                    },
                    {
                        "id": "610323",
                        "label": "岐山县"
                    },
                    {
                        "id": "610324",
                        "label": "扶风县"
                    },
                    {
                        "id": "610326",
                        "label": "眉县"
                    },
                    {
                        "id": "610327",
                        "label": "陇县"
                    },
                    {
                        "id": "610328",
                        "label": "千阳县"
                    },
                    {
                        "id": "610329",
                        "label": "麟游县"
                    },
                    {
                        "id": "610330",
                        "label": "凤县"
                    },
                    {
                        "id": "610331",
                        "label": "太白县"
                    }
                ]
            },
            {
                "id": "610400",
                "label": "咸阳市",
                "children": [
                    {
                        "id": "610402",
                        "label": "秦都区"
                    },
                    {
                        "id": "610403",
                        "label": "杨陵区"
                    },
                    {
                        "id": "610404",
                        "label": "渭城区"
                    },
                    {
                        "id": "610422",
                        "label": "三原县"
                    },
                    {
                        "id": "610423",
                        "label": "泾阳县"
                    },
                    {
                        "id": "610424",
                        "label": "乾县"
                    },
                    {
                        "id": "610425",
                        "label": "礼泉县"
                    },
                    {
                        "id": "610426",
                        "label": "永寿县"
                    },
                    {
                        "id": "610427",
                        "label": "彬县"
                    },
                    {
                        "id": "610428",
                        "label": "长武县"
                    },
                    {
                        "id": "610429",
                        "label": "旬邑县"
                    },
                    {
                        "id": "610430",
                        "label": "淳化县"
                    },
                    {
                        "id": "610431",
                        "label": "武功县"
                    },
                    {
                        "id": "610481",
                        "label": "兴平市"
                    }
                ]
            },
            {
                "id": "610500",
                "label": "渭南市",
                "children": [
                    {
                        "id": "610502",
                        "label": "临渭区"
                    },
                    {
                        "id": "610521",
                        "label": "华县"
                    },
                    {
                        "id": "610522",
                        "label": "潼关县"
                    },
                    {
                        "id": "610523",
                        "label": "大荔县"
                    },
                    {
                        "id": "610524",
                        "label": "合阳县"
                    },
                    {
                        "id": "610525",
                        "label": "澄城县"
                    },
                    {
                        "id": "610526",
                        "label": "蒲城县"
                    },
                    {
                        "id": "610527",
                        "label": "白水县"
                    },
                    {
                        "id": "610528",
                        "label": "富平县"
                    },
                    {
                        "id": "610581",
                        "label": "韩城市"
                    },
                    {
                        "id": "610582",
                        "label": "华阴市"
                    }
                ]
            },
            {
                "id": "610600",
                "label": "延安市",
                "children": [
                    {
                        "id": "610602",
                        "label": "宝塔区"
                    },
                    {
                        "id": "610621",
                        "label": "延长县"
                    },
                    {
                        "id": "610622",
                        "label": "延川县"
                    },
                    {
                        "id": "610623",
                        "label": "子长县"
                    },
                    {
                        "id": "610624",
                        "label": "安塞县"
                    },
                    {
                        "id": "610625",
                        "label": "志丹县"
                    },
                    {
                        "id": "610626",
                        "label": "吴起县"
                    },
                    {
                        "id": "610627",
                        "label": "甘泉县"
                    },
                    {
                        "id": "610628",
                        "label": "富县"
                    },
                    {
                        "id": "610629",
                        "label": "洛川县"
                    },
                    {
                        "id": "610630",
                        "label": "宜川县"
                    },
                    {
                        "id": "610631",
                        "label": "黄龙县"
                    },
                    {
                        "id": "610632",
                        "label": "黄陵县"
                    }
                ]
            },
            {
                "id": "610700",
                "label": "汉中市",
                "children": [
                    {
                        "id": "610702",
                        "label": "汉台区"
                    },
                    {
                        "id": "610721",
                        "label": "南郑县"
                    },
                    {
                        "id": "610722",
                        "label": "城固县"
                    },
                    {
                        "id": "610723",
                        "label": "洋县"
                    },
                    {
                        "id": "610724",
                        "label": "西乡县"
                    },
                    {
                        "id": "610725",
                        "label": "勉县"
                    },
                    {
                        "id": "610726",
                        "label": "宁强县"
                    },
                    {
                        "id": "610727",
                        "label": "略阳县"
                    },
                    {
                        "id": "610728",
                        "label": "镇巴县"
                    },
                    {
                        "id": "610729",
                        "label": "留坝县"
                    },
                    {
                        "id": "610730",
                        "label": "佛坪县"
                    }
                ]
            },
            {
                "id": "610800",
                "label": "榆林市",
                "children": [
                    {
                        "id": "610802",
                        "label": "榆阳区"
                    },
                    {
                        "id": "610821",
                        "label": "神木县"
                    },
                    {
                        "id": "610822",
                        "label": "府谷县"
                    },
                    {
                        "id": "610823",
                        "label": "横山县"
                    },
                    {
                        "id": "610824",
                        "label": "靖边县"
                    },
                    {
                        "id": "610825",
                        "label": "定边县"
                    },
                    {
                        "id": "610826",
                        "label": "绥德县"
                    },
                    {
                        "id": "610827",
                        "label": "米脂县"
                    },
                    {
                        "id": "610828",
                        "label": "佳县"
                    },
                    {
                        "id": "610829",
                        "label": "吴堡县"
                    },
                    {
                        "id": "610830",
                        "label": "清涧县"
                    },
                    {
                        "id": "610831",
                        "label": "子洲县"
                    }
                ]
            },
            {
                "id": "610900",
                "label": "安康市",
                "children": [
                    {
                        "id": "610902",
                        "label": "汉滨区"
                    },
                    {
                        "id": "610921",
                        "label": "汉阴县"
                    },
                    {
                        "id": "610922",
                        "label": "石泉县"
                    },
                    {
                        "id": "610923",
                        "label": "宁陕县"
                    },
                    {
                        "id": "610924",
                        "label": "紫阳县"
                    },
                    {
                        "id": "610925",
                        "label": "岚皋县"
                    },
                    {
                        "id": "610926",
                        "label": "平利县"
                    },
                    {
                        "id": "610927",
                        "label": "镇坪县"
                    },
                    {
                        "id": "610928",
                        "label": "旬阳县"
                    },
                    {
                        "id": "610929",
                        "label": "白河县"
                    }
                ]
            },
            {
                "id": "611000",
                "label": "商洛市",
                "children": [
                    {
                        "id": "611002",
                        "label": "商州区"
                    },
                    {
                        "id": "611021",
                        "label": "洛南县"
                    },
                    {
                        "id": "611022",
                        "label": "丹凤县"
                    },
                    {
                        "id": "611023",
                        "label": "商南县"
                    },
                    {
                        "id": "611024",
                        "label": "山阳县"
                    },
                    {
                        "id": "611025",
                        "label": "镇安县"
                    },
                    {
                        "id": "611026",
                        "label": "柞水县"
                    }
                ]
            }
        ]
    },
    {
        "id": "620000",
        "label": "甘肃省",
        "children": [
            {
                "id": "620100",
                "label": "兰州市",
                "children": [
                    {
                        "id": "620102",
                        "label": "城关区"
                    },
                    {
                        "id": "620103",
                        "label": "七里河区"
                    },
                    {
                        "id": "620104",
                        "label": "西固区"
                    },
                    {
                        "id": "620105",
                        "label": "安宁区"
                    },
                    {
                        "id": "620111",
                        "label": "红古区"
                    },
                    {
                        "id": "620121",
                        "label": "永登县"
                    },
                    {
                        "id": "620122",
                        "label": "皋兰县"
                    },
                    {
                        "id": "620123",
                        "label": "榆中县"
                    }
                ]
            },
            {
                "id": "620200",
                "label": "嘉峪关市",
                "children": []
            },
            {
                "id": "620300",
                "label": "金昌市",
                "children": [
                    {
                        "id": "620302",
                        "label": "金川区"
                    },
                    {
                        "id": "620321",
                        "label": "永昌县"
                    }
                ]
            },
            {
                "id": "620400",
                "label": "白银市",
                "children": [
                    {
                        "id": "620402",
                        "label": "白银区"
                    },
                    {
                        "id": "620403",
                        "label": "平川区"
                    },
                    {
                        "id": "620421",
                        "label": "靖远县"
                    },
                    {
                        "id": "620422",
                        "label": "会宁县"
                    },
                    {
                        "id": "620423",
                        "label": "景泰县"
                    }
                ]
            },
            {
                "id": "620500",
                "label": "天水市",
                "children": [
                    {
                        "id": "620502",
                        "label": "秦州区"
                    },
                    {
                        "id": "620503",
                        "label": "麦积区"
                    },
                    {
                        "id": "620521",
                        "label": "清水县"
                    },
                    {
                        "id": "620522",
                        "label": "秦安县"
                    },
                    {
                        "id": "620523",
                        "label": "甘谷县"
                    },
                    {
                        "id": "620524",
                        "label": "武山县"
                    },
                    {
                        "id": "620525",
                        "label": "张家川回族自治县"
                    }
                ]
            },
            {
                "id": "620600",
                "label": "武威市",
                "children": [
                    {
                        "id": "620602",
                        "label": "凉州区"
                    },
                    {
                        "id": "620621",
                        "label": "民勤县"
                    },
                    {
                        "id": "620622",
                        "label": "古浪县"
                    },
                    {
                        "id": "620623",
                        "label": "天祝藏族自治县"
                    }
                ]
            },
            {
                "id": "620700",
                "label": "张掖市",
                "children": [
                    {
                        "id": "620702",
                        "label": "甘州区"
                    },
                    {
                        "id": "620721",
                        "label": "肃南裕固族自治县"
                    },
                    {
                        "id": "620722",
                        "label": "民乐县"
                    },
                    {
                        "id": "620723",
                        "label": "临泽县"
                    },
                    {
                        "id": "620724",
                        "label": "高台县"
                    },
                    {
                        "id": "620725",
                        "label": "山丹县"
                    }
                ]
            },
            {
                "id": "620800",
                "label": "平凉市",
                "children": [
                    {
                        "id": "620802",
                        "label": "崆峒区"
                    },
                    {
                        "id": "620821",
                        "label": "泾川县"
                    },
                    {
                        "id": "620822",
                        "label": "灵台县"
                    },
                    {
                        "id": "620823",
                        "label": "崇信县"
                    },
                    {
                        "id": "620824",
                        "label": "华亭县"
                    },
                    {
                        "id": "620825",
                        "label": "庄浪县"
                    },
                    {
                        "id": "620826",
                        "label": "静宁县"
                    }
                ]
            },
            {
                "id": "620900",
                "label": "酒泉市",
                "children": [
                    {
                        "id": "620902",
                        "label": "肃州区"
                    },
                    {
                        "id": "620921",
                        "label": "金塔县"
                    },
                    {
                        "id": "620922",
                        "label": "瓜州县"
                    },
                    {
                        "id": "620923",
                        "label": "肃北蒙古族自治县"
                    },
                    {
                        "id": "620924",
                        "label": "阿克塞哈萨克族自治县"
                    },
                    {
                        "id": "620981",
                        "label": "玉门市"
                    },
                    {
                        "id": "620982",
                        "label": "敦煌市"
                    }
                ]
            },
            {
                "id": "621000",
                "label": "庆阳市",
                "children": [
                    {
                        "id": "621002",
                        "label": "西峰区"
                    },
                    {
                        "id": "621021",
                        "label": "庆城县"
                    },
                    {
                        "id": "621022",
                        "label": "环县"
                    },
                    {
                        "id": "621023",
                        "label": "华池县"
                    },
                    {
                        "id": "621024",
                        "label": "合水县"
                    },
                    {
                        "id": "621025",
                        "label": "正宁县"
                    },
                    {
                        "id": "621026",
                        "label": "宁县"
                    },
                    {
                        "id": "621027",
                        "label": "镇原县"
                    }
                ]
            },
            {
                "id": "621100",
                "label": "定西市",
                "children": [
                    {
                        "id": "621102",
                        "label": "安定区"
                    },
                    {
                        "id": "621121",
                        "label": "通渭县"
                    },
                    {
                        "id": "621122",
                        "label": "陇西县"
                    },
                    {
                        "id": "621123",
                        "label": "渭源县"
                    },
                    {
                        "id": "621124",
                        "label": "临洮县"
                    },
                    {
                        "id": "621125",
                        "label": "漳县"
                    },
                    {
                        "id": "621126",
                        "label": "岷县"
                    }
                ]
            },
            {
                "id": "621200",
                "label": "陇南市",
                "children": [
                    {
                        "id": "621202",
                        "label": "武都区"
                    },
                    {
                        "id": "621221",
                        "label": "成县"
                    },
                    {
                        "id": "621222",
                        "label": "文县"
                    },
                    {
                        "id": "621223",
                        "label": "宕昌县"
                    },
                    {
                        "id": "621224",
                        "label": "康县"
                    },
                    {
                        "id": "621225",
                        "label": "西和县"
                    },
                    {
                        "id": "621226",
                        "label": "礼县"
                    },
                    {
                        "id": "621227",
                        "label": "徽县"
                    },
                    {
                        "id": "621228",
                        "label": "两当县"
                    }
                ]
            },
            {
                "id": "622900",
                "label": "临夏回族自治州",
                "children": [
                    {
                        "id": "622901",
                        "label": "临夏市"
                    },
                    {
                        "id": "622921",
                        "label": "临夏县"
                    },
                    {
                        "id": "622922",
                        "label": "康乐县"
                    },
                    {
                        "id": "622923",
                        "label": "永靖县"
                    },
                    {
                        "id": "622924",
                        "label": "广河县"
                    },
                    {
                        "id": "622925",
                        "label": "和政县"
                    },
                    {
                        "id": "622926",
                        "label": "东乡族自治县"
                    },
                    {
                        "id": "622927",
                        "label": "积石山保安族东乡族撒拉族自治县"
                    }
                ]
            },
            {
                "id": "623000",
                "label": "甘南藏族自治州",
                "children": [
                    {
                        "id": "623001",
                        "label": "合作市"
                    },
                    {
                        "id": "623021",
                        "label": "临潭县"
                    },
                    {
                        "id": "623022",
                        "label": "卓尼县"
                    },
                    {
                        "id": "623023",
                        "label": "舟曲县"
                    },
                    {
                        "id": "623024",
                        "label": "迭部县"
                    },
                    {
                        "id": "623025",
                        "label": "玛曲县"
                    },
                    {
                        "id": "623026",
                        "label": "碌曲县"
                    },
                    {
                        "id": "623027",
                        "label": "夏河县"
                    }
                ]
            }
        ]
    },
    {
        "id": "630000",
        "label": "青海省",
        "children": [
            {
                "id": "630100",
                "label": "西宁市",
                "children": [
                    {
                        "id": "630102",
                        "label": "城东区"
                    },
                    {
                        "id": "630103",
                        "label": "城中区"
                    },
                    {
                        "id": "630104",
                        "label": "城西区"
                    },
                    {
                        "id": "630105",
                        "label": "城北区"
                    },
                    {
                        "id": "630121",
                        "label": "大通回族土族自治县"
                    },
                    {
                        "id": "630122",
                        "label": "湟中县"
                    },
                    {
                        "id": "630123",
                        "label": "湟源县"
                    }
                ]
            },
            {
                "id": "630200",
                "label": "海东市",
                "children": [
                    {
                        "id": "630202",
                        "label": "乐都区"
                    },
                    {
                        "id": "630221",
                        "label": "平安县"
                    },
                    {
                        "id": "630222",
                        "label": "民和回族土族自治县"
                    },
                    {
                        "id": "630223",
                        "label": "互助土族自治县"
                    },
                    {
                        "id": "630224",
                        "label": "化隆回族自治县"
                    },
                    {
                        "id": "630225",
                        "label": "循化撒拉族自治县"
                    }
                ]
            },
            {
                "id": "632200",
                "label": "海北藏族自治州",
                "children": [
                    {
                        "id": "632221",
                        "label": "门源回族自治县"
                    },
                    {
                        "id": "632222",
                        "label": "祁连县"
                    },
                    {
                        "id": "632223",
                        "label": "海晏县"
                    },
                    {
                        "id": "632224",
                        "label": "刚察县"
                    }
                ]
            },
            {
                "id": "632300",
                "label": "黄南藏族自治州",
                "children": [
                    {
                        "id": "632321",
                        "label": "同仁县"
                    },
                    {
                        "id": "632322",
                        "label": "尖扎县"
                    },
                    {
                        "id": "632323",
                        "label": "泽库县"
                    },
                    {
                        "id": "632324",
                        "label": "河南蒙古族自治县"
                    }
                ]
            },
            {
                "id": "632500",
                "label": "海南藏族自治州",
                "children": [
                    {
                        "id": "632521",
                        "label": "共和县"
                    },
                    {
                        "id": "632522",
                        "label": "同德县"
                    },
                    {
                        "id": "632523",
                        "label": "贵德县"
                    },
                    {
                        "id": "632524",
                        "label": "兴海县"
                    },
                    {
                        "id": "632525",
                        "label": "贵南县"
                    }
                ]
            },
            {
                "id": "632600",
                "label": "果洛藏族自治州",
                "children": [
                    {
                        "id": "632621",
                        "label": "玛沁县"
                    },
                    {
                        "id": "632622",
                        "label": "班玛县"
                    },
                    {
                        "id": "632623",
                        "label": "甘德县"
                    },
                    {
                        "id": "632624",
                        "label": "达日县"
                    },
                    {
                        "id": "632625",
                        "label": "久治县"
                    },
                    {
                        "id": "632626",
                        "label": "玛多县"
                    }
                ]
            },
            {
                "id": "632700",
                "label": "玉树藏族自治州",
                "children": [
                    {
                        "id": "632701",
                        "label": "玉树市"
                    },
                    {
                        "id": "632722",
                        "label": "杂多县"
                    },
                    {
                        "id": "632723",
                        "label": "称多县"
                    },
                    {
                        "id": "632724",
                        "label": "治多县"
                    },
                    {
                        "id": "632725",
                        "label": "囊谦县"
                    },
                    {
                        "id": "632726",
                        "label": "曲麻莱县"
                    }
                ]
            },
            {
                "id": "632800",
                "label": "海西蒙古族藏族自治州",
                "children": [
                    {
                        "id": "632801",
                        "label": "格尔木市"
                    },
                    {
                        "id": "632802",
                        "label": "德令哈市"
                    },
                    {
                        "id": "632821",
                        "label": "乌兰县"
                    },
                    {
                        "id": "632822",
                        "label": "都兰县"
                    },
                    {
                        "id": "632823",
                        "label": "天峻县"
                    }
                ]
            }
        ]
    },
    {
        "id": "640000",
        "label": "宁夏回族自治区",
        "children": [
            {
                "id": "640100",
                "label": "银川市",
                "children": [
                    {
                        "id": "640104",
                        "label": "兴庆区"
                    },
                    {
                        "id": "640105",
                        "label": "西夏区"
                    },
                    {
                        "id": "640106",
                        "label": "金凤区"
                    },
                    {
                        "id": "640121",
                        "label": "永宁县"
                    },
                    {
                        "id": "640122",
                        "label": "贺兰县"
                    },
                    {
                        "id": "640181",
                        "label": "灵武市"
                    }
                ]
            },
            {
                "id": "640200",
                "label": "石嘴山市",
                "children": [
                    {
                        "id": "640202",
                        "label": "大武口区"
                    },
                    {
                        "id": "640205",
                        "label": "惠农区"
                    },
                    {
                        "id": "640221",
                        "label": "平罗县"
                    }
                ]
            },
            {
                "id": "640300",
                "label": "吴忠市",
                "children": [
                    {
                        "id": "640302",
                        "label": "利通区"
                    },
                    {
                        "id": "640303",
                        "label": "红寺堡区"
                    },
                    {
                        "id": "640323",
                        "label": "盐池县"
                    },
                    {
                        "id": "640324",
                        "label": "同心县"
                    },
                    {
                        "id": "640381",
                        "label": "青铜峡市"
                    }
                ]
            },
            {
                "id": "640400",
                "label": "固原市",
                "children": [
                    {
                        "id": "640402",
                        "label": "原州区"
                    },
                    {
                        "id": "640422",
                        "label": "西吉县"
                    },
                    {
                        "id": "640423",
                        "label": "隆德县"
                    },
                    {
                        "id": "640424",
                        "label": "泾源县"
                    },
                    {
                        "id": "640425",
                        "label": "彭阳县"
                    }
                ]
            },
            {
                "id": "640500",
                "label": "中卫市",
                "children": [
                    {
                        "id": "640502",
                        "label": "沙坡头区"
                    },
                    {
                        "id": "640521",
                        "label": "中宁县"
                    },
                    {
                        "id": "640522",
                        "label": "海原县"
                    }
                ]
            }
        ]
    },
    {
        "id": "650000",
        "label": "新疆维吾尔自治区",
        "children": [
            {
                "id": "650100",
                "label": "乌鲁木齐市",
                "children": [
                    {
                        "id": "650102",
                        "label": "天山区"
                    },
                    {
                        "id": "650103",
                        "label": "沙依巴克区"
                    },
                    {
                        "id": "650104",
                        "label": "新市区"
                    },
                    {
                        "id": "650105",
                        "label": "水磨沟区"
                    },
                    {
                        "id": "650106",
                        "label": "头屯河区"
                    },
                    {
                        "id": "650107",
                        "label": "达坂城区"
                    },
                    {
                        "id": "650109",
                        "label": "米东区"
                    },
                    {
                        "id": "650121",
                        "label": "乌鲁木齐县"
                    }
                ]
            },
            {
                "id": "650200",
                "label": "克拉玛依市",
                "children": [
                    {
                        "id": "650202",
                        "label": "独山子区"
                    },
                    {
                        "id": "650203",
                        "label": "克拉玛依区"
                    },
                    {
                        "id": "650204",
                        "label": "白碱滩区"
                    },
                    {
                        "id": "650205",
                        "label": "乌尔禾区"
                    }
                ]
            },
            {
                "id": "652100",
                "label": "吐鲁番地区",
                "children": [
                    {
                        "id": "652101",
                        "label": "吐鲁番市"
                    },
                    {
                        "id": "652122",
                        "label": "鄯善县"
                    },
                    {
                        "id": "652123",
                        "label": "托克逊县"
                    }
                ]
            },
            {
                "id": "652200",
                "label": "哈密地区",
                "children": [
                    {
                        "id": "652201",
                        "label": "哈密市"
                    },
                    {
                        "id": "652222",
                        "label": "巴里坤哈萨克自治县"
                    },
                    {
                        "id": "652223",
                        "label": "伊吾县"
                    }
                ]
            },
            {
                "id": "652300",
                "label": "昌吉回族自治州",
                "children": [
                    {
                        "id": "652301",
                        "label": "昌吉市"
                    },
                    {
                        "id": "652302",
                        "label": "阜康市"
                    },
                    {
                        "id": "652323",
                        "label": "呼图壁县"
                    },
                    {
                        "id": "652324",
                        "label": "玛纳斯县"
                    },
                    {
                        "id": "652325",
                        "label": "奇台县"
                    },
                    {
                        "id": "652327",
                        "label": "吉木萨尔县"
                    },
                    {
                        "id": "652328",
                        "label": "木垒哈萨克自治县"
                    }
                ]
            },
            {
                "id": "652700",
                "label": "博尔塔拉蒙古自治州",
                "children": [
                    {
                        "id": "652701",
                        "label": "博乐市"
                    },
                    {
                        "id": "652702",
                        "label": "阿拉山口市"
                    },
                    {
                        "id": "652722",
                        "label": "精河县"
                    },
                    {
                        "id": "652723",
                        "label": "温泉县"
                    }
                ]
            },
            {
                "id": "652800",
                "label": "巴音郭楞蒙古自治州",
                "children": [
                    {
                        "id": "652801",
                        "label": "库尔勒市"
                    },
                    {
                        "id": "652822",
                        "label": "轮台县"
                    },
                    {
                        "id": "652823",
                        "label": "尉犁县"
                    },
                    {
                        "id": "652824",
                        "label": "若羌县"
                    },
                    {
                        "id": "652825",
                        "label": "且末县"
                    },
                    {
                        "id": "652826",
                        "label": "焉耆回族自治县"
                    },
                    {
                        "id": "652827",
                        "label": "和静县"
                    },
                    {
                        "id": "652828",
                        "label": "和硕县"
                    },
                    {
                        "id": "652829",
                        "label": "博湖县"
                    }
                ]
            },
            {
                "id": "652900",
                "label": "阿克苏地区",
                "children": [
                    {
                        "id": "652901",
                        "label": "阿克苏市"
                    },
                    {
                        "id": "652922",
                        "label": "温宿县"
                    },
                    {
                        "id": "652923",
                        "label": "库车县"
                    },
                    {
                        "id": "652924",
                        "label": "沙雅县"
                    },
                    {
                        "id": "652925",
                        "label": "新和县"
                    },
                    {
                        "id": "652926",
                        "label": "拜城县"
                    },
                    {
                        "id": "652927",
                        "label": "乌什县"
                    },
                    {
                        "id": "652928",
                        "label": "阿瓦提县"
                    },
                    {
                        "id": "652929",
                        "label": "柯坪县"
                    }
                ]
            },
            {
                "id": "653000",
                "label": "克孜勒苏柯尔克孜自治州",
                "children": [
                    {
                        "id": "653001",
                        "label": "阿图什市"
                    },
                    {
                        "id": "653022",
                        "label": "阿克陶县"
                    },
                    {
                        "id": "653023",
                        "label": "阿合奇县"
                    },
                    {
                        "id": "653024",
                        "label": "乌恰县"
                    }
                ]
            },
            {
                "id": "653100",
                "label": "喀什地区",
                "children": [
                    {
                        "id": "653101",
                        "label": "喀什市"
                    },
                    {
                        "id": "653121",
                        "label": "疏附县"
                    },
                    {
                        "id": "653122",
                        "label": "疏勒县"
                    },
                    {
                        "id": "653123",
                        "label": "英吉沙县"
                    },
                    {
                        "id": "653124",
                        "label": "泽普县"
                    },
                    {
                        "id": "653125",
                        "label": "莎车县"
                    },
                    {
                        "id": "653126",
                        "label": "叶城县"
                    },
                    {
                        "id": "653127",
                        "label": "麦盖提县"
                    },
                    {
                        "id": "653128",
                        "label": "岳普湖县"
                    },
                    {
                        "id": "653129",
                        "label": "伽师县"
                    },
                    {
                        "id": "653130",
                        "label": "巴楚县"
                    },
                    {
                        "id": "653131",
                        "label": "塔什库尔干塔吉克自治县"
                    }
                ]
            },
            {
                "id": "653200",
                "label": "和田地区",
                "children": [
                    {
                        "id": "653201",
                        "label": "和田市"
                    },
                    {
                        "id": "653221",
                        "label": "和田县"
                    },
                    {
                        "id": "653222",
                        "label": "墨玉县"
                    },
                    {
                        "id": "653223",
                        "label": "皮山县"
                    },
                    {
                        "id": "653224",
                        "label": "洛浦县"
                    },
                    {
                        "id": "653225",
                        "label": "策勒县"
                    },
                    {
                        "id": "653226",
                        "label": "于田县"
                    },
                    {
                        "id": "653227",
                        "label": "民丰县"
                    }
                ]
            },
            {
                "id": "654000",
                "label": "伊犁哈萨克自治州",
                "children": [
                    {
                        "id": "654002",
                        "label": "伊宁市"
                    },
                    {
                        "id": "654003",
                        "label": "奎屯市"
                    },
                    {
                        "id": "654021",
                        "label": "伊宁县"
                    },
                    {
                        "id": "654022",
                        "label": "察布查尔锡伯自治县"
                    },
                    {
                        "id": "654023",
                        "label": "霍城县"
                    },
                    {
                        "id": "654024",
                        "label": "巩留县"
                    },
                    {
                        "id": "654025",
                        "label": "新源县"
                    },
                    {
                        "id": "654026",
                        "label": "昭苏县"
                    },
                    {
                        "id": "654027",
                        "label": "特克斯县"
                    },
                    {
                        "id": "654028",
                        "label": "尼勒克县"
                    }
                ]
            },
            {
                "id": "654200",
                "label": "塔城地区",
                "children": [
                    {
                        "id": "654201",
                        "label": "塔城市"
                    },
                    {
                        "id": "654202",
                        "label": "乌苏市"
                    },
                    {
                        "id": "654221",
                        "label": "额敏县"
                    },
                    {
                        "id": "654223",
                        "label": "沙湾县"
                    },
                    {
                        "id": "654224",
                        "label": "托里县"
                    },
                    {
                        "id": "654225",
                        "label": "裕民县"
                    },
                    {
                        "id": "654226",
                        "label": "和布克赛尔蒙古自治县"
                    }
                ]
            },
            {
                "id": "654300",
                "label": "阿勒泰地区",
                "children": [
                    {
                        "id": "654301",
                        "label": "阿勒泰市"
                    },
                    {
                        "id": "654321",
                        "label": "布尔津县"
                    },
                    {
                        "id": "654322",
                        "label": "富蕴县"
                    },
                    {
                        "id": "654323",
                        "label": "福海县"
                    },
                    {
                        "id": "654324",
                        "label": "哈巴河县"
                    },
                    {
                        "id": "654325",
                        "label": "青河县"
                    },
                    {
                        "id": "654326",
                        "label": "吉木乃县"
                    }
                ]
            },
            {
                "id": "659000",
                "label": "自治区直辖县级行政区划",
                "children": [
                    {
                        "id": "659001",
                        "label": "石河子市"
                    },
                    {
                        "id": "659002",
                        "label": "阿拉尔市"
                    },
                    {
                        "id": "659003",
                        "label": "图木舒克市"
                    },
                    {
                        "id": "659004",
                        "label": "五家渠市"
                    }
                ]
            }
        ]
    },
    {
        "id": "710000",
        "label": "台湾省",
        "children": []
    },
    {
        "id": "810000",
        "label": "香港特别行政区",
        "children": []
    },
    {
        "id": "820000",
        "label": "澳门特别行政区",
        "children": []
    }
]